  baseEndpointUrl = 'https://mp.mygoddiva.com';
  var classResrtict = "";
  var allData = null;
  var urlParams = new URLSearchParams(window.location.search);
  var customerIdParam = urlParams.get('customer_id');
  var orderIDParam = urlParams.get('order_id');
  var typeParam = urlParams.get('type');
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  });

  // Global Variable
  restrictedCountries = [
        "US","CA","AT","BE","BG","CY","CZ","DE","DK","EE",
        "EL","ES","FI","FR","GR","HR","HU","IE","IT","LT",
        "LU","LV","MT","NL","PL","PT","RO","SE","SI","SK","AU","NZ"
  ];

  // Outlet items: international (non-UK, not in restrictedCountries) + Cyprus => Self Ship only
  function isOutletSelfShipOnly(countryCode) {
    const code = (countryCode || '').toUpperCase();
    if (!code) return false;
    if (code === 'CY') return true;
    if (code === 'GB' || code === 'UK') return false;
    return !restrictedCountries.includes(code);
  }

  let dataSet = [];
  let orderID = null,
  customerID = null;
  let selectOption = 'phone';
  $('#tableConfirmation').hide();
  $('.spinner-border').hide();
  function changeSearchBy(element) {
    if (element.value === 'phone_number') {
      document.getElementById('input-search-label').innerHTML = 'Mobile';
      document.getElementById('input-search').type = 'text';
    } else {
      document.getElementById('input-search-label').innerHTML = 'Email';
      document.getElementById('input-search').type = 'email';
    }
  }

  /**Get Marketplace list start**/
  const selectElement = document.getElementById('marketplaces');
  $('.search').prop('disabled', true);
  let marketplacesData = [];
  console.log('/v1/api/marketplaces');
  // fetch(baseEndpointUrl + '/v1/api/marketplaces')
  //   .then((response) => response.json())
  //   .then((data) => {
  //     marketplacesData = data;
  //     data.forEach((item) => {
  //       const option = document.createElement('option');
  //       option.value = item.id;
  //       option.text = item.name;
  //       selectElement.appendChild(option);
  //     });
  //     $('.search').prop('disabled', false);
  //   });

    fetch(baseEndpointUrl + '/v1/api/marketplaces')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Success case - hide maintenance, show returns section
      marketplacesData = data;
      data.forEach(item => {
        const option = document.createElement('option');
        option.value = item.id;
        option.text = item.name;
        option.setAttribute('data-manage-return-by', item.manage_return_by || '');
        option.setAttribute('data-customer-return-instructions', item.customer_return_instructions || '');
        selectElement.appendChild(option);
      });
      $('.search').prop('disabled', false);
      
      // Hide maintenance and show returns section
      $('.section-maintenance').hide();
      $('.section-return').show();
    })
    .catch(error => {
      // Error or timeout case - show maintenance, hide returns
      console.error('API Error:', error);
      $('.section-return').hide();
      $('.section-maintenance').show();
    });
     

  /**Get Marketplace list ends**/

  /*show hide email based on marketplace start*/
  const marketplaceSelect = $('#marketplaces');
  const emailDiv = $('.email_div');
  const phoneDiv = $('.phone_div');
  const postalcodeDiv = $('.postalcode_div');
  const searchType = $('#search_type');
  const searchForm = $('#searchForm'); // Search form with Options like email/phone/order id
  const messageContainer = $('#message-container');
  const emailInput = $('.email_div input');
  const phoneInput = $('.phone_div input');
  const postalcodeInput = $('.postalcode_div input');
  const orderInput = $('.orderId');

  marketplaceSelect.change(function () {
    searchType.trigger('change');
    // remove fetched data and hide the response container when marketplace changed
    $('#resultsBody').html('');
    $('#resultsBodyExchange').html('');
    $('#resultsBodyMadeMeasure').html('');
    $('#responseBody').hide();
    $('#responseCard').hide();
    /*emailInput.val('');
    phoneInput.val('');
    orderInput.val('');
    postalcodeInput.val('');*/
    $('.order-msg.invalid-msg, .phone-msg.invalid-msg,.postalcode-msg.invalid-msg').removeClass('invalid-msg');
    $('.order-msg, .phone-msg,.postalcode-msg').html('');
    $('.phone_div input.invalid-input, .orderId.invalid-input, .postalcode_div input.invalid-input').removeClass('invalid-input');

    const selectedValue = $(this).val();
    const selectedOption = $(this).find('option:selected');
    const manageReturnBy = selectedOption.data('manage-return-by');
    const returnInstructions = selectedOption.data('customer-return-instructions');

    if (selectedValue === '5') {
      jQuery('#debenhams-warning').fadeIn();
    } else {
      jQuery('#debenhams-warning').fadeOut();
    }

    if (selectedValue === '5' || selectedValue === '7' || selectedValue === '11') {
      // DEBENHAMS,Secret Sales, ASOS show mobile number
      /*phoneDiv.show();
      emailDiv.hide();
      postalcodeDiv.hide();
      searchType.val('phone');*/
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('phone').trigger('change');
    } else if (selectedValue === '24') {
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="postalcode"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('postalcode').trigger('change');
    }else if (selectedValue === '27') {
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="postalcode"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('postalcode').trigger('change');
    }else if (selectedValue === '28') {
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', false).removeClass('hideoption');
      searchType.find('option[value="postalcode"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('phone').trigger('change');
    }else{
      // show phone and email both but phone will be default
      /*phoneDiv.show();
      emailDiv.hide();
      postalcodeDiv.hide();
      searchType.val('phone');*/
      searchType.find('option[value="email"]').prop('disabled', false).removeClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('phone').trigger('change');
    }

    if (manageReturnBy === 'partner' && returnInstructions) {
      messageContainer.html(returnInstructions).show();
      searchForm.hide();
    }else{
      messageContainer.html('').hide();
      searchForm.show();
    }

  });
  /*show hide email based on marketplace ends*/

  // Phone Number Validation Start
  function handlePhoneNumberInput() {
    const inputSelector = '.phone_number';
    const msgSelector = '.phone-msg';
    const maxDigits = 4;
    const searchButton = '#search-btn';
    $(inputSelector).on('input', function () {
      var phoneNumber = $(this).val();
      if (phoneNumber.length > maxDigits) {
        $(inputSelector).addClass('invalid-input');
        $(msgSelector)
          .addClass('invalid-msg')
          .html('Please enter the last ' + maxDigits + ' digits of your phone number.');
        $(searchButton).prop('disabled', true);
      } else {
        $(inputSelector).removeClass('invalid-input');
        $(msgSelector).removeClass('invalid-msg').html('');
        $(searchButton).prop('disabled', false);
      }
    });
  }
  handlePhoneNumberInput();
  // Phone Number Validation Ends
  //Trim Spaces from Order ID Start
  function trimOrderIdSpace() {
    const inputField = document.querySelector('.orderId');
    if (inputField) {
      inputField.addEventListener('blur', function () {
        this.value = this.value.replace(/\s+/g, '').replace(/\./g, '');
      });
    }
  }
  trimOrderIdSpace();
  //Trim Spaces from Order ID ends

  function loadCustomerAccountParams() {
      if (!checkMarketPlaceData) return;

      // If customer came from their account with an email auto-filled
      if (customerAccountEmail) {
          $('#search_type').val('email').trigger('change');
          setTimeout(function () {
              $('input[name="email"]').val(customerAccountEmail);
          }, 50);
      }

      // If order ID is already available
      if (customerAccountOrderId) {
          $('input[name="order_id"]').val(customerAccountOrderId);
      }

      // Handle selection change for ALL three types
      $('#search_type').on('change', function () {
          const val = $(this).val();

          // Hide all first
          $('.email_div, .phone_div, .postalcode_div').hide();

          // Show the correct one
          if (val === 'email') {
              $('.email_div').show();
          } else if (val === 'phone') {
              $('.phone_div').show();
          } else if (val === 'postalcode') {
              $('.postalcode_div').show();
          }
      });

      // Auto-trigger search if email + order ID are present
      setTimeout(function () {
          if (customerAccountEmail && customerAccountOrderId) {
              $('#search-btn').trigger('click');
          }
      }, 100);
  }

  $('body').on('click', '.addtopreviouslabel', function () {
    let newLabelFeeBrands = $('.addtopreviousradio-wrapper').data('newlabelfeebrands');
    let addWithPreviousLabelBrands = $('.addtopreviousradio-wrapper').data('addwithpreviouslabelbrands');
    if ($(this).val() == 'yes') {
      if (newLabelFeeBrands == 0 && addWithPreviousLabelBrands > 0) {
        $('#total-returns').text($('#total-returns').data('fee'));
      }
    } else {
      if (newLabelFeeBrands == 0 && addWithPreviousLabelBrands > 0) {
        $('#total-returns').text('0.00');
      }
    }
  });

  $('body').on('click', '.paid-returns-accordion .accordion-header', function () {
    const $target = $(this).next('.accordion-body');
    const $icon = $(this).find('.accordion-arrow-icon'); // Get the icon in the clicked header

    // Collapse all other open panels and reset their arrows
    $('.paid-returns-accordion .accordion-body').not($target).removeClass('open');
    $('.paid-returns-accordion .accordion-arrow-icon')
      .not($icon)
      .removeClass('accordion-arrow-up')
      .addClass('accordion-arrow-down');

    // Toggle the clicked panel
    $target.toggleClass('open');

    // Update arrow classes
    if ($target.hasClass('open')) {
      $icon.removeClass('accordion-arrow-down').addClass('accordion-arrow-up'); // Show up arrow for opened panel
    } else {
      $icon.removeClass('accordion-arrow-up').addClass('accordion-arrow-down'); // Show down arrow for closed panel
    }
  });

  function responseCardLoad() {
    /**summary update ends**/
    function updateSummary() {
      var totalStoreCredit = 0;
      var totalRefund = 0;
      var totalReturns = 0.0;
      var totalSelfShip = 0;
      var returnFeeAdded = false; // Track whether the return fee has been added

      $('.cards').each(function () {
        var quantity = parseInt($(this).find('.quantity').val(), 10) || 0;
        var selectedOption = $(this).find('.refund-option input[type="radio"]:checked').val();
        var singleAmount = parseFloat($(this).data('item-store-credit-single-amount')) || 0;
        var refundAmount = parseFloat($(this).data('item-refund-single-amount')) || 0;
        var returnFeeElement = $(this).find('input[value="return_label"][type="radio"]:checked');
        var returnFee = returnFeeElement.length ? parseFloat(returnFeeElement.data('returnFee')) || 0.0 : 0.0;
        if (
          allData.partner_id == 5 ||
          allData.partner_id == 7 ||
          allData.partner_id == 11 ||
          allData.partner_id == 17 ||
          allData.partner_id == 27 ||
          allData.partner_id == 29
        ) {
          returnFee = 0;
        }

        if (selectedOption === 'store_credit') {
          totalStoreCredit += singleAmount * quantity;
        } else if (selectedOption === 'refund') {
          totalRefund += refundAmount * quantity;
        } else if (selectedOption === 'self_ship') {
          totalSelfShip += quantity;
        }

        // Only add the return fee once when return_label is selected
        if (selectedOption === 'return_label' && !returnFeeAdded && returnFee > 0) {
          totalReturns += returnFee; // Add return fee only once, regardless of quantity
          returnFeeAdded = true; // Mark the return fee as added
        }
      });

      $('#total-store-credit').text(totalStoreCredit.toFixed(2));
      $('#total-refund').text(totalRefund.toFixed(2));
      $('#total-returns').text(totalReturns === 0.0 ? '0.00' : totalReturns.toFixed(2));
      $('#total-returns').attr('data-fee', totalReturns === 0.0 ? '0.00' : totalReturns.toFixed(2));
      $('#total-self-ship').text(totalSelfShip);
    }

    $(document).on('change', '.refund-option input[type="radio"], .quantity', function () {
      var parent = $(this).closest('.cards');
      var checkBoxDiv = parent.find('.flex-row-reverse .checkbox');
      checkBoxDiv.prop('checked', true);
      selectCard(true, parent.data('lineItemId'), parent);
      updateSummary();
      toggleSummary();
      toggleSubmitBtn();
    });

    updateSummary();
    function toggleSubmitBtn() {
      if ($('.checkbox:checked').length > 0) {
        $('.btn-submit').show();
        $('.terms_conditions_checkbox_wrapper').show();
      } else {
        $('.btn-submit').hide();
        $('.terms_conditions_checkbox_wrapper').hide();
      }
    }
    function toggleSummary() {
      if ($('.refund-option input[type="radio"]:checked').length > 0) {
        $('.summary-wrapper').show();
      } else {
        $('.summary-wrapper').hide();
      }

      const options = {
        store_credit: '.summary-wrapper .store-credit',
        refund: '.summary-wrapper .refund',
        return_label: '.summary-wrapper .return-label',
        self_ship: '.summary-wrapper .self-ship',
      };

      const selectedRadio = $('.refund-option input[type="radio"]:checked');
      const selectedValue = selectedRadio.val();
      const outletChecked = $('.non-return-outlet-checkbox').is(':checked');

      for (let option in options) {
        if (selectedValue === 'return_label' && outletChecked) {
          const show = option === 'return_label';
          if (!allData.is_vip_customer) {
            $('#total-returns').text('1.99').attr('data-fee', '1.99');
          }
          $(options[option]).toggle(show);
        } else {
          const isChecked = selectedRadio.filter(`[value="${option}"]`).length > 0;
          $(options[option]).toggle(isChecked);
        }
      }

      $('.addtopreviouslabel-wrapper').hide();
      let addWithPreviousLabelBrands = [];
      let pendingFeeBrands = [];
      let newLabelFeeBrands = [];
      // brand id checked for vip option if return_label checked for lastReturnItems
      $('.refund-option input[type="radio"]:checked').each(function (index, element) {
        let selectedOption = $(element).val();

        if (selectedOption === 'return_label') {
          let card = $(element).closest('.cards');
          let brandId = card.data('brand-id');
          let matchedItem = lastReturnItems.find((item) => item.brand_id == brandId);

          if (matchedItem) {
            let lastRequestedTime = new Date(matchedItem.requested_date);
            let currentDateTime = new Date();
            let timeDifference = Math.abs(currentDateTime - lastRequestedTime); // Difference in milliseconds
            let hoursDifference = timeDifference / (1000 * 60 * 60); // Convert to hours
            if (hoursDifference < 48) {
              addWithPreviousLabelBrands.push(matchedItem);
            }
          }

          let matchedPendingItem = lastPendingFeesReturnItems.find((item) => item.brand_id == brandId);
          if (matchedPendingItem) {
            pendingFeeBrands.push(matchedPendingItem);
          }

          if (matchedItem == undefined && matchedPendingItem == undefined) {
            newLabelFeeBrands.push(matchedItem);
          }
        }
      });

      if (addWithPreviousLabelBrands.length > 0) {
        // Get unique brand names using Set
        const brandNames = [...new Set(addWithPreviousLabelBrands.map((item) => item.brand_name))];

        // Format the brand names
        const formattedNames =
          brandNames.length > 1
            ? brandNames.slice(0, -1).join(', ') + ' and ' + brandNames[brandNames.length - 1]
            : brandNames[0];

        $('.addtopreviouslabel-wrapper p.content').html(`You recently requested returns for items from ` +formattedNames +`. <br/>If you haven't shipped them yet, you can use the same label for any new returns. <br/> Have you sent the previous items?`);

        // Show the wrapper
        $('.addtopreviouslabel-wrapper').show();
      }

      $('.addtopreviousradio-wrapper').attr('data-newLabelFeeBrands', newLabelFeeBrands.length);
      $('.addtopreviousradio-wrapper').attr('data-addWithPreviousLabelBrands', addWithPreviousLabelBrands.length);
      $('.addtopreviousradio-wrapper').attr('data-pendingFeeBrands', pendingFeeBrands.length);
      if ($('.refund-option input[type="radio"]:checked').length > 0 &&
        newLabelFeeBrands.length == 0 &&
        addWithPreviousLabelBrands.length == 0 &&
        pendingFeeBrands.length > 0
      ) {
        $('#total-returns').text('0.00');
      }
    }

    toggleSubmitBtn();
    toggleSummary();

    /**summary update ends**/
    function toggleSelfShipBadge() {
      $('.refund-option input[type="radio"]').each(function () {
        const $card = $(this).closest('.cards');
        const $badge = $card.find('.self_ship_badge');
        if ($(this).is(':checked') && $(this).val() === 'self_ship') {
          $badge.show();
        } else {
          $badge.hide();
        }
      });

      $('.refund-option input[type="radio"]').on('change', function () {
        const $card = $(this).closest('.cards');
        const $badge = $card.find('.self_ship_badge');
        if ($(this).val() === 'self_ship') {
          $badge.show();
        } else {
          $badge.hide();
        }
      });
    }

    toggleSelfShipBadge();

    var SelectSize = '';
    $('.error').hide();
    $('.type-error').hide();
    $('.specific-reason').hide();
    $('.checkbox').change(function () {
      let parent = $(this).closest('.cards'); // Navigate directly to the '.cards' parent
      var lineItemId = $(this).data('lineItemId');
      selectCard(this.checked, lineItemId, parent);
      toggleSummary();
      toggleSubmitBtn();
      toggleSelfShipBadge();
      jQuery('#card-' + lineItemId + ' .refund-option-wrapper').hide();
    });

    function selectCard(checked, lineItemId, parent) {
      if (checked) {
        parent.addClass('selected-card');
        elementAction(true, lineItemId);
        parent.find('.refund-option input[type="radio"]').prop('disabled', false);
      } else {
        parent.removeClass('selected-card');
        elementAction(false, lineItemId);
        let specificReasonField = $(`.specific-reason[data-line-item-id="${lineItemId}"]`);
        specificReasonField.hide();
        specificReasonField.val('');
        parent.find('.refund-option input[type="radio"]').prop('checked', false);
        let refundDescription = $(`.option-description-${lineItemId}`);
        refundDescription.html('');
        let otherMessage = $(`.other-message[data-line-item-id="${lineItemId}"]`);
        otherMessage.hide();
        let restrictedcountries = $(`.restricted-countrieslist[data-line-item-id="${lineItemId}"]`);
        restrictedcountries.hide();
      }
    }

    $('.quantity').change(function () {
      let parent = $(this).closest('.cards');
      let checkBoxDiv = parent.find('.flex-row-reverse');
      checkBoxDiv.find('.checkbox').prop('checked', true);
      selectCard(true, $(this).data('lineItemId'), parent);

      let errorDiv = $(`.type-error[data-line-item-id="${$(this).data('lineItemId')}"]`);
      errorDiv.hide();

      let quantity = parseInt($(this).val());
      let maxQuantity = parseInt($(this).data('maxQty'));

      if (quantity === 0) {
        //  $(this).val('');
      } else if (quantity > maxQuantity) {
        errorDiv.show();
      }
      toggleSummary();
      toggleSubmitBtn();
    });

    function checkSelectedValues(selectElement) {
        var selectedValues = $(selectElement).val();
          var lineItemId = $(selectElement).attr('data-line-item-id');
        if (selectedValues && (selectedValues == 4 || selectedValues == 6)) {
            $('#shorten-my-dress').attr('data-line-item-id', lineItemId)
            $('#TooBigTooLongPopup').show();
        } else {
            $('#TooBigTooLongPopup').hide();
        }
    }

    $('.reason').change(function () {
      let self = $(this);
      let parent = $(this).closest('.cards');
      let checkBoxDiv = parent.find('.flex-row-reverse');
      let lineItemId = $(this).data('lineItemId');
      checkBoxDiv.find('.checkbox').prop('checked', true);
      selectCard(true, $(this).data('lineItemId'), parent);

      if ($(this).children('option:selected').text() === 'Other') {
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).show();
      } else {
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).hide();
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).val('');
      }

      let options = renderOptions(self);

      jQuery('#card-' + lineItemId + ' .refund-option').html(options);
      jQuery('#card-' + lineItemId + ' .refund-option-wrapper').show();
      jQuery('.option-description-' + lineItemId).html('');

      toggleSummary();
      toggleSubmitBtn();
    });

    $('.reason[data-brand="Goddiva"], .reason[data-brand="Goddiva Plus"], .reason[data-brand="City Goddess"], .reason[data-brand="Cosmochic"], .reason[data-brand="Danaya"], .reason[data-brand="Goddiva denim"], .reason[data-brand="Goddiva Accessories"]'
    ).change(function () {
      if (allData.partner_id == 1) {
        checkSelectedValues(this);
      }
    });

    function detectCircularExchange() {
              const graph = {};
              let hasCircular = false;

              $(".available_option").each(function () {
                  const oldSku = String($(this).data("size")).trim().toLowerCase();
                  const newSku = String($(this).val()).trim().toLowerCase();

                  if (newSku && newSku !== "-1" && oldSku !== newSku) {
                      graph[oldSku] = newSku;
                  }
              });

              const visited = new Set();
              const stack = new Set();

              function dfs(node) {
                  if (stack.has(node)) return true;
                  if (visited.has(node)) return false;

                  visited.add(node);
                  stack.add(node);

                  const next = graph[node];
                  if (next && dfs(next)) return true;

                  stack.delete(node);
                  return false;
              }

              Object.keys(graph).some(key => {
                  if (dfs(key)) {
                      hasCircular = true;
                      return true;
                  }
              });

              return hasCircular;
        }


      function toggleExchangeSubmitBtn() {
        const $submitBtn = $('.btn-submit[data-type="exchange"]');
        if (detectCircularExchange()) {
            $submitBtn.prop('disabled', true).addClass('disabled');
        } else {
            $submitBtn.prop('disabled', false).removeClass('disabled');
        }
      }

    $('.available_option').change(function () {
      var SelectSize = $(this).children('option:selected').text();
      var itemSize = $(this).data('size');

      let parent = $(this).closest('.cards');
      let checkBoxDiv = parent.find('.flex-row-reverse');
      checkBoxDiv.find('.checkbox').prop('checked', true);
      selectCard(true, $(this).data('lineItemId'), parent);

      $(`.is_same_size[data-line-item-id="${$(this).data('lineItemId')}"]`).val(SelectSize === itemSize);
      $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).hide();
      $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).val('');
      $(`.exchange-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).prop('disabled', false);
      $(`.exchange-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).val('');
      if (SelectSize === itemSize) {
        const lineItemId = $(this).data('lineItemId');
        const otherOptionValue = $(`.exchange-reason[data-line-item-id="${lineItemId}"] option`)
          .filter(function () {
            return $(this).text() == 'Other';
          })
          .val();
        $(`.exchange-reason[data-line-item-id="${lineItemId}"]`).val(otherOptionValue);
        setTimeout(() => {
          $(`.exchange-reason[data-line-item-id="${lineItemId}"]`).val(otherOptionValue).prop('disabled', true);
        }, 500);
        $(`.other-message[data-line-item-id="${$(this).data('lineItemId')}"]`)
          .html(
            `<p style="color:#ff0000">As you've selected the same size as the original item. Please let us know your reason for requesting an exchange using the text box below.</p>`
          )
          .show();
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).show();
      } else {
        const lineItemId = $(this).data('lineItemId');
        $(`.exchange-reason[data-line-item-id="${lineItemId}"]`).val('-1').prop('disabled', false);
        $(`.other-message[data-line-item-id="${$(this).data('lineItemId')}"]`).html('');
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).hide();
      }
      toggleSummary();
      toggleSubmitBtn();

      if (detectCircularExchange()) {
          toastr.warning("Select a different exchange option.");
          // Reset only the dropdown that caused it
          $(this).val("-1");
      }

      toggleExchangeSubmitBtn();

    });

    $('.exchange-reason').change(function () {
      let parent = $(this).closest('.cards');
      let checkBoxDiv = parent.find('.flex-row-reverse');
      checkBoxDiv.find('.checkbox').prop('checked', true);
      selectCard(true, $(this).data('lineItemId'), parent);

      if ($(this).children('option:selected').text() === 'Other') {
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).show();
      } else {
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).hide();
        $(`.specific-reason[data-line-item-id="${$(this).data('lineItemId')}"]`).val('');
      }
      toggleSummary();
      toggleSubmitBtn();
    });

    function initFaultyUploadValidation() {
          
         $('.faulty-upload').on('dragover', function(e) {
            e.preventDefault();
            e.stopPropagation();
          });
        
          $('.faulty-upload').on('drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
          });   
         
          const uploadedFilesMap = {};
  
          $('.faulty-upload').on('change', function (e) {
            const lineItemId = $(this).data('lineItemId');
            const $previewContainer = $(`.image-preview-container[data-line-item-id="${lineItemId}"]`);
            const $errorContainer = $(`.upload-errors[data-line-item-id="${lineItemId}"]`);
            const files = Array.from(this.files);
            //$previewContainer.empty();
            $errorContainer.html('');
          
            // Store files in global map
            if (!window.uploadedFilesMap) window.uploadedFilesMap = {};
            if (!uploadedFilesMap[lineItemId]) uploadedFilesMap[lineItemId] = [];
          
            const currentFiles = uploadedFilesMap[lineItemId];
            const totalFiles = currentFiles.length + files.length;
          
            if (totalFiles > 3) {
              $errorContainer.html('<p>You can upload a maximum of 3 images.</p>');
              uploadedFilesMap[lineItemId] = [];
              $(this).val('');
              $previewContainer.html(''); 
              return;
            }

            
            const allowedTypes = {
              'image/jpeg': true,
              'image/png': true,
              'image/jpg': true
            };
          
            let hasError = false;
            let validFiles = [];
          
            files.forEach((file, index) => {
              if (!allowedTypes[file.type]) {
                hasError = true;
                $errorContainer.append(`<p>File ${index + 1} ("${file.name}") is not a valid image. (Only JPG/PNG allowed).</p>`);
              } else if (file.size > 5 * 1024 * 1024) {
                hasError = true;
                $errorContainer.append(`<p>File ${index + 1} ("${file.name}") exceeds 5MB.</p>`);
              } else {
                const renameFile = new File([file], `${Date.now()}-${file.name}`, {
                type: file.type,
                lastModified: file.lastModified
                });
                validFiles.push(renameFile);
               // validFiles.push(file);
              }
            });
          
            if (hasError) {
              uploadedFilesMap[lineItemId] = [];
              $previewContainer.html(''); 
              $(this).val('');
              return;
            }
          
            // Append valid files to memory
            uploadedFilesMap[lineItemId] = [...currentFiles, ...validFiles];
          
            // Update input file list with DataTransfer
            const dataTransfer = new DataTransfer();
            uploadedFilesMap[lineItemId].forEach(file => dataTransfer.items.add(file));
            this.files = dataTransfer.files;
            
          
            // Render previews
            validFiles.forEach((file) => {
              const reader = new FileReader();
              reader.onload = function (e) {
                const imgSrc = e.target.result;
          
                const $previewWrapper = $('<div>', {
                  class: 'preview-wrapper',
                  css: { position: 'relative' }
                });
          
                // const $removeBtn = $('<span>', {
                //   class: 'remove-image',
                //   html: '&times;',
                //   'data-line-item-id': lineItemId,
                //   'data-file-name': file.name,
                //   title: 'Remove'
                // });
          
                const $link = $('<a>', {
                  href: imgSrc,
                  'data-fancybox': `lineitem-${lineItemId}`,
                  'data-caption': file.name
                });
          
                const $img = $('<img>', {
                  src: imgSrc,
                  class: 'preview-image'
                });
          
                $link.append($img);
               // $previewWrapper.append($removeBtn).append($link);
                 $previewWrapper.append($link);
                $previewContainer.append($previewWrapper);
              };
              reader.readAsDataURL(file);
            });
          
            // Fancybox init
            setTimeout(() => {
              $previewContainer.find('[data-fancybox]').fancybox({
                buttons: ["zoom", "slideShow", "fullScreen", "close"],
                loop: true
              });
            }, 300);
            
            if (totalFiles == 3) {
             $(this).prop('disabled', true);
            }
          });


         $(document).on('click', '.remove-image', function () {
            const lineItemId = $(this).data('lineitemid');
            const fileName = $(this).data('filename');
            const $previewWrapper = $(this).closest('.preview-wrapper');
            const $input = $(`.faulty-upload[data-line-item-id="${lineItemId}"]`);
          
            // Ensure global map exists
            if (!window.uploadedFilesMap) window.uploadedFilesMap = {};
            if (!uploadedFilesMap[lineItemId]) uploadedFilesMap[lineItemId] = [];
          
            // Remove from memory
            uploadedFilesMap[lineItemId] = uploadedFilesMap[lineItemId].filter(
              file => file.name !== fileName
            );
          
            // Remove preview UI
            $previewWrapper.remove();
          
            if (uploadedFilesMap[lineItemId].length === 0) {
              // Clear input completely
              const $newInput = $input.clone(); // Don't use `.clone(true)` here
              $newInput.val('');
              $input.replaceWith($newInput);
          
              // Optional: Rebind event handler
              //$newInput.on('change', handleFileUploadChange); // if you’re using a function
            } else {
              // Rebuild FileList only if files remain
              const dataTransfer = new DataTransfer();
              uploadedFilesMap[lineItemId].forEach(file => {
                dataTransfer.items.add(file);
              });
              $input[0].files = dataTransfer.files;
            }
          });

          $('.checkbox, .reason').on('change', function () {
            const $wrapper = $(this).closest('.cards');
            const lineItemId = $wrapper.attr('id').replace('card-', '');
            const $uploadInput = $wrapper.find(`.faulty-upload[data-line-item-id="${lineItemId}"]`);
            const $errorContainer = $wrapper.find(`.upload-errors[data-line-item-id="${lineItemId}"]`);
            const $uploadWrapper = $wrapper.find('.upload-wrapper');
            const $previewContainer = $(`.image-preview-container[data-line-item-id="${lineItemId}"]`);

            uploadedFilesMap[lineItemId] = [];
            
            if ($uploadInput.length) {
              $uploadInput.val('');
              $uploadInput.prop('disabled', false);
            }
            if ($errorContainer.length) {
              $errorContainer.html(''); 
            }
            if ($uploadWrapper.length) {
              $uploadWrapper.hide();
            }
            
            if ($previewContainer.length) {
              $previewContainer.html(''); 
            }
            
          });
         
          $('.reason').on('change', function() {
              const $wrapper = $(this).closest('.cards');
              const lineItemId = $wrapper.attr('id').replace('card-', '');
              $wrapper.data('is-reason-13', $(this).val() === '13');
              $wrapper.find('.upload-wrapper').hide();
          });
          
          $(document).on('change', '.refund-option input[type="radio"]', function() {
              const $wrapper = $(this).closest('.cards');
              const $uploadWrapper = $wrapper.find('.upload-wrapper');
              const lineItemId = $wrapper.attr('id').replace('card-', '');
              const $input = $wrapper.find(`.faulty-upload[data-line-item-id="${lineItemId}"]`);
              const $errorContainer = $wrapper.find(`.upload-errors[data-line-item-id="${lineItemId}"]`);
              const $previewContainer = $(`.image-preview-container[data-line-item-id="${lineItemId}"]`);
            
              if ($wrapper.data('is-reason-13') && $(this).val() === 'return_label') {
                  $uploadWrapper.show();
                  if ($input.length) {
                      $('html, body').animate({
                          scrollTop: $input.offset().top - 100 
                      }, 500);
                  }
              } else {
                  $uploadWrapper.hide();
                  $input.prop('disabled', false);
                  $input.val('');
                  uploadedFilesMap[lineItemId] = [];
                  $errorContainer.html('');
                  if ($previewContainer.length) {
                    $previewContainer.html(''); 
                  }
              }
          });
          
        }
       
        initFaultyUploadValidation();

    

    // Heart Shaped Foil Shopper Bag - Rose Gold start
    let handlingChange = false;

    $(document).on('change', '.return-checkbox, .reason', function () {
      // Prevent infinite recursion
      if (handlingChange) return;
      handlingChange = true;
      let otherChecked = $('.return-checkbox:not(.gift-bag-checkbox):checked').length > 0;

      $('.gift-bag-checkbox').each(function () {
        let id = $(this).data('line-item-id');
        let $reason = $(`#reason-${id}`);
        let $card = $(`#card-${id}`);

        if (otherChecked) {
          // Enable bag checkbox
          $(this).prop('disabled', false);
          $card.find('.gift-bag-msg').hide();
          // Hide all options except default + the 2 requested reasons
          $reason.find('option').each(function () {
            let val = $(this).val();
            if (val === '-1' || val === '9' || val === '10') {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
          // Show quantity, reason, and return options
          $card.find('.input-container-wrapper, .reason-wrapper').show();
        } else {
          // Disable if no other items checked
          $(this).prop('checked', false).change().prop('disabled', true);
          $card.find('.gift-bag-msg').show();
          // Show all options again
          $reason.find('option').show();
          // Hide quantity, reason, and return options + error
          $card.find(`.refund-option-wrapper, .input-container-wrapper, .reason-wrapper, .option-description-${id}, .error.active[data-line-item-id="${id}"]`).hide();
          $card.find('.refund-option input[type="radio"]:checked').prop('checked', false).change();
        }
      });
      // Reset the flag after a short delay to ensure all change events are processed
      setTimeout(() => {
        handlingChange = false;
      }, 10);
    });

    $(document).on('click', '.plus-btn, .minus-btn', function () {
      let otherChecked = $('.return-checkbox:not(.gift-bag-checkbox):checked').length > 0;
      $('.gift-bag-checkbox').each(function () {
        let id = $(this).data('line-item-id');
        let $reason = $(`#reason-${id}`);
        let $card = $(`#card-${id}`);

        if (otherChecked) {
          // Enable bag checkbox
          $(this).prop('disabled', false);
          $card.find('.gift-bag-msg').hide();
          // Hide all options except default + the 2 requested reasons
          $reason.find('option').each(function () {
            let val = $(this).val();
            if (val === '-1' || val === '9' || val === '10') {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
          // Show quantity, reason, and return options
          $card.find('.input-container-wrapper, .reason-wrapper').show();
        }
      });
    });
    // Heart Shaped Foil Shopper Bag - Rose Gold ends

    function initOutletItemSelection() {
      $('.outlet-item-option').on('change', function () {
        const nameAttr = $(this).attr('name');
        const itemId = nameAttr.split('outlet-item-option-')[1];

        const $checkbox = $(`.non-return-outlet-checkbox[data-line-item-id="${itemId}"]`);
        const $qtyInput = $(`.quantity[data-line-item-id="${itemId}"]`);
        const $reasonSelect = $(`.reason[data-line-item-id="${itemId}"]`);

        const $yesDiv = $(`.outlet-items-options-wrapper-${itemId}`);
        const $noDiv = $(`.outlet-item-no-message-${itemId}`);

        if ($(this).val() === 'yes') {
          $yesDiv.show();
          $checkbox.prop('checked', true).trigger('change');
          $noDiv.hide();
        } else if ($(this).val() === 'no') {
          $checkbox.prop('checked', false).trigger('change');
          $yesDiv.hide();
          $noDiv.show();
        }
      });
    }

    initOutletItemSelection();

    function handleOutletCheckboxChange() {
      $('.non-return-outlet-checkbox').on('change', function () {
        const itemId = $(this).data('line-item-id');
        const isChecked = $(this).is(':checked');
        const $yesRadio = $(`input[name="outlet-item-option-${itemId}"][value="yes"]`);
        const $noRadio = $(`input[name="outlet-item-option-${itemId}"][value="no"]`);
        const $yesDiv = $(`.outlet-items-options-wrapper-${itemId}`);
        const $noDiv = $(`.outlet-item-no-message-${itemId}`);

        if (isChecked) {
          $yesDiv.show();
          $noDiv.hide();
          $yesRadio.prop('checked', true);
        } else {
          $yesDiv.hide();
          $noDiv.hide();
          $yesRadio.prop('checked', false);
        }
      });

      // Handle radio button change separately
      $('.outlet-item-option').on('change', function () {
        const nameAttr = $(this).attr('name');
        const itemId = nameAttr.split('outlet-item-option-')[1];
        const $checkbox = $(`.non-return-outlet-checkbox[data-line-item-id="${itemId}"]`);
        const $yesDiv = $(`.outlet-items-options-wrapper-${itemId}`);
        const $noDiv = $(`.outlet-item-no-message-${itemId}`);
        if ($(this).val() === 'yes') {
          $checkbox.prop('checked', true);
          $yesDiv.show();
          $noDiv.hide();
        } else if ($(this).val() === 'no') {
          $checkbox.prop('checked', false);
          $yesDiv.hide();
          $noDiv.show();
        }
      });
    }

    handleOutletCheckboxChange();
  }

  function initializeQuantityControls() {
    const plusButtons = document.querySelectorAll('.plus-btn');
    const minusButtons = document.querySelectorAll('.minus-btn');
    const quantityInputs = document.querySelectorAll('.input-container input[type="number"]');

    plusButtons.forEach((button) => {
      const input = button.closest('.input-container').querySelector('input[type="number"]');
      let maxValue = parseInt(input.getAttribute('data-max-qty'));

      if (maxValue > 1) {
        button.addEventListener('click', function (event) {
          handlePlusMinusClick(event, input, 'plus');
        });
      } else {
        disableQuantityControl(button, input);
      }
    });

    minusButtons.forEach((button) => {
      const input = button.closest('.input-container').querySelector('input[type="number"]');
      let maxValue = parseInt(input.getAttribute('data-max-qty'));

      if (maxValue > 1) {
        button.addEventListener('click', function (event) {
          handlePlusMinusClick(event, input, 'minus');
        });
      } else {
        disableQuantityControl(button, input);
      }
    });

    quantityInputs.forEach((input) => {
      let maxValue = parseInt(input.getAttribute('data-max-qty'));

      if (maxValue > 1) {
        input.addEventListener('blur', validateInputRange);
      } else {
        input.disabled = true;
      }
    });

    function handlePlusMinusClick(event, input, action) {
      const lineItemId = input.getAttribute('data-line-item-id');
      const selectElement = document.querySelector(`#exchange-reason-${lineItemId}`);

      if (selectElement) {
        const selectedValue = selectElement.value;
        const selectedText = selectElement.options[selectElement.selectedIndex].text;
        // Check if "Other" is selected by value or text
        if (selectedValue === 'Other' || selectedText === 'Other') {
          return; // Do not modify the state of the select if "Other" is selected
        }
      }
      // Otherwise, proceed with increment/decrement logic
      if (action === 'plus') {
        incrementValue(input);
      } else {
        decrementValue(input);
      }
    }

    function incrementValue(input) {
      let currentValue = parseInt(input.value) || parseInt(input.getAttribute('min'));
      let maxValue = parseInt(input.getAttribute('data-max-qty'));
      if (currentValue < maxValue) {
        input.value = currentValue + 1;
        triggerChange(input);
      } else {
        input.value = maxValue;
      }
    }

    function decrementValue(input) {
      let currentValue = parseInt(input.value) || parseInt(input.getAttribute('min'));
      let minValue = parseInt(input.getAttribute('min'));
      if (currentValue > minValue) {
        input.value = currentValue - 1;
        triggerChange(input);
      } else {
        input.value = minValue;
      }
    }

    function validateInputRange(event) {
      const input = event.target;
      let currentValue = parseInt(input.value) || 0;
      let minValue = parseInt(input.getAttribute('min'));
      let maxValue = parseInt(input.getAttribute('data-max-qty'));
      if (currentValue < minValue) {
        input.value = minValue;
      } else if (currentValue > maxValue) {
        input.value = maxValue;
      }
      triggerChange(input);
    }

    function triggerChange(input) {
      const event = new Event('change', { bubbles: true });
      input.dispatchEvent(event);
    }

    function disableQuantityControl(button, input) {
      button.disabled = true;
      input.disabled = true;
    }
  }

  function responseCardLoadAlteration() {    
    $(document).on('change', '.length-input', function () {
        let raw = $(this).val();
        let val = parseFloat(raw);

        if (isNaN(val)) {
          $(this).val('');
          return;
        }

        let decimalWarning = false;
        let rangeWarning = false;

        // detect more than 2 decimals
        if (/^\d+\.\d{3,}$/.test(raw)) {
          decimalWarning = true;
        }

        if (val > 30) {
          val = 30;
          rangeWarning = true;
        }

        if (val < 1) {
          val = 1;
          rangeWarning = true;
        }

        // round to 2 decimals
        val = Math.round(val * 100) / 100;

        $(this).val(val.toFixed(2));

        // show messages separately
        if (decimalWarning) {
          toastr.warning('Only 2 decimal places allowed.');
        }

        if (rangeWarning) {
          toastr.warning('Value must be between 1 and 30.');
        }
      });


    $(document).on('input', '.alteration-note', function () {
      var maxLength = $(this).attr('maxlength');
      var currentLength = $(this).val().length;
      var remainingLength = maxLength - currentLength;
      var lineItemId = $(this).data('lineItemId');
      $('p.alterationremaining[data-line-item-id="' + lineItemId + '"]').text(
        remainingLength + ' characters remaining'
      );
      toggleSelectedCard(lineItemId, true);
      toggleSubmitBtnAlter();
    });

    $(document).on('input', '.quantity, .length-input, .alteration-note', function () {
      var lineItemId = $(this).data('lineItemId');
      $('.checkbox[data-line-item-id="' + lineItemId + '"]').prop('checked', true);
      toggleSubmitBtnAlter();
      toggleSelectedCard(lineItemId, true);
    });

    function checkClosestCheckbox(lineItemId) {
      $('.checkbox[data-line-item-id="' + lineItemId + '"]').prop('checked', true);
      toggleSelectedCard(lineItemId, true);
      toggleSubmitBtnAlter();
    }

    $(document).on('click', '.plus-btn, .minus-btn', function () {
      var lineItemId = $(this).siblings('.quantity').data('line-item-id');
      checkClosestCheckbox(lineItemId);
    });

    $(document).on('input', '.quantity', function () {
      var lineItemId = $(this).data('lineItemId');
      checkClosestCheckbox(lineItemId);
    });

    function toggleSelectedCard(lineItemId, isChecked) {
      var card = $('#card-' + lineItemId);
      if (isChecked) {
        card.addClass('selected-card');
      } else {
        card.removeClass('selected-card');
      }
    }
    $(document).on('change', '.checkbox', function () {
      var lineItemId = $(this).data('lineItemId');
      var isChecked = $(this).prop('checked');
      var quantityInput = $('.quantity[data-line-item-id="' + lineItemId + '"]');
      var lengthInput = $('.length-input[data-line-item-id="' + lineItemId + '"]');
      var noteTextarea = $('.alteration-note[data-line-item-id="' + lineItemId + '"]');
      var noteRemainingCharacter = $('.alterationremaining[data-line-item-id="' + lineItemId + '"]'); // Select the element properly
      var maxQty = quantityInput.data('max-qty');
      var card = $('#card-' + lineItemId);
      if (maxQty == 1) {
        quantityInput.prop('disabled', true);
      } else {
        quantityInput.prop('disabled', !isChecked);
      }

      if (!isChecked) {
        quantityInput.val('1');
        lengthInput.val('');
        noteTextarea.val('');
        card.removeClass('selected-card');
        noteRemainingCharacter.text('1000 characters remaining');
      }
      toggleSelectedCard(lineItemId, isChecked);
      toggleSubmitBtnAlter();
    });

    function toggleSubmitBtnAlter() {
      if ($('.alteration-checkbox:checked').length > 0) {
        $('.btn-submit-alteration').show();
      } else {
        $('.btn-submit-alteration').hide();
      }
    }
    toggleSubmitBtnAlter();
  }

  // filter order data
  function initItemFilter() {
    // Get all filter options and filter rows
    const filterOptions = document.querySelectorAll('.items-filter-options li');
    const filterRows = document.querySelectorAll('.filter-row');

    function updateBadgeCounts() {
      const totalRows = filterRows.length;

      const returnFeePendingCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('return-fee-pending')
      ).length;
      const returnEligibleCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('return-eligible')
      ).length;
      const returnFeePaidCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('return-fee-paid')
      ).length;
      const returnNotEligibleCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('return-not-eligible')
      ).length;
      const selfShipReturnRequestedCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('self-ship-return-requested')
      ).length;
      const storeCreditIssuedCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('store-credit-issued')
      ).length;
      const refundIssuedCount = Array.from(filterRows).filter((row) => row.classList.contains('refund-issued')).length;
      const outletItemNonReturnableCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('outlet-item-non-returnable')
      ).length;
      const nonReturnableCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('non-returnable')
      ).length;
      const eligibleForExchangeCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('eligible-for-exchange')
      ).length;
      const alreadyRequestedForExchangeCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('already-requested-for-exchange')
      ).length;
      const alreadyRequestedForReturnCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('already-requested-for-return')
      ).length;

      const eligibleForAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('eligible-for-alteration')
      ).length;
      const alreadyRequestedForAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('already-requested-for-alteration')
      ).length;

      const completedAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('alteration-Completed')
      ).length;
      const pendingAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('alteration-Pending')
      ).length;
      const receivedAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('alteration-Received')
      ).length;
      const declinedAlterationCount = Array.from(filterRows).filter((row) =>
        row.classList.contains('alteration-Declined')
      ).length;

      // Update badge counts in the dropdown
      filterOptions.forEach((option) => {
        const value = option.getAttribute('data-value');
        let count = 0;

        switch (value) {
          case 'all':
            count = totalRows;
            break;
          case 'return-fee-pending':
            count = returnFeePendingCount;
            break;
          case 'return-eligible':
            count = returnEligibleCount;
            break;
          case 'return-fee-paid':
            count = returnFeePaidCount;
            break;
          case 'return-not-eligible':
            count = returnNotEligibleCount;
            break;
          case 'self-ship-return-requested':
            count = selfShipReturnRequestedCount;
            break;
          case 'store-credit-issued':
            count = storeCreditIssuedCount;
            break;
          case 'refund-issued':
            count = refundIssuedCount;
            break;
          case 'outlet-item-non-returnable':
            count = outletItemNonReturnableCount;
            break;
          case 'non-returnable':
            count = nonReturnableCount;
            break;
          case 'eligible-for-exchange':
            count = eligibleForExchangeCount;
            break;
          case 'already-requested-for-exchange':
            count = alreadyRequestedForExchangeCount;
            break;
          case 'already-requested-for-return':
            count = alreadyRequestedForReturnCount;
            break;
          case 'eligible-for-alteration':
            count = eligibleForAlterationCount;
            break;
          case 'already-requested-for-alteration':
            count = alreadyRequestedForAlterationCount;
            break;
          case 'alteration-Completed':
            count = completedAlterationCount;
            break;
          case 'alteration-Pending':
            count = pendingAlterationCount;
            break;
          case 'alteration-Received':
            count = receivedAlterationCount;
            break;
          case 'alteration-Declined':
            count = declinedAlterationCount;
            break;
        }

        // Update badge text
        option.querySelector('.filter-badge').textContent = count;

        // Hide options if count is 0
        if (count === 0) {
          option.classList.add('hidden-filter-option');
        } else {
          option.classList.remove('hidden-filter-option');
        }
      });
    }

    filterOptions.forEach(function (filterOption) {
      filterOption.addEventListener('click', function () {
        let filterValue = this.getAttribute('data-value');

        filterOptions.forEach(function (item) {
          item.classList.remove('active');
        });
        this.classList.add('active');

        filterRows.forEach(function (item) {
          const separator = item.closest('.separator');
          if (filterValue === 'all') {
            item.style.display = 'block'; // Show all items
            if (separator) {
              separator.style.display = ''; // Show separator if it exists
            }
          } else if (item.classList.contains(filterValue)) {
            item.style.display = 'block'; // Show item if it matches the filter
            if (separator) {
              separator.style.display = ''; // Show separator if it exists
            }
          } else {
            item.style.display = 'none'; // Hide the item
          }

          // Check the visibility of the items within the same separator
          if (separator) {
            const allHidden = [...separator.querySelectorAll('.filter-row')].every((el) => el.style.display === 'none');
            if (allHidden) {
              separator.style.display = 'none'; // Hide separator if all items are hidden
            } else {
              separator.style.display = ''; // Show separator if at least one item is visible
            }
          }
        });

        updateBadgeCounts();
        if ($('.filter-row input[type="checkbox"]:checked').length > 0) {
          $('.filter-row input[type="checkbox"]:checked').prop('checked', false);
        }

        if ($('.filter-row input[type="radio"]:checked').length > 0) {
          $('.filter-row input[type="radio"]:checked').prop('checked', false);
        }

        if ($('.filter-row select.reason').length > 0) {
          $('.filter-row select.reason').val('-1');
        }

        if ($('.filter-row select.exchange-reason').length > 0) {
          $('.filter-row select.exchange-reason').val('-1');
          $('.filter-row select.exchange-reason').prop('disabled', false);
        }
        if ($('.other-message').length > 0) {
          $('.other-message').hide();
        }
        $('.restricted-countrieslist').hide();   
        if ($('.addtopreviouslabel-wrapper').length > 0) {
          $('.addtopreviouslabel-wrapper').hide();
        }
        if ($('.terms_conditions_checkbox_wrapper').length > 0) {
          $('.terms_conditions_checkbox_wrapper').hide();
        }
        if ($('.filter-row select.available_option').length > 0) {
          $('.filter-row select.available_option').val('-1');
        }

        if ($('.filter-row input.quantity[type="number"]').length > 0) {
          $('.filter-row input.quantity[type="number"]').val('1');
        }

        if ($('.filter-row input.length-input[type="number"]').length > 0) {
          $('.filter-row input.length-input[type="number"]').val('');
        }

        if ($('.filter-row .alteration-note').length > 0) {
          $('.filter-row .alteration-note').val('');
        }
        if ($('.filter-row .alterationremaining').length > 0) {
          $('.filter-row .alterationremaining').text('1000 character remaining');
        }

        if ($('.filter-row .specific-reason').length > 0) {
          $('.filter-row .specific-reason').val('').hide();
        }

        if ($('.refund-option-wrapper').length > 0) {
          $('.refund-option-wrapper').hide();
        }

        if ($('p[class^="option-description-"]').length > 0) {
          $('p[class^="option-description-"]').html('');
        }

        if ($('.checkbox:checked').length > 0) {
          $('.btn-submit, .btn-submit-alteration').show();
        } else {
          $('.btn-submit, .btn-submit-alteration').hide();
          $('.cards.selected-card').removeClass('selected-card');
        }

        if ($('.refund-option input[type="radio"]:checked').length > 0) {
          $('.summary-wrapper').show();
        } else {
          $('.summary-wrapper').hide();
        }

        const options = {
          store_credit: '.summary-wrapper .store-credit',
          refund: '.summary-wrapper .refund',
          return_label: '.summary-wrapper .return-label',
          self_ship: '.summary-wrapper .self-ship',
        };

        for (let option in options) {
          $(options[option]).toggle(
            $('.refund-option input[type="radio"]:checked').filter(`[value="${option}"]`).length > 0
          );
        }
         let uploadedFilesMap = {};
          if ($('.upload-wrapper').length > 0) {
              for (const key in uploadedFilesMap) {
                if (uploadedFilesMap.hasOwnProperty(key)) {
                  uploadedFilesMap[key] = [];
                }
              }
              $('.upload-wrapper').hide();
              $('.upload-errors').html('');
              $('.image-preview-container').html('');
              $('.faulty-upload').val('').prop('disabled', false);
          }

        if ($('.outlet-return-confirmation').length) {
          $('.outlet-item-option[type="radio"]:checked').prop('checked', false);
          $('.outlet-items-options-wrapper').hide();
          $('.outlet-item-no-message').hide();
        }
      });
    });

    updateBadgeCounts();
  }

  function finalSummaryItemsAccordion() {
    $('.final-summary-accordion .accordion-header').on('click', function () {
      const $target = $(this).next('.accordion-body');
      const $icon = $(this).find('.accordion-arrow-icon'); // Get the icon in the clicked header

      // Collapse all other open panels and reset their arrows
      $('.final-summary-accordion .accordion-body').not($target).removeClass('open');
      $('.final-summary-accordion .accordion-arrow-icon')
        .not($icon)
        .removeClass('accordion-arrow-up')
        .addClass('accordion-arrow-down');

      // Toggle the clicked panel
      $target.toggleClass('open');

      // Update arrow classes
      if ($target.hasClass('open')) {
        $icon.removeClass('accordion-arrow-down').addClass('accordion-arrow-up'); // Show up arrow for opened panel
      } else {
        $icon.removeClass('accordion-arrow-up').addClass('accordion-arrow-down'); // Show down arrow for closed panel
      }
    });
  }

  /*cuntry,marketplace brand start*/
  $('#country, #marketplaces, input[name="brand"]').on('change', function () {
    $selectedMarketplace = $('#marketplaces').val();
  });
  /*cuntry,marketplace brand end*/

  // Set the value of the input with id 'tabData' to 'alteration' based on URL parameter
  if (window.location.href.indexOf('?alteration') !== -1) {
    const $tabData = $('#tabData');
    if ($tabData.length) {
      $tabData.val('alteration');
    }
  }

  $('.nav-link').click(function () {
    var activeTab = $(this).data('type');
    $('#tabData').val(activeTab);
    fetchSearchData();
  });

  $('.rea-btn').click(function () {
    var activeTab = $(this).data('type');
    $('#tabData').val(activeTab);
    $('html, body').animate(
      {
        scrollTop: $('#tabData').offset().top,
      },
      1000
    );
    let lineItemId = null;
    var attr = $(this).attr('data-line-item-id');

    if (activeTab == 'alteration' && typeof attr !== 'undefined' && attr !== false) {
      lineItemId = attr;
    }
    fetchSearchData(lineItemId);
  });

  $('#search-btn').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $email = $('.email').val();
    var $phone = $('.phone_number').val();
    var $postalcode = $('.postalcode').val();
    var $orderId = $('.orderId').val();
    var $tabData = $('#tabData').val();
    var $selectedMarketplace = $('#marketplaces').val();

    $('.email-msg').removeClass('invalid-msg');
    $('.phone-msg').removeClass('invalid-msg');
    $('.postalcode-msg').removeClass('invalid-msg');
    $('#responseCard').hide();

    if (selectOption == 'phone') {
      if ($phone == '') {
        $('.phone-msg').addClass('invalid-msg').text('Phone is required');
        $('.phone_number').addClass('invalid-input');
      } else {
        if ($phone.match(/^[0-9]{4,11}$/) == null) {
          $('.phone-msg').addClass('invalid-msg').text('Invalid Phone Number');
          $('.phone_number').addClass('invalid-input');
        } else {
          $('.phone_number').removeClass('invalid-input');
          $('.phone-msg').removeClass('invalid-msg').text('');
        }
      }
    } else if(selectOption == 'email'){
      if ($email == '') {
        $('.email-msg').addClass('invalid-msg').text('Email is required');
        $('.email').addClass('invalid-input');
      } else {
        var mailformat = /\S+@\S+\.\S+/;
        if ($email.match(mailformat) == null) {
          $('.email-msg').addClass('invalid-msg').text('Invalid Email');
          $('.email').addClass('invalid-input');
        } else {
          $('.email').removeClass('invalid-input');
          $('.email-msg').removeClass('invalid-msg').text('');
        }
      }
    } else{
          if ($postalcode == '') {
              $('.postalcode-msg').addClass('invalid-msg').text("Postal code is required");
              $('.postalcode').addClass('invalid-input');
          }else{
            // Postal code must be 3–10 chars, letters, numbers, spaces, hyphens
              var postalFormat = /^[A-Za-z0-9\s-]{3,10}$/;

              if($postalcode.match(postalFormat) == null){
                  $('.postalcode-msg')
                      .addClass('invalid-msg')
                      .text("Invalid Postal Code (3-10 letters, numbers, spaces, or hyphens)");
                  $('.postalcode').addClass('invalid-input');
              }else{
                  $('.postalcode').removeClass('invalid-input');
                  $('.postalcode-msg').removeClass('invalid-msg').text("");
              }
          }
      }

    if ($orderId == '') {
      $('.order-msg').addClass('invalid-msg').text('Order Id is required');
      $('.orderId').addClass('invalid-input');
    } else {
      $('.orderId').removeClass('invalid-input');
      $('.order-msg').removeClass('invalid-msg').text('');
    }

    if (($phone.length > 0 || $email.length > 0 || $postalcode.length > 0) && $orderId.length > 0) {
      fetchSearchData();
    }
  });

  function fetchSearchData(lineItemIdScrollTo = null) {
    var $email = $('.email').val();
    var $phone = $('.phone_number').val();
    var $postalcode = $('.postalcode').val();
    var $orderId = $('.orderId').val();
    var $tabData = $('#tabData').val();
    var $selectedMarketplace = $('#marketplaces').val();

    // variable assigned to preserve the input data, so we can use when error occured in data.error condition start
    var originalFormState = {
      marketplace: $selectedMarketplace,
      email: $email,
      phone: $phone,
      postalcode:$postalcode,
      orderId: $orderId,
      searchType: selectOption
    };
    // variable assigned to preserve the input data, so we can use when error occured end

    $('.email-msg').removeClass('invalid-msg');
    $('.phone-msg').removeClass('invalid-msg');
    $('.postalcode-msg').removeClass('invalid-msg');
    $('#responseCard').hide();

    if (selectOption == 'phone') {
      if ($phone == '') {
        $('.phone-msg').addClass('invalid-msg').text('Phone is required');
        $('.phone_number').addClass('invalid-input');
      } else {
        if ($phone.match(/^[0-9]{4,11}$/) == null) {
          $('.phone-msg').addClass('invalid-msg').text('Invalid Phone Number');
          $('.phone_number').addClass('invalid-input');
        } else {
          $('.phone_number').removeClass('invalid-input');
          $('.phone-msg').removeClass('invalid-msg').text('');
        }
      }
    } else if(selectOption == 'email'){
      if ($email == '') {
        $('.email-msg').addClass('invalid-msg').text('Email is required');
        $('.email').addClass('invalid-input');
      } else {
        var mailformat = /\S+@\S+\.\S+/;
        if ($email.match(mailformat) == null) {
          $('.email-msg').addClass('invalid-msg').text('Invalid Email');
          $('.email').addClass('invalid-input');
        } else {
          $('.email').removeClass('invalid-input');
          $('.email-msg').removeClass('invalid-msg').text('');
        }
      }
    } else {
          if ($postalcode == '') {
              $('.postalcode-msg').addClass('invalid-msg').text("Postal code is required");
              $('.postalcode').addClass('invalid-input');
          }else{
            // Postal code must be 3–10 chars, letters, numbers, spaces, hyphens
              var postalFormat = /^[A-Za-z0-9\s-]{3,10}$/;

              if($postalcode.match(postalFormat) == null){
                  $('.postalcode-msg')
                      .addClass('invalid-msg')
                      .text("Invalid Postal Code (3-10 letters, numbers, spaces, or hyphens)");
                  $('.postalcode').addClass('invalid-input');
              }else{
                  $('.postalcode').removeClass('invalid-input');
                  $('.postalcode-msg').removeClass('invalid-msg').text("");
              }
          }
      }

    if ($orderId == '') {
      $('.order-msg').addClass('invalid-msg').text('Order Id is required');
      $('.orderId').addClass('invalid-input');
    } else {
      $('.orderId').removeClass('invalid-input');
      $('.order-msg').removeClass('invalid-msg').text('');
    }

    if (($phone.length > 0 || $email.length > 0 || $postalcode.length > 0) && $orderId.length > 0) {
      $('#resultsBody').html('');
      $('#resultsBodyExchange').html('');
      $('#resultsBodyMadeMeasure').html('');
      $('#responseBody').hide();
      $('.spinner-border').show();
      $('.search').prop('disabled', true);

      $('.loader').show();
      $('body').addClass('return-loader-active');
      var form = $(this);
      var actionUrl = form.attr('action');
      lastReturnItems = [];
      lastPendingFeesReturnItems = [];
      let searchType = '';
      let searchValue = '';
      // determine search type based on selected option
      if (selectOption == 'phone') {
          searchType = 'phone_number';
          searchValue = $phone;
      } else if (selectOption == 'email') {
          searchType = 'email';
          searchValue = $email;
      } else {
          // postal code search
          searchType = 'postal_code';
          searchValue = $postalcode;
      }

      $.ajax({
        type: 'POST',
        url: baseEndpointUrl + '/v1/api/return/order-items',
        data: {
          marketplace_id: $selectedMarketplace,
          order_id: $orderId,
          search_type: searchType,
          search_value: searchValue,
          type: $tabData,
        },
        success: function (data) {
          allData = data;
          $('.loader').hide();
          $('body').removeClass('return-loader-active');
          $('.search').prop('disabled', false);
          $('.spinner-border').hide();
          const returnTabNav = $('.return-tab-nav');
          const exchangeTabNav = $('.exchange-tab-nav');
          const madeMeasureTabNav = $('.made-measure-tab-nav');

          const hasGoddivaItem =
            data.not_requested?.some((seller) => seller.items?.some((item) => item.is_goddiva)) ||
            data.outlet?.some((seller) => seller.items?.some((item) => item.is_goddiva)) ||
            false;
          console.log('hasGoddivaItem', hasGoddivaItem);
          console.log('another', data.requested && data.requested.alteration && data.requested.alteration.length > 0);

          madeMeasureTabNav.hide();

          if (data.is_goddiva) {
            // Show all tab nav
            returnTabNav.show();
            exchangeTabNav.show();
            if (
              hasGoddivaItem ||
              (data.requested && data.requested.alteration && data.requested.alteration.length > 0)
            ) {
              console.log('Check 1');
              madeMeasureTabNav.show();
            }
          } else if (data.is_other_brand) {
            // Show return and exchange tab, but not alteration tab
            returnTabNav.show();
            exchangeTabNav.show();
            madeMeasureTabNav.hide();
          } else {
            //show all tabs
            returnTabNav.show();
            exchangeTabNav.show();
            if (
              hasGoddivaItem ||
              (data.requested && data.requested.alteration && data.requested.alteration.length > 0)
            ) {
              console.log('Check 2');
              madeMeasureTabNav.show();
            }
          }
          /*If selected marketplace not equal to partner_id(marketplace) from response show message start*/
          const matchedMarketplaceObj = marketplacesData.find((marketplace) => marketplace.id == data.partner_id);
          const matchedMarketplaceName = matchedMarketplaceObj ? matchedMarketplaceObj.name : '';
          // Check if selected value is not equal to partner_id
          if (Number($selectedMarketplace) !== Number(data.partner_id)) {
            $('#marketplaces').val(Number(data.partner_id)).trigger('change');

            $('#search_type').val(selectOption);
            if (selectOption === 'phone') {
                $('.phone_number').val($phone);
            }
            else if (selectOption === 'email') {
                $('.email').val($email);
            }
            else if (selectOption === 'postalcode') {
                $('.postalcode').val($postalcode);
            }

            $('.orderId').val($orderId);
            if (Number(data.partner_id) == 1) {
              $('.marketplaces-message').html(
                `We have located your order, but it appears that it was placed with our site, "${matchedMarketplaceName}".`
              );
            } else {
              $('.marketplaces-message').html(
                `We have located your order, but it appears that it was placed with marketplace, "${matchedMarketplaceName}".`
              );

              let restrictedPartners = [3, 4, 9, 10, 12, 13, 14, 15];
              if (restrictedPartners.indexOf(Number(data.partner_id)) !== -1) {
                $('#responseCard').css('display', 'none');
                return;
              }
            }
          } else {
            // Clear the message if the IDs match
            $('.marketplaces-message').html('');
          }
          if (Number(data.partner_id) != 1) {
            $('#made-measure-tab, #profile-tab').hide();
          } else {
            if (
              hasGoddivaItem ||
              (data.requested && data.requested.alteration && data.requested.alteration.length > 0)
            ) {
              $('#made-measure-tab, #profile-tab').show();
            }
          }
          /*If selected marketplace not equal to partner_id(marketplace) from response show message ends*/
          if (data.error) {
            $('#marketplaces').val(originalFormState.marketplace);
            $('#search_type').val(originalFormState.searchType);
            $('.email').val(originalFormState.email);
            $('.phone_number').val(originalFormState.phone);
            $('.postalcode').val(originalFormState.postalcode);
            $('.orderId').val(originalFormState.orderId);

            // Div references
            const emailDiv = $(".email_div");
            const phoneDiv = $(".phone_div");
            const postalDiv = $(".postalcode_div");

            // Hide all first
            emailDiv.hide();
            phoneDiv.hide();
            postalDiv.hide();

            // Show correct input based on saved search type
            if (originalFormState.searchType === "email") {
                emailDiv.show();
            } 
            else if (originalFormState.searchType === "phone") {
                phoneDiv.show();
            }
            else if (originalFormState.searchType === "postalcode") {
                postalDiv.show();
            }

            toastr.warning(data.message);
            $('.search').prop('disabled', false);
            $('.marketplaces-message').html('');
          } else {
            /*data fetch start*/
            if ($tabData == 'return') {
              if (
                data.requested &&
                data.requested.return &&
                data.requested.return.return_label &&
                data.requested.return.return_label.pending_label &&
                data.requested.return.return_label.pending_label.length > 0
              ) {
                const pendingLabels = data?.requested?.return?.return_label?.pending_label ?? [];

                const hasMatchingRecord = pendingLabels.some(
                  (label) =>
                    Number(label?.return_request_status_id) === 5 &&
                    Number(label?.is_return_fee) === 1 &&
                    label?.return_request_financial_status == null && // null OR undefined
                    (label?.items ?? []).some((group) =>
                      (group?.items ?? []).some((item) => Number(item?.return_request_item_status_id) === 4)
                    )
                );
                console.log('hasMatchingRecord', hasMatchingRecord);
                if (!hasMatchingRecord) {
                  showReturnFeePopup();
                }
              }

              $('#resultsBody').show();
              var html = '';

              html += `<ul class="items-filter-options">
                          <li data-value="all" class="active">All <span class="filter-badge">0</span></li>
                          <li data-value="return-fee-pending">Return Fee Pending <span class="filter-badge">0</span></li>
                          <li data-value="return-eligible">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="return-fee-paid">Download Label<span class="filter-badge">0</span></li>
                          <li data-value="return-not-eligible">Return Not Eligible <span class="filter-badge">0</span></li>
                          <li data-value="self-ship-return-requested">Self-Ship Return Requested <span class="filter-badge">0</span></li>
                          <li data-value="store-credit-issued">Store Credit Issued <span class="filter-badge">0</span></li>
                          <li data-value="refund-issued">Refund Issued <span class="filter-badge">0</span></li>
                          <li data-value="eligible-for-exchange">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-exchange">Already requested for Exchange <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-return">Already requested for Return <span class="filter-badge">0</span></li>
                          <li data-value="eligible-for-alteration">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-alteration">Already requested for Alteration <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Completed">Alteration Completed <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Pending">Alteration Pending <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Received">Alteration Received <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Declined">Alteration Declined <span class="filter-badge">0</span></li>
                          <li data-value="outlet-item-non-returnable">Outlet Item<span class="filter-badge">0</span></li>
                          <li data-value="non-returnable">Non-Returnable <span class="filter-badge">0</span></li>
                      </ul>`;

              // Loop through return items for which return fees is pending
              if (
                data.requested &&
                data.requested.return &&
                data.requested.return.return_label &&
                data.requested.return.return_label.pending_label &&
                data.requested.return.return_label.pending_label.length > 0
              ) {
                html += processPendingLabelItems(data);
              }
              // Loop through not requested items
              if (data.not_requested && data.not_requested.length > 0) {
                html += notRequestedItems(data, 'return');

                // Step 1: Sort the array by requested_date in descending order
                lastPendingFeesReturnItems.sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date));

                // Step 2: Use a Map to keep only the latest record for each brand_id
                const latestRecords = new Map();
                lastPendingFeesReturnItems.forEach((item) => {
                  if (!latestRecords.has(item.brand_id)) {
                    latestRecords.set(item.brand_id, item);
                  }
                });

                // Step 3: Convert the Map back to an array
                const result = Array.from(latestRecords.values());
                lastPendingFeesReturnItems = result;
              }

              // Loop through the return items where return label has been generated
              if (
                data.requested &&
                data.requested.return &&
                data.requested.return.return_label &&
                data.requested.return.return_label.complete_label &&
                data.requested.return.return_label.complete_label.length > 0
              ) {
                html += processCompleteLabelItems(data);

                // Step 1: Sort the array by requested_date in descending order
                lastReturnItems.sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date));

                // Step 2: Use a Map to keep only the latest record for each brand_id
                const latestRecords = new Map();
                lastReturnItems.forEach((item) => {
                  if (!latestRecords.has(item.brand_id)) {
                    latestRecords.set(item.brand_id, item);
                  }
                });

                // Step 3: Convert the Map back to an array
                const result = Array.from(latestRecords.values());
                lastReturnItems = result;
              }

              // Loop through other return requested items
              if (
                data.requested &&
                data.requested.return &&
                (data.requested.return.self_ship || data.requested.return.refund || data.requested.return.store_credit)
              ) {
                if (data.requested.return.self_ship) {
                  html += processedReturnItems(data, 'self_ship', 'Self Ship');
                }
                if (data.requested.return.store_credit) {
                  html += processedReturnItems(data, 'store_credit', 'Store Credit');
                }
                if (data.requested.return.refund) {
                  html += processedReturnItems(data, 'refund', 'Refund');
                }
              }

              // Loop through the already exchanged or alteration items
              if (data.requested && data.requested.exchange) {
                html += alreadyRequested(
                  data.requested.exchange.flatMap((request) => request.items.flatMap((itemGroup) => itemGroup.items)),
                  'Exchange'
                );
              }
              if (data.requested && data.requested.alteration) {
                html += alreadyRequested(
                  data.requested.alteration.flatMap((request) => request.items.flatMap((itemGroup) => itemGroup.items)),
                  'Alteration'
                );
              }

              //Loop through outlet items
              if (data.outlet && data.outlet.length > 0) {
                html += getOutletItemHtml(data, $tabData);
              }

              //Loop through Non Returnable items
              if (data.nonReturnableItems && data.nonReturnableItems.length > 0) {
                html += getNonReturnableItemHtml(data, $tabData);
              }

              html += '<div class="mt-2 d-flex justify-content-end">';
              html += '<div class="summary-wrapper">';
              html += '<h3 class="title">Summary</h3>';

              html += '<div class="table-container">';
              html += '    <table>';
              html += '        <tbody>';
              html += '            <tr class="store-credit">';
              html += '                <td class="summary-label">Total Store Credit:</td>';
              html += '                <td>£<span id="total-store-credit">20.00</span></td>';
              html += '            </tr>';
              html += '            <tr class="refund">';
              html += '                <td class="summary-label">Total Refund:</td>';
              html += '                <td>£<span id="total-refund">15.00</span></td>';
              html += '            </tr>';
              html += '            <tr class="return-label">';
              html += '                <td class="summary-label">Total Return Fee:</td>';
              html += '                <td>£<span id="total-returns">0.00</span></td>';
              html += '            </tr>';
              html += '            <tr class="self-ship">';
              html += '                <td class="summary-label">Total Self Ship Qty:</td>';
              html += '                <td><span id="total-self-ship">1</span></td>';
              html += '            </tr>';
              html += '        </tbody>';
              html += '    </table>';
              html += '</div>';
              html += '</div>';
              html += '</div>';

              html += '<div class="mt-2 d-flex justify-content-end submit-btn-wrapper">';
              html += `<div class="addtopreviouslabel-wrapper">
                          <p class="content"></p>
                          <div class="addtopreviousradio-wrapper">
                               <label>
                                  <input class="addtopreviouslabel" type="radio" name="addtopreviouslabel" value="yes" required> Yes
                              </label>
                              <label>
                                  <input class="addtopreviouslabel" type="radio" name="addtopreviouslabel" value="no"> No
                              </label>
                          </div>
                          <p class="addtopreviousradio-wrapper-error text-danger d-none">Please choose Yes or No</p>
                          </div>`;
              html += `<p class="terms_conditions_checkbox_wrapper d-none">
                            <i class="material-icons" style="display: inline-block;vertical-align: text-bottom;">
                              <input class="form-check-input" style="font-size: 1.5rem;display: block" 
                              type="checkbox" id="terms_conditions_checkbox" name="terms_conditions_checkbox" value="true" aria-label="...">
                            </i>
                            <label for="terms_conditions_checkbox">By selecting the checkbox, you agree to the <a href="https://goddiva.co.uk/pages/terms-conditions">terms and conditions.</a></label></p>`;
              html += '<p class="text-danger mt-1 error d-none terms_conditions_checkbox_error" style="font-size: 15px !important;">Please accept terms and conditions.</p>';
              html += '<button type="button" data-discount_value="' +
                data.discount_value +
                '" data-customer="' +
                data.customer +
                '" data-order="' +
                data.order +
                '" data-type="return" class="btn primary-color btn-submit">PROCEED</button>';
              html += '</div>';

              $('#resultsBody').html(html);
              jQuery('.tab-content .tab-pane').removeClass('active').removeClass('show');
              jQuery('#responseCard .nav-link').removeClass('active');
              jQuery('#home-tab').addClass('active');
              jQuery('#home-tab-pane').addClass('active').addClass('show');
              $('#responseCard').show();

              function updateDescription(itemId) {
                let optionDescription = {
                  store_credit:
                    '<p>Keep the item and receive a gift card worth £store_credit_amount</p><p>Note: To receive a full refund, please select either the return label option or choose to ship the item yourself.</p>',
                  refund:
                    '<p>Keep the item and get a refund of £refund_amount to your original payment method.</p><p>Note: To receive a full refund, please select either the return label option or choose to ship the item yourself.</p>',
                  return_label:
                    '<p>You will be charged a small fee for all the items you are selecting for return. Once the return charges are paid, you can download a return label to send the item back.</p>',
                  self_ship: '<p>Receive a return note and ship the item back at your own expense.</p>',
                };
                if (
                  data.is_vip_customer ||
                  data.partner_id == 5 ||
                  data.partner_id == 7 ||
                  data.partner_id == 11 ||
                  data.partner_id == 17 ||
                  data.partner_id == 27 ||
                  data.partner_id == 29
                ) {
                  optionDescription['return_label'] = 'You can download a return label to send the item back.';
                }
                let selectedOption = $('input[name="return_option_' + itemId + '"]:checked').val();
                let outletChecked = $(`.non-return-outlet-checkbox[data-line-item-id="${itemId}"]`).is(':checked');

                let message = optionDescription[selectedOption];

                if (selectedOption === 'return_label' && outletChecked) {
                  message = ``;
                }

                if (data.return_fee == 0) {
                  message = ``;
                }

                if (selectedOption == 'store_credit') {
                  let totalStoreCreditValue = $('#total-store-credit__' + itemId).text();
                  if (message) {
                    message = message.replace('store_credit_amount', totalStoreCreditValue);
                  }
                } else if (selectedOption == 'refund') {
                  let totalRefundValue = $('#total-refund__' + itemId).text();
                  if (message) {
                    message = message.replace('refund_amount', totalRefundValue);
                  }
                }

                $('.option-description-' + itemId).html(message);
              }

              function updateAmounts(inputElement) {
                var card = inputElement.closest('.cards');
                var lineItemId = inputElement.data('line-item-id');
                var quantitymain = parseInt(jQuery('#return_quantity_' + lineItemId).val(), 10) || 1;
                var storeCreditSingleAmount = parseFloat(card.data('item-store-credit-single-amount')) || 0;
                var refundSingleAmount = parseFloat(card.data('item-refund-single-amount')) || 0;

                var totalStoreCreditMain = (quantitymain * storeCreditSingleAmount).toFixed(2);
                var totalRefundMain = (quantitymain * refundSingleAmount).toFixed(2);

                $('#total-store-credit__' + lineItemId).text(totalStoreCreditMain);
                $('#total-refund__' + lineItemId).text(totalRefundMain);
                //updateDescription(lineItemId); // Call updateDescription() here
              }

              $('.returnitems').each(function () {
                var firstQuantityInput = $(this).find('.quantity').first();
                updateAmounts(firstQuantityInput);
              });

              $(document).on('change', '.refund-option input[type="radio"]', function () {
                let name = jQuery(this).attr('name');
                let lineItemId = name.replace('return_option_', '');
                updateDescription(lineItemId);
              });

              // Attach event listener for changes
              $('.returnitems').on('change', '.quantity, .reason', function () {
                var inputElement = $(this);
                var lineItemId = inputElement.data('line-item-id');
                updateAmounts(inputElement);
                updateDescription(lineItemId); // Call updateDescription() here
              });

              if ($('.form-check-input.return-checkbox').length <= 0) {
                $('.summary-wrapper').hide();
                $('.btn-submit').hide();
              }

              //return fee 0.00 if marcketplace 5 (DEBENHAMS) start
              if (data.partner_id == 5 || data.partner_id == 7 || data.partner_id == 11 || data.partner_id == 17 || data.partner_id == 27 || data.partner_id == 29) {
                let radioButtons = document.querySelectorAll('input[type="radio"]');
                radioButtons.forEach(function (radio) {
                  if (radio.value === 'return_label') {
                    radio.setAttribute('data-return-fee', '0.00');
                  }
                });
              }
              //return fee 0.00 if marcketplace 5 (DEBENHAMS) ends

              initializeQuantityControls();
              responseCardLoad();
              initItemFilter();
              finalSummaryItemsAccordion();
              // return items ends
            } else if ($tabData == 'exchange') {
              $('#resultsBodyExchange').show();
              var html = '';

              html += `<ul class="items-filter-options">
                          <li data-value="all" class="active">All <span class="filter-badge">0</span></li>
                        
                          <li data-value="return-fee-pending">Return Fee Pending <span class="filter-badge">0</span></li>
                          <li data-value="return-eligible">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="return-fee-paid">Download Label<span class="filter-badge">0</span></li>
                          <li data-value="return-not-eligible">Return Not Eligible <span class="filter-badge">0</span></li>
                          <li data-value="self-ship-return-requested">Self-Ship Return Requested <span class="filter-badge">0</span></li>
                          <li data-value="store-credit-issued">Store Credit Issued <span class="filter-badge">0</span></li>
                          <li data-value="refund-issued">Refund Issued <span class="filter-badge">0</span></li>
                          
                          
                          <li data-value="eligible-for-exchange">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-exchange">Already requested for Exchange <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-return">Already requested for Return <span class="filter-badge">0</span></li>
                          
                          <li data-value="eligible-for-alteration">Not Requested <span class="filter-badge">0</span></li>
                          <li data-value="already-requested-for-alteration">Already requested for Alteration <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Completed">Alteration Completed <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Pending">Alteration Pending <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Received">Alteration Received <span class="filter-badge">0</span></li>
                          <li data-value="alteration-Declined">Alteration Declined <span class="filter-badge">0</span></li>

                          <li data-value="outlet-item-non-returnable">Outlet Item<span class="filter-badge">0</span></li>
                          <li data-value="non-returnable">Non-Returnable <span class="filter-badge">0</span></li>
                      </ul>`;
              // Loop through the items which are eligible for exchange
              if (data.not_requested) {
                html += pendingExchangeItems(data);
              }
              // Loop through the items which are already exchanged
              if (data.requested && data.requested.exchange) {
                html += processAlreadyExchangeItems(data);
              }

              // Loop through the already exchanged or alteration items
              if (
                data.requested &&
                data.requested.return &&
                data.requested.return.return_label &&
                data.requested.return.return_label.complete_label
              ) {
                html += alreadyRequested(
                  data.requested.return.return_label.complete_label.flatMap((request) =>
                    request.items.flatMap((itemGroup) => itemGroup.items)
                  ),
                  'Return'
                );
              }
              if (
                data.requested &&
                data.requested.return &&
                data.requested.return.return_label &&
                data.requested.return.return_label.pending_label
              ) {
                html += alreadyRequested(
                  data.requested.return.return_label.pending_label.flatMap((request) =>
                    request.items.flatMap((itemGroup) => itemGroup.items)
                  ),
                  'Return'
                );
              }
              if (data.requested && data.requested.alteration) {
                html += alreadyRequested(
                  data.requested.alteration.flatMap((request) => request.items.flatMap((itemGroup) => itemGroup.items)),
                  'Alteration'
                );
              }

              //Loop through outlet items
              if (data.outlet && data.outlet.length > 0) {
                html += getOutletItemHtml(data, $tabData);
              }

              //Loop through Non Returnable items
              if (data.nonReturnableItems && data.nonReturnableItems.length > 0) {
                html += getNonReturnableItemHtml(data, $tabData);
              }

              html += '<div class="mt-2 d-flex justify-content-end">';
              html +=
                '<button type="button" data-discount_value="' +
                data.discount_value +
                '" data-customer="' +
                data.customer +
                '" data-order="' +
                data.order +
                '" data-type="exchange" class="btn primary-color btn-submit">Exchange Items</button>';
              html += '</div>';
              $('#resultsBodyExchange').html(html);
              jQuery('.tab-content .tab-pane').removeClass('active').removeClass('show');
              jQuery('#responseCard .nav-link').removeClass('active');
              jQuery('#profile-tab').addClass('active');
              jQuery('#pills-profile').addClass('active').addClass('show');
              if ($('.form-check-input.exchange-checkbox').length <= 0) {
                $('.btn-submit').hide();
              }

              $('#responseCard').show();
              initializeQuantityControls();
              responseCardLoad();
              initItemFilter();

              //exchange ends
            } else {
              // This is Alteration block
              if (
                hasGoddivaItem ||
                (data.requested && data.requested.alteration && data.requested.alteration.length > 0)
              ) {
                $('#resultsBodyMadeMeasure').show();

                var html = '';

                html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="row made-measure-content-wrapper">
                                <p style="font-size:15px;line-height:25px;text-align:left;margin:0">Once you’ve received your stunning new outfit, try it on with the heels you plan to wear. Measure from the bottom hem upwards and let us know exactly how much length you would like taken off.<br/>

                                    For example: <i>“Please remove 5cm from the hem.”</i><br/>

                                    Please provide your measurement in centimetres or inches.<br/>

                                    Simply send your gown back to us, and we’ll adjust the hem to ensure the perfect fit. Within 7–14 days, your gown will be beautifully tailored, ready to wear, and ready to turn heads at your event! <br/>

                                    <a style="color: #ff8080;margin: 0;padding: 0;" href="/pages/made-to-measure" target="_blank">Visit here for more info</a>

                                    <br/><br/><b style="color: red;">Note: During alterations, there is a possibility that some detailing on the hem, such as scalloped edges or beading, may be affected or lost.</b>
                                </p>
                            </div>
                        </div>`;

                html += `<ul class="items-filter-options">
                            <li data-value="all" class="active">All <span class="filter-badge">0</span></li>
                          
                            <li data-value="return-fee-pending">Return Fee Pending <span class="filter-badge">0</span></li>
                            <li data-value="return-eligible">Not Requested <span class="filter-badge">0</span></li>
                            <li data-value="return-fee-paid">Download Label<span class="filter-badge">0</span></li>
                            <li data-value="return-not-eligible">Return Not Eligible <span class="filter-badge">0</span></li>
                            <li data-value="self-ship-return-requested">Self-Ship Return Requested <span class="filter-badge">0</span></li>
                            <li data-value="store-credit-issued">Store Credit Issued <span class="filter-badge">0</span></li>
                            <li data-value="refund-issued">Refund Issued <span class="filter-badge">0</span></li>
                            
                            
                            <li data-value="eligible-for-exchange">Not Requested <span class="filter-badge">0</span></li>
                            <li data-value="already-requested-for-exchange">Already requested for Exchange <span class="filter-badge">0</span></li>
                            <li data-value="already-requested-for-return">Already requested for Return <span class="filter-badge">0</span></li>
                            
                            <li data-value="eligible-for-alteration">Not Requested <span class="filter-badge">0</span></li>
                            <li data-value="already-requested-for-alteration">Already requested for Alteration <span class="filter-badge">0</span></li>
                            <li data-value="alteration-Completed">Alteration Completed <span class="filter-badge">0</span></li>
                            <li data-value="alteration-Pending">Alteration Pending <span class="filter-badge">0</span></li>
                            <li data-value="alteration-Received">Alteration Received <span class="filter-badge">0</span></li>
                            <li data-value="alteration-Declined">Alteration Declined <span class="filter-badge">0</span></li>

                            <li data-value="outlet-item-non-returnable">Outlet Item<span class="filter-badge">0</span></li>
                            <li data-value="non-returnable">Non-Returnable <span class="filter-badge">0</span></li>
                        </ul>`;
                // Loop through not_requested items
                if (data.not_requested) {
                  html += pendingAlterationItems(data);
                }

                if (data.outlet) {
                  html += pendingOutletAlterationItems(data);
                }

                // Loop through requested items
                if (data.requested && data.requested.alteration && data.requested.alteration.length > 0) {
                  html += processAlreadyAlterationItems(data);
                }

                html += '<div class="mt-2 d-flex justify-content-end">';
                html +=
                  '<button type="button" data-discount_value="' +
                  data.discount_value +
                  '" data-customer="' +
                  data.customer +
                  '" data-order="' +
                  data.order +
                  '" data-type="alteration" class="btn primary-color btn-submit-alteration">Submit for Alteration</button>';
                html += '</div>';

                $('#resultsBodyMadeMeasure').html(html);
                jQuery('.tab-content .tab-pane').removeClass('active').removeClass('show');
                jQuery('#responseCard .nav-link').removeClass('active');
                jQuery('#made-measure-tab').addClass('active');
                jQuery('#made-measure-content').addClass('active').addClass('show');
                if ($('.form-check-input.alteration-checkbox').length <= 0) {
                  $('.btn-submit-alteration').hide();
                }

                $('#responseCard').show();
                initializeQuantityControls();
                responseCardLoadAlteration();
                initItemFilter();
              }
              // alteration ends
            }
            /*data fetch end*/
            if (lineItemIdScrollTo != null) {
              $('html, body').animate(
                {
                  scrollTop: $('#card-' + lineItemIdScrollTo).offset().top,
                },
                1000
              );
            }
          }
          $('.search').prop('disabled', false);
        },
      });
    }
  }

  function elementAction(state, id) {
    $('.reason').each(function (e) {
      if ($(this).data('lineItemId') === id)
        if (state) {
          $(this).prop('disabled', false);
        } else {
          $(this).prop('disabled', false);
          $(this).val('-1');
        }
    });

    $('.available_option').each(function (e) {
      if ($(this).data('lineItemId') === id)
        if (state) {
          $(this).prop('disabled', false);
        } else {
          $(this).prop('disabled', false);
          $(this).val('-1');
        }
    });

    $('.exchange-reason').each(function (e) {
      if ($(this).data('lineItemId') === id)
        if (state) {
          $(this).prop('disabled', false);
        } else {
          $(this).prop('disabled', false);
          $(this).val('-1');
        }
    });

    $('.quantity').each(function () {
      const maxQty = $(this).data('max-qty');
      const lineItemId = $(this).data('lineItemId');

      if (lineItemId === id) {
        if (maxQty == 1) {
          // Always disable if maxQty is 1
          $(this).prop('disabled', true);
          $(this).val('1'); // Ensure the value is 1 if disabled
        } else {
          // Enable or disable based on the checkbox state if maxQty is greater than 1
          if (state) {
            $(this).prop('disabled', false); // Enable if checkbox is checked
          } else {
            $(this).prop('disabled', true); // Disable if checkbox is unchecked
            $(this).val('1'); // Optionally reset to 1 when disabled
          }
        }
      }
    });
  }

  $(document).ready(function () {
    jQuery('body').on('click', '.open-payment-popup', function () {
      showReturnFeePopup();
    });

    jQuery('body').on('click', '.close-button', function () {
      var attr = $(this).attr('data-reload-search');
      if (typeof attr !== 'undefined' && attr !== false) {
        const responseCardElement = document.getElementById('responseCard');
        const offsetPosition = responseCardElement.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
        $('#search-btn').click();
      }
      if (allIntervals && allIntervals.length > 0) {
        allIntervals.forEach(function (inverval) {
          clearInterval(inverval);
        });
        allIntervals = [];
      }
      jQuery('#PaymentPopup .close-button').removeAttr('data-reload-search');
      jQuery(this).parents('.popup-container').hide();
    });

    jQuery('body').on('click', '.pay-now-button', function () {
      let self = $(this);
      let url = $(this).attr('href');
      setTimeout(function () {
        self
          .addClass('disabled')
          .removeAttr('href')
          .removeAttr('target')
          .html('<span class="btn-loader"></span> Waiting for payment');
      }, 1000);
      checkForPayment(self, url);
    });

    $(document).on('click', '.btn-submit', function () {
      var orderID = $(this).data('order');
      var customerID = $(this).data('customer');
      var btnType = $(this).data('type');

      $('.error').hide().removeClass('active');
      $('#responseBody').hide();
      $('#mainError').fadeOut(500);

      let dataArray = [],
        errorFound = 0;

      // Loop only through checked items
      $('.checkbox:checked').each(function () {
        let id = $(this).data('lineItemId');
        let card = $(this).closest('.cards');
        let required = 0;
        let reasonClass = '.reason';
        if (btnType == 'exchange') {
          reasonClass = '.exchange-reason';
        }

        // Collect values for this card
        let reason = card.find(reasonClass).val();
        let reasonText = card.find(reasonClass + ' option:selected').text();

        let specificReason = card.find('.specific-reason').val();
        let quantity = card.find('.quantity').val();

        let available = null,
          variant = null;
        if (btnType !== 'return') {
          available = card.find('.available_option').val();
          variant = card.find('.available_option option:selected').data('variant-id');
        }

        // Validation
        let selectedOption = null;
        if (btnType == 'return') {
          selectedOption = card.find('.refund-option input[type="radio"]:checked').val();
          if (!selectedOption) required++;
        }

        if (!reason) required++;

        if (reason === 'Other') {
          if (!specificReason || specificReason.trim() === '') {
            required++;
          }
        }

        if (!quantity) required++;

        if (btnType !== 'return') {
          if (!available) required++;
        }

        let images = null;

        if (btnType === 'return') {
          const fileInput = card.find('.faulty-upload')[0];
          let fileObjects = [];

          if (fileInput && fileInput.files && fileInput.files.length > 0) {
            for (let i = 0; i < fileInput.files.length; i++) {
              fileObjects.push(fileInput.files[i]);
            }
          }

          images = fileObjects;
        }

        // Build array or show error
        if (required === 0) {
          dataArray.push({
            id: id,
            sku: card.find(reasonClass).data('sku'),
            product: card.find(reasonClass).data('product'),
            reasonText: reasonText,
            reason: reason,
            specificReason: specificReason,
            quantity: quantity,
            to_exchange: available,
            variant: variant,
            return_option: btnType === 'return' ? selectedOption : undefined,
            images: images
          });
        } else {
          errorFound++;
          $('.error').each(function () {
            if ($(this).data('lineItemId') === id) {
              $(this).addClass('active').show();
            }
          });
        }
      });

      // --- Now proceed with confirmation logic ---
      if (errorFound === 0) {
        if (btnType == 'return') {
          $('.addtopreviousradio-wrapper-error').hide();
          if (
            $('.addtopreviouslabel-wrapper').css('display') != 'none' &&
            $('input[name=addtopreviouslabel]:checked').length == 0
          ) {
            $('.addtopreviousradio-wrapper-error').show();
            return false;
          }

          $('.terms_conditions_checkbox_error').hide();
          if (!$('#terms_conditions_checkbox').prop('checked')) {
            $('.terms_conditions_checkbox_error').show();
            return false;
          }
        }

        $('#table > tbody').html('');
        let comfirm = null;
        let tableRows = '';

        if (dataArray.length > 0) {
          dataSet = dataArray;
          dataArray.forEach(function (value) {
            tableRows += `<tr><td>${value.product}</td><td>${value.reasonText}</td><td>${value.quantity}</td></tr>`;
          });
          $('#table > tbody').html(tableRows);

          if (btnType == 'return') {
            if (!comfirm) {
              comfirm = $.confirm({
                title: 'Return Items',
                closeIcon: true,
                offsetTop: 20,
                content: 'Are you sure?',
                buttons: {
                  confirm: {
                    text: 'Yes',
                    btnClass: 'btn-dark',
                    action: function () {
                      submitData(btnType, orderID, customerID);
                    },
                  },
                  somethingElse: {
                    text: 'No',
                    btnClass: 'btn-dark no',
                  },
                },
              });
            }
            comfirm.open();
          } else {
            comfirm = $.confirm({
              title: 'Exchange Items',
              closeIcon: true,
              content: 'Please confirm before proceeding request',
              offsetTop: 20,
              buttons: {
                confirm: {
                  text: 'Exchange',
                  btnClass: 'btn-dark',
                  action: function () {
                    submitData(btnType, orderID, customerID);
                  },
                },
                cancel: function () {},
              },
            });
          }
        } else {
          toastr.warning('Please select an item to proceed');
        }
      } else {
        $('html, body').animate(
          {
            scrollTop: $('.tab-content .error.active:first').parents('.cards').offset().top - 200,
          },
          2000
        );
        toastr.warning('Failed to proceed, please fill all required fields');
      }
    });

    function submitData(type, orderID, customerID) {
      $('.btn-submit').prop('disabled', true);
      $('.btn-submit').append('<span class="loaderbtn"> </span>');

      let addWithPreviousLabel = false;

      if (
        $('.addtopreviouslabel-wrapper').css('display') != 'none' &&
        $('input[name=addtopreviouslabel]:checked').length > 0 &&
        $('input[name=addtopreviouslabel]:checked').val() == 'no'
      ) {
        addWithPreviousLabel = true;
      }

      let returnItems = null;

      if (type == 'return') {
        returnItems = dataSet.filter((item) =>
          ['return_label', 'self_ship', 'refund', 'store_credit'].includes(item.return_option)
        );
      }

      // ✅ Build FormData
      const formData = new FormData();

      formData.append('order', orderID);
      formData.append('customer', customerID);
      formData.append('type', type);
      formData.append('add_with_previous_label', addWithPreviousLabel);
      formData.append(
        'terms_conditions_checkbox',
        $('#terms_conditions_checkbox').prop('checked')
      );

      // ✅ Append items
      dataSet.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][sku]`, item.sku);
        formData.append(`items[${index}][product]`, item.product);
        formData.append(`items[${index}][reasonText]`, item.reasonText);
        formData.append(`items[${index}][reason]`, item.reason);
        formData.append(`items[${index}][specificReason]`, item.specificReason || '');
        formData.append(`items[${index}][quantity]`, item.quantity || '');

        // ✅ Exchange fields
        if (type !== 'return') {
          formData.append(`items[${index}][to_exchange]`, item.to_exchange || '');
          formData.append(`items[${index}][variant]`, item.variant || '');
        }

        // ✅ Return fields
        if (type === 'return') {
          formData.append(`items[${index}][return_option]`, item.return_option || '');

          // optional images
          if (item.images && item.images.length > 0) {
            item.images.forEach((file, fileIndex) => {
              formData.append(`items[${index}][images][${fileIndex}]`, file);
            });
          }
        }
      });

      $.ajax({
        type: 'POST',
        url: baseEndpointUrl + '/v1/api/return/request-add',
        data: formData,
        processData: false,
        contentType: false,

        success: function (response) {
          $('.btn-submit').find('.loaderbtn').remove();
          $('.btn-submit').prop('disabled', false);

          if (response.errors) {
            toastr.warning(response.errors);
            return;
          }

          if (response.invoice_url) {
            showPaymentPopup(response, returnItems, allData);
          } else {
            $.alert({
              type: 'success',
              title: 'Success',
              content: response.message,
            });

            const responseCardElement = document.getElementById('responseCard');
            const offsetPosition =
              responseCardElement.getBoundingClientRect().top +
              window.scrollY -
              100;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });

            $('#search-btn').click();
          }
        },

        error: function () {
          $('.btn-submit').find('.loaderbtn').remove();
          $('.btn-submit').prop('disabled', false);

          toastr.warning('An unexpected error occurred. Please try again.');
        },
      });
    }


    //alteration data submit
    $(document).on('click', '.btn-submit-alteration', function () {
      var orderID = $(this).data('order');
      var customerID = $(this).data('customer');
      var btnType = $(this).data('type');
      $('.error').hide().removeClass('active');
      $('#responseBody').hide();
      $('#mainError').fadeOut(500);

      let dataArray = [],
        errorFound = 0,
        required = 0;

      // Loop through each card for alteration
      $('.alteration-checkbox').each(function (index, element) {
        // Get line item ID from the checkbox
        var lineItemId = $(this).data('lineItemId');
        var isChecked = $(this).prop('checked');

        // Only process if checkbox is checked
        if (isChecked) {
          // Retrieve values from the corresponding inputs within the same card
          var length = $(this).closest('.cards').find('.length-input').val();
          var quantity = $(this).closest('.cards').find('.quantity').val();
          var note = $(this).closest('.cards').find('.alteration-note').val();
          note = note === '' ? null : note; // Set note to null if empty

          // Basic validation to check if length and quantity are present
          if (length === '' || quantity === '') {
            required++;
            $(this).closest('.cards').find('.error').show(); // Show error if any field is missing
          }

          if (required === 0) {
            dataArray.push({
              id: lineItemId,
              length: length,
              quantity: quantity,
              note: note,
            });
          } else {
            errorFound++;
            $('.error').each(function () {
              if ($(this).data('lineItemId') === lineItemId) $(this).addClass('active').show();
            });
          }
        }
      });

      // If no errors, proceed with the confirmation and submission
      if (errorFound === 0 && dataArray.length > 0) {
        $.confirm({
          title: 'Alteration Items',
          closeIcon: true,
          content: 'Please confirm before proceeding alteration request',
          offsetTop: 20,
          buttons: {
            confirm: {
              text: 'CONTINUE',
              btnClass: 'btn-dark',
              action: function () {
                submitDataAlteration(btnType, orderID, customerID, dataArray);
              },
            },
            cancel: function () {},
          },
        });
      } else if ($('.alteration-checkbox:checked').length === 0 && dataArray.length === 0) {
        toastr.warning('Please select an item to proceed');
      } else {
        $('html, body').animate(
          {
            scrollTop: $('.tab-content .error.active:first').parents('.cards').offset().top - 200,
          },
          2000
        );
        toastr.warning('Failed to proceed, please fill all required fields');
      }
    });

    // Function to submit data to the alteration API
    function submitDataAlteration(type, orderID, customerID, dataArray) {
      $('.btn-submit-alteration').prop('disabled', true);
      $('.btn-submit-alteration').append('<span class="loaderbtn"> </span>');
      const data = {
        order: orderID,
        customer: customerID,
        type: type,
        items: dataArray,
      };

      $.ajax({
        type: 'POST',
        url: baseEndpointUrl + '/v1/api/web/made-to-measure',
        data: JSON.stringify(data),
        contentType: 'application/json',
        success: function (response) {
          $('.btn-submit-alteration').find('.loaderbtn').remove();
          $('.btn-submit-alteration').prop('disabled', false);
          if (response.error) {
            toastr.warning(response.message);
          } else {
            $.alert({
              type: 'success',
              title: 'Success',
              content: response.message,
            });
            const responseCardElement = document.getElementById('responseCard');
            const offsetPosition = responseCardElement.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
            $('#search-btn').click();
          }
        },
        error: function (xhr) {
          $('.btn-submit-alteration').find('.loaderbtn').remove();
          $('.btn-submit-alteration').prop('disabled', false);
          console.log(xhr,'xhr');
          if (
            xhr.responseJSON &&
            xhr.responseJSON.errors &&
            typeof xhr.responseJSON.errors === 'object'
          ) {
            Object.values(xhr.responseJSON.errors).forEach(function (messages) {
              messages.forEach(function (msg) {
                toastr.warning(msg);
              });
            });
          } else {
            toastr.warning('Something went wrong. Please try again.');
          }

        },
      });
    }
  });

  function removeConfirmTableItem(index) {
    dataSet.splice(index, 1);
  }

  function back() {
    $('#resultsBody').fadeIn(500);
    $('#tableConfirmation').fadeOut(500);
  }

  function responseMessage(action, message) {
    $('#responseBody').show();
    let responseSet = null;
    if (action === 1) {
      responseSet = `<div class="mt-2 alert alert-danger d-flex alert-dismissible align-items-center fade show" role="alert">
                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                        <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`;
    } else if (action === 2) {
      responseSet = `<div class="mt-2 alert alert-success d-flex align-items-center alert-dismissible fade show" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
                <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`;
    }
    $('#responseBody').html(responseSet);
  }

  $('#search_type').change(function () {
    selectOption = this.value;
    console.log('selectOption', selectOption);
    if(this.value == "phone"){
        $('.email_div').hide();
        $('.postalcode_div').hide();
        $('.phone_div').show();
        //$('.email').val('');
        //$('.postalcode').val('');
    }else if(this.value == "email") {
        $('.phone_div').hide();
        $('.postalcode_div').hide();
        $('.email_div').show();
        //$('.phone_number').val('');
          //$('.postalcode').val('');
    }else{
        $('.phone_div').hide();
        $('.email_div').hide();
        $('.postalcode_div').show();
        //$('.phone_number').val('');
        //$('.email').val('');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('#resultsBody').html('');
    $('#resultsBodyExchange').html('');
    $('#resultsBodyMadeMeasure').html('');
    $('#customerResponseBody').html('');
    $('#responseBody').hide();

    if (customerIdParam && orderIDParam) {
      $('.loader').show();
      $('body').addClass('return-loader-active');
      $.ajax({
        type: 'GET',
        url:
          baseEndpointUrl +
          '/v1/order/get-order?order_id=' +
          orderIDParam +
          '&customer=' +
          customerIdParam +
          '&type=' +
          typeParam,
        data: {
          _token: '{{ csrf_token() }}',
          order_id: orderIDParam,
          customer: customerIdParam,
          type: typeParam,
        }, // serializes the form's elements.
        success: function (data) {
          $('.loader').hide();
          $('body').removeClass('return-loader-active');
          if (data.error) {
            toastr.warning(data.message);
          } else {
            $('#customerResponseBody').show();
            $('#customerResponseBody').html(data);
            responseCardLoad();
          }
        },
      });
    }
  });

  function alreadyRequested(data, action_type) {
    let html = '';
    html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
    var counter = 0;
    $.each(data, function (index, item) {
      let handlelizedActionType = action_type
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '');
      html +=
        `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 exchangeitems filter-row already-requested-for-` +
        handlelizedActionType +
        `">` +
        '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
        item.id +
        '" data-item-price="' +
        item.price +
        '" data-item-gross-price="' +
        item.gross_price +
        '" data-item-store-credit-percentage="' +
        item.store_credit_percentage +
        '" data-item-refund-percentage="' +
        item.refund_percentage +
        '" data-item-store-credit-single-amount="' +
        item.store_credit_single_amount +
        '" data-item-refund-single-amount="' +
        item.refund_single_amount +
        '">';
      if (counter == 0) {
        html += '<div class="card_badge info"><span>Already requested for ' + action_type + '</span></div>';
      }
      html += '<div class="col-md-1">';
      html +=
        '<div class="product-img">' +
        '<img class="card-img-top card-img" src="' +
        item.image +
        '" style="object-fit: cover;" alt="' +
        item.name +
        '">' +
        '</div>' +
        '</div>' +
        '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">' +
        '<div class="row">' +
        '<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">' +
        '<h6 class="card-title" style="font-size: 15px;">' +
        item.name +
        ' - ' +
        item.color +
        '-' +
        item.size +
        '</h6>' +
        '<span>SKU: ' +
        item.sku +
        '</span>' +
        '<br/><span><b>Qty:</b> ' +
        item.quantity +
        '</span>' +
        '<br/><span><b>Price:</b> £' +
        item.price +
        '</span>' +
        '<br/><span data-brand="' +
        item.brand +
        '">Brand: ' +
        item.brand +
        '</span>' +
        '<p>' +
        '<b>Tracking Company:</b> ' +
        item.tracking_name +
        '<br>' +
        '<b>Tracking Id:</b> ' +
        item.tracking_id +
        '</p>' +
        '</div>' +
        '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">' +
        '<div class="row">';
      if (action_type == 'Return') {
        // Item already requested for return, Check Return tab for more information
        html +=
          '<div><p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">This item has already requested for return.</p></div>';
      } else if (action_type == 'Exchange') {
        if (item.refund_status_id == 1) {
          // Pending
          html +=
            '<p style="font-weight: 700; color: #F44336;padding-left:0px;">Exchange Already Requested From ' +
            item.exchange_order +
            ' with quantity ' +
            item.return_qty +
            '</p>';
          if (item.lable_type_url != 'error') {
            html +=
              `<a href="` +
              item.lable_type_url +
              `" class="btnurls btn-alter-label" target="_blank">Download Label</a>`;
          }
          if (item.qrcode_url != 'error') {
            html +=
              `<a href="` + item.qrcode_url + `" class="btnurls btn-alter-label" target="_blank">Download QR Code</a>`;
          }
          html += `<p style="padding: 10px 0 5px 0;margin:0;">Please download the return label using the above button and include it in your return parcel.If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                           <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                           <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
        } else if (item.refund_status_id == 3) {
          // Declined
          html +=
            '<p style="font-weight: 700; color: #F44336;padding-left:0px;">Your exchange request is declined.</p>';
        } else {
          html +=
            '<p style="font-weight: 700; color: #198754;padding-left:0px;">Exchange Already Completed From ' +
            item.exchange_order +
            ' with quantity ' +
            item.return_qty +
            '</p>';
        }
      } else if (action_type == 'Alteration') {
        // Customer has requested the alteration request
        html +=
          '<div><p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">This item has already requested for alteration.</p></div>';
        html +=
          '<p style="margin: 0; padding-top: 0; padding-bottom: 0;"><b>Alteration Request Status:</b> ' +
          item.alteration_request_status +
          '</p>\
                                      <p style="margin: 0; padding-top: 0; padding-bottom: 0;"><b>Requested Quantity:</b> ' +
          (item.alteration_request_quantity || 'N/A') +
          '</p>\
                                      <p style="margin: 0; padding-top: 0; padding-bottom: 0;"><b>Requested Length (in cm):</b> ' +
          item.alteration_request_length +
          '</p>';
        if (item.alteration_request_note && item.alteration_request_note.trim() !== '') {
          html +=
            '<p style="margin: 0; padding-top: 0; padding-bottom: 0;"><b>Note:</b> ' +
            item.alteration_request_note +
            '</p>';
        }
        if (item.alteration_request_trackings && item.alteration_request_trackings.length > 0) {
          html += `<div class="alteration-tracking"><p>Tracking Details:</p>`;
          item.alteration_request_trackings.forEach((tracking) => {
            const trackingLink = `<a style="color: #ff8080;" href="${tracking.tracking_url}" target="_blank">${tracking.tracking_name} (ID: ${tracking.tracking_id})</a>`;
            //console.log(trackingLink);
            html += trackingLink;
          });
          html += `</div>`;
        }
        if (item.alteration_request_status == 'Pending' && item.return_tracking && item.return_tracking.label_url) {
          if (item.return_tracking.label_url != 'error') {
            html += `<a href="${item.return_tracking.label_url}" target="_blank" class="btn-alter-label">Download Retun Label</a>`;
          }
          if (item.return_tracking.qrcode_url != 'error') {
            html +=
              `<a href="` +
              item.return_tracking.qrcode_url +
              `" class="btnurls btn-alter-label" target="_blank">Download QR Code</a>`;
          }
          html += `<p style="padding: 10px 0 5px 0;margin:0;">Please download the return label using the above button and include it in your return parcel.If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                               <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                               <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
        }
      }
      html += '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      counter++;
    });
    html += `</div>`;
    return html;
  }

  function getOutletItemHtml(data, action_type) {
    if (data.partner_id != 1) {
      return '';
    }
    let html = '';
    $.each(data.outlet, function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
      $.each(seller.items, function (itemIndex, item) {
        html +=
          '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row outlet-item-non-returnable">\
                    <div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" data-item-price="' +
          item.price +
          '" data-item-gross-price="' +
          item.gross_price +
          '" data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" data-item-refund-percentage="' +
          item.refund_percentage +
          '" data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" data-item-refund-single-amount="' +
          item.refund_single_amount +
          '">';
        if (itemIndex === 0) {
          html += `<div class="card_badge danger"><span>Outlet Item</span></div>`;
        }
        html += '<div class="col-md-1">';
        if (data.is_active_date == 1 && item.can_return == 1 && action_type == 'return') {
          html +=
            '<div class="controls flex-row-reverse">\
                              <i class="material-icons"></i>\
                              <i class="material-icons">\
                                  <input class="form-check-input non-return-outlet-checkbox checkbox" data-line-item-id="' +
            item.id +
            '" style="font-size: 1.5rem;display: block" type="checkbox" id="checkboxNoLabel" value="" aria-label="...">\
                              </i>\
                          </div>';
        }
        html +=
          '<div class="product-img">\
                            <img class="card-img-top card-img" src="' +
          item.image +
          '"  style="object-fit: cover;" alt="' +
          item.name +
          '">\
                        </div>\
                          </div>\
                        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
                          <div class="row">\
                           <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
                            <h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>\
                            <span>SKU: ' +
          item.sku +
          '</span>\
                            <br/><span>\
                                <b>Qty:</b> ' +
          item.quantity +
          '\
                            </span>\
                             <br/><span>\
                                <b>Price:</b> £' +
          item.price +
          '\
                            </span>\
                            <br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>\
                             <p>' +
          (item.tracking_name ? '<b>Tracking Company:</b> ' + item.tracking_name + '<br>' : '') +
          (item.tracking_id ? '<b>Tracking Id:</b> ' + item.tracking_id : '') +
          '</p>\
                          </div>';
        html += '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">';
        html += '<div class="row">';
        if (action_type == 'return') {
          if (data.is_active_date == 1) {
           const isRestrictedCountry = restrictedCountries.includes(data.shipping_country_code);
            const showInternationalOutletMsg = isRestrictedCountry || isOutletSelfShipOnly(data.shipping_country_code);

            let outletPolicyHtml = '';
            if (showInternationalOutletMsg) {
              // EU / US / CA / AU / NZ, Cyprus, and other international countries
              outletPolicyHtml = `
                <p>Outlet items are subject to different return terms. If you return an Outlet item, you will receive 60% of the purchase price as a Goddiva e-gift card. Outlet returns are not eligible for a refund to the original payment method.</p>
                <p>For international locations outside of the EU, USA, Canada, New Zealand, and Australia, customers are responsible for arranging and covering the cost of return postage.</p>
                <p style="color:red">*Please note Cyprus is excluded from EU returns and is a self-ship location.</p>
                <p>We recommend using a tracked shipping service with your local courier and ensuring that any applicable duties or taxes are covered.</p>
                <p>Please securely repackage your item(s) in waterproof, non-transparent packaging and include a copy of your order details inside the parcel.</p>
                <p><strong>Return address:</strong><br>
                Goddiva Returns<br>
                CG House, 107B Chadwell Heath Lane, Romford, Essex RM6 4NP, United Kingdom</p>
                <p>Once your return has been received and processed, we will issue the applicable 60% Outlet refund as a Goddiva e-gift card.</p>`;
            } else {
              // UK – current message
              outletPolicyHtml = `
                <p><span class="gdbold">Please note that outlet items are final sale and not eligible for a full refund,</span>as they are end-of-line or seasonal stock.</p>
                <p>However, as a gesture of goodwill, we can offer a 60% refund in the form of a gift card if the item is returned and passes our quality checks. Kindly note:</p>
                <ul>
                  <li>A small fee applies for the return label.<span class="gdbold">(Returns are free for Goddiva Unlimited subscribers)</span></li>
                  <li>If the item does not meet return conditions, it will be sent back and no refund issued.</li>
                </ul>
                <p>Thank you for your understanding.</p>`;
            }

            html += `<div class="return-policy-message">
                      ${outletPolicyHtml}
                      <div class="outlet-return-confirmation">
                        <label>
                          <input class="outlet-item-option" type="radio" name="outlet-item-option-${item.id}" value="yes">
                          <span class="gdbold">Yes</span> – I want to return the item
                        </label>
                        <label>
                          <input class="outlet-item-option" type="radio" name="outlet-item-option-${item.id}" value="no">
                          <span class="gdbold">No</span> – I do not want to return it
                        </label>
                      </div>
                    </div>`;
            // Can return as it's available for return
            html += `<div class="outlet-item-no-message-${item.id} outlet-item-no-message" style="display:none">Please reach out to us at <a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a> for further help.</div>`;
            html += `<div class="outlet-items-options-wrapper-${item.id} row outlet-items-options-wrapper" style="display:none">`;
            html +=
              '<input type="hidden" name="is_same_size" class="is_same_size" data-line-item-id="' +
              item.id +
              '" value="">';
            html +=
              '<div class="col-lg-2 col-md-4 col-sm-12 col-xs-12" style="">\
                                            <label>Quantity</label>\
                                            <div class="input-container">\
                                              <button class="minus-btn"> </button>\
                                              <input type="number" style="font-size: 14px !important;" class="form-control quantity" placeholder="Quantity" min="1" max="' +
              item.availableQty +
              '" oninput="validity.valid||(value=\'\');" data-max-qty="' +
              item.quantity +
              '" data-line-item-id="' +
              item.id +
              '" id="return_quantity_' +
              item.id +
              '" value="1">\
                                              <button class="plus-btn"> </button>\
                                              </div>\
                                          </div>';
            html +=
              '<div class="col-md-3">\
                                          <label>Reason <span class="mandatory">*</span></label>\
                                                <select id="reason-' +
              item.id +
              '" name="search_type" class="form-select mb-1 reason" data-is-goddiva="' +
              item.is_goddiva +
              '" data-is-outlet="' +
              item.is_outlet +
              '" data-price="' +
              item.price +
              '" data-line-item-id="' +
              item.id +
              '" data-sku="' +
              item.sku +
              '" data-product="' +
              item.name +
              '" aria-label="Reason">\
                                                    <option value="-1" selected="" disabled="">Select Reason</option>';

            $.each(data.reasons, function (index, reason) {
              html += '<option value="' + reason.id + '">' + reason.name + '</option>';
            });

            html += `</select>
                                              <div class="">
                                                <textarea rows="10" class="form-control mb-1 specific-reason" placeholder="Leave a specific reason here" maxlength="150" data-line-item-id="${item.id}" style="display: none;"></textarea>\
                                            </div>
                                            </div>`;
            // Return Options Started here
            html += '<div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 refund-option-wrapper">';
            html += '<label>Choose Options <span class="mandatory">*</span></label>';
            var returnOptions = item.return_options;
            var outletSelfShipOnly = isOutletSelfShipOnly(data.shipping_country_code);
            html += '<div class="refund-option">';
            if (returnOptions.return_label && !outletSelfShipOnly) {
              html += `<label class="return-label"><input type="radio" name="return_option_${item.id}" data-price="${
                item.price
              }" value="return_label" data-return-fee="${data.is_vip_customer ? '0.00' : data.return_fee}">
                                        Return Label
                                        </label>`;
            }
            if (returnOptions.self_ship && data.is_self_ship_available) {
              html += `<label class="self-ship"><input type="radio" name="return_option_${item.id}" value="self_ship">
                                        Self Ship
                                        </label>`;
            }
            html += '</div>';

            html += '</div>';
            // Return Options End here
            html += `<div class="row">
                    <div class="upload-wrapper" data-line-item-id="${item.id}" style="display:none;">
                        <input 
                          type="file" 
                          class="faulty-upload" 
                          accept=".jpg,.jpeg,.png" 
                          multiple 
                          data-line-item-id="${item.id}" 
                        />
                        <div class="upload-message"><p>If you upload images of the fault, our team will review them. If approved, your return postage will be free, otherwise we’ll deduct the postage fee from your refund amount.</p></div>
                        <div class="upload-errors" data-line-item-id="${item.id}"></div>
                        <div class="image-preview-container" data-line-item-id="${item.id}"></div>
                      </div>
                    </div>`;

            html +=
              '<p class="text-danger mt-1 type-error" data-line-item-id="' +
              item.id +
              '" style="font-size: 15px !important;">*Quantity cannot exceed available to return quantity - [' +
              item.availableQty +
              ']</p>';
            html +=
              '<p class="text-danger mt-1 error" data-line-item-id="' +
              item.id +
              '" style="font-size: 15px !important;">*Please fill all fields</p>';
            html += `<p  style="font-weight: 700;padding-left:1.5rem;" class="option-description-` + item.id + `"></p>`;
            html += `</div>`; //outlet-item-options-wrapper closed
          } else {
            html +=
              '<p class="text-danger mt-1"  style="font-weight: 700; font-size: 15px">The return period has passed, please contact customer service at <a style="color: #ff8080;" href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
          }
        } else {
          html += `<p style="padding: 0 0 5px 0;margin:0;">Please note: All outlet items are final sale and cannot be exchanged. These are reduced, end-of-line or seasonal products, and as such, are not eligible for refunds or exchanges.</p>
                                   <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
                                   <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
                                   <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>`;
        }
        html +=
          '</div>\
                        </div>\
                         </div>\
                        </div>\
                        </div>\
                    </div>';
      });
      html += `</div>`;
    });
    return html;
  }

  function getNonReturnableItemHtml(data, action_type) {
    let html = '';
    $.each(data.nonReturnableItems, function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
      $.each(seller.items, function (itemIndex, item) {
        html +=
          '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row non-returnable">\
                    <div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" data-item-price="' +
          item.price +
          '" data-item-gross-price="' +
          item.gross_price +
          '" data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" data-item-refund-percentage="' +
          item.refund_percentage +
          '" data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" data-item-refund-single-amount="' +
          item.refund_single_amount +
          '">';
        if (itemIndex === 0) {
          html += `<div class="card_badge danger"><span>Non-Returnable</span></div>`;
        }
        html += '<div class="col-md-1">';
        html +=
          '<div class="product-img">\
                            <img class="card-img-top card-img" src="' +
          item.image +
          '"  style="object-fit: cover;" alt="' +
          item.name +
          '">\
                        </div>\
                          </div>\
                        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
                          <div class="row">\
                           <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
                            <h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>\
                            <span>SKU: ' +
          item.sku +
          '</span>\
                            <br/><span>\
                                <b>Qty:</b> ' +
          item.quantity +
          '\
                            </span>\
                            <br/><span>\
                                <b>Price:</b> £' +
          item.price +
          '\
                            </span>\
                            <br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>\
                            <p>\
                                <b>Tracking Company:</b> ' +
          item.tracking_name +
          ' <br>\
                                <b>Tracking Id:</b> ' +
          item.tracking_id +
          '\
                            </p>\
                          </div>';
        html += '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">';
        if (data.is_active_date == 1) {
          // Cannot return as it's outlet tagged item
          html += `<p style="padding: 0 0 5px 0;margin:0;">Please note: All earrings / skin care / hair care, etc. items cannot be returned/exchanged for hygiene reasons.</p>
                                   <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
                                   <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
                                   <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
                                  `;
        } else {
          html +=
            '<p class="text-danger mt-1"  style="font-weight: 700; font-size: 15px">The return period has passed, please contact customer service at <a style="color: #ff8080;" href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
        }

        html +=
          '</div>\
                        </div>\
                         </div>\
                        </div>\
                    </div>';
      });
      html += `</div>`;
    });
    return html;
  }

  // return html start
  function notRequestedItems(data, type) {
    let html = '';
    $.each(data.not_requested, function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
      $.each(seller.items, function (itemIndex, item) {
        let isGiftBagItem = item.name === 'Heart Shaped Foil Shopper Bag - Rose Gold';

        html +=
          '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row ' +
          type +
          '-eligible">\
      <div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" data-item-price="' +
          item.price +
          '" data-item-gross-price="' +
          item.gross_price +
          '" data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" data-item-refund-percentage="' +
          item.refund_percentage +
          '" data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" data-item-refund-single-amount="' +
          item.refund_single_amount +
          '" data-brand-id="' +
          item.brand_id +
          '">';

        if (itemIndex === 0) {
          html +=
            `<div class="card_badge success"><span>Not Requested for ` + type + ` - ` + seller.brand + `</span></div>`;
        }

        html += '<div class="col-md-1">';

        if (data.is_active_date == 1 && item.can_return == 1) {
          if (isGiftBagItem && item.is_gift_bag) {
            // Gift bag eligible but only with other items
            html +=
              '<div class="controls flex-row-reverse">\
                    <i class="material-icons"></i>\
                    <i class="material-icons">\
                        <input class="form-check-input return-checkbox checkbox gift-bag-checkbox" data-line-item-id="' +
              item.id +
              '" data-line-item-name="' +
              item.name +
              '" type="checkbox" disabled>\
                    </i>\
                </div>';
          } else if (isGiftBagItem && !item.is_gift_bag) {
            // Not returnable at all -> no checkbox
            html += '';
          } else if(item.is_mystery){
            // Not returnable Mystery box -> no checkbox
              html += '';     
          } else {
            if (seller.seller_id == 60) {
              // Not returnable at all for Naylaleex seller -> no checkbox
              html += '';
            } else {
              // Normal case
              html +=
                '<div class="controls flex-row-reverse">\
                    <i class="material-icons"></i>\
                    <i class="material-icons">\
                        <input class="form-check-input return-checkbox checkbox" data-line-item-id="' +
                item.id +
                '" data-line-item-name="' +
                item.name +
                '" type="checkbox">\
                    </i>\
                </div>';
            }
          }
        }

        let price = parseFloat(item.price);
        let gross = parseFloat(item.gross_price);

        html +=
          '<div class="product-img">\
          <img class="card-img-top card-img" src="' +
          item.image +
          '"  style="object-fit: cover;" alt="' +
          item.name +
          '">\
      </div>\
        </div>\
      <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
        <div class="row">\
         <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
          <h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>\
          <span>SKU: ' +
          item.sku +
          '</span>\
          <br/><span><b>Qty:</b> ' +
          item.quantity +
          '</span>\
          <br/><span><b>Price:</b> ' +
          (price !== gross
            ? '<span style="text-decoration:line-through;">£' +
              price.toFixed(2) +
              '</span> <span style="color:#d00;font-weight:bold;">£' +
              gross.toFixed(2) +
              '</span>'
            : '£' + price.toFixed(2)) +
          '</span>\
          <br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>\
          <p>\
              <b>Tracking Company:</b> ' +
          item.tracking_name +
          ' <br>\
              <b>Tracking Id:</b> ' +
          item.tracking_id +
          '\
          </p>\
        </div>';

        html += '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><div class="row">';

        if (data.is_active_date == 1) {
          if (seller.seller_id == 60) {
            // Not returnable message only
            html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">For hygiene reasons, we are unable to accept returns on beauty products, ranging from pierced jewellery, make-up, skin care, fragrances, hair products and anything that can be applied to the skin or body. In addition, we will be unable to accept returns on face masks, lingerie & swimwear</p>
              <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
              <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
              <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
            `;
          } else if(item.is_mystery){
            // Not returnable message only
            html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">This is a Mystery Box product, and as per our return policy, Mystery Box items are non-returnable.</p>
              <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
              <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
              <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
            `;
          } else {
            if (isGiftBagItem && !item.is_gift_bag) {
              // Not returnable message only
              html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">Please note: This item is non returnable.</p>
              <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
              <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
              <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
            `;
            } else {
              if (isGiftBagItem && item.is_gift_bag) {
                // Promotional bag message
                html +=
                  '<p class="gift-bag-msg text-danger mt-1" style="font-weight: 700; font-size: 15px" data-line-item-id="' +
                  item.id +
                  '">The promotional bag can’t be returned on its own. It may only be returned if other items from the order are also returned.</p>';
              }

              html +=
                '<input type="hidden" name="is_same_size" class="is_same_size" data-line-item-id="' +
                item.id +
                '" value="">';

              // Quantity
              html +=
                '<div class="col-lg-2 col-md-4 col-sm-12 col-xs-12 input-container-wrapper" ' +
                (isGiftBagItem && item.is_gift_bag ? 'style="display:none;"' : '') +
                '>\
                      <label>Quantity</label>\
                      <div class="input-container">\
                        <button class="minus-btn"> </button>\
                        <input type="number" class="form-control quantity" min="1" max="' +
                          item.availableQty +
                          '" data-line-item-id="' +
                          item.id +
                          '" id="return_quantity_' +
                          item.id +
                          '" data-max-qty="' +
                          item.quantity +
                          '" value="1">\
                        <button class="plus-btn"> </button>\
                      </div>\
                  </div>';

              // Reason
              html +=
                '<div class="col-md-3 reason-wrapper" ' +
                (isGiftBagItem && item.is_gift_bag ? 'style="display:none;"' : '') +
                '>\
                      <label>Reason <span class="mandatory">*</span></label>\
                      <select id="reason-' +
                item.id +
                '" class="form-select mb-1 reason" data-is-goddiva="' +
                item.is_goddiva +
                '" data-line-item-id="' +
                item.id +
                '" data-sku="' +
                item.sku +
                '" data-product="' +
                item.name +
                '" data-brand="' +
                item.brand +
                '">\
                          <option value="-1" selected disabled>Select Reason</option>';

              if (isGiftBagItem && item.is_gift_bag) {
                // Show all reasons initially
                $.each(data.reasons, function (index, reason) {
                  html += '<option value="' + reason.id + '">' + reason.name + '</option>';
                });
              } else {
                // All reasons
                $.each(data.reasons, function (index, reason) {
                  html += '<option value="' + reason.id + '">' + reason.name + '</option>';
                });
              }
              html +=
                '</select>\
                  <div><textarea rows="10" class="form-control mb-1 specific-reason" placeholder="Leave a specific reason here" maxlength="150" data-line-item-id="' +
                item.id +
                '" style="display:none;"></textarea></div>\
                  </div>';

              // Return options
              html +=
                '<div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 refund-option-wrapper" ' +
                (isGiftBagItem && item.is_gift_bag ? 'style="display:none;"' : '') +
                '>';
              html += '<label>Choose Options <span class="mandatory">*</span></label>';
              var returnOptions = item.return_options;
              html += '<div class="refund-option">';
              if (returnOptions.store_credit == true) {
                html += `<label class="store-credit"><input type="radio" name="return_option_${item.id}" value="store_credit">
                          £<span id="total-store-credit__${item.id}">0.00</span> Store Credit <span class="keepitem">(Keep the item)</span>
                          </label>`;
              }
              if (returnOptions.refund == true) {
                html += `<label class="refund"><input type="radio" name="return_option_${item.id}" value="refund">
                          £<span id="total-refund__${item.id}">0.00</span> Refund <span class="keepitem">(Keep the item)</span>
                      </label>`;
              }
              if (returnOptions.return_label == true) {
                html += `<label class="return-label"><input type="radio" name="return_option_${
                  item.id
                }" value="return_label" data-return-fee="${data.is_vip_customer ? '0.00' : data.return_fee}">
                          Return Label
                      </label>`;
              }
              if (returnOptions.self_ship == true && data.is_self_ship_available == true) {
                html += `<label class="self-ship"><input type="radio" name="return_option_${item.id}" value="self_ship">
                          Self Ship
                      </label>`;
              }
              html += '</div></div>';
              html += `<div class="restricted-countrieslist" data-line-item-id="${item.id}" style="font-size: 15px !important; display:none">
                <p>For international locations outside of the EU, USA, Canada, New Zealand, and Australia, customers are responsible for arranging and covering the cost of return postage.</p>
                <p style="color:red">*Please note Cyprus is excluded from EU returns and is a self-ship location.</p>
                <p>We recommend using a tracked shipping service with your local courier and ensuring that any applicable duties or taxes are covered.</p>
                <p>Please securely repackage your item(s) in waterproof, non-transparent packaging and include a copy of your order details inside the parcel.</p>
                <p><strong>Return address:</strong><br>
                Goddiva Returns<br>
                CG House, 107B Chadwell Heath Lane, Romford, Essex RM6 4NP, United Kingdom</p>
                <p>Once your return has been received and processed, we will be in touch regarding your refund or exchange.</p>
              </div>`;
              html += `<div class="row">
              <div class="upload-wrapper" data-line-item-id="${item.id}" style="display:none;">
                  <input 
                    type="file" 
                    class="faulty-upload" 
                    accept=".jpg,.jpeg,.png" 
                    multiple 
                    data-line-item-id="${item.id}" 
                  />
                  <div class="upload-message"><p>If you upload images of the fault, our team will review them. If approved, your return postage will be free, otherwise we’ll deduct the postage fee from your refund amount.</p></div>
                  <div class="upload-errors" data-line-item-id="${item.id}"></div>
                  <div class="image-preview-container" data-line-item-id="${item.id}"></div>
                </div>
              </div>`;

              html +=
                '<p class="text-danger mt-1 type-error" data-line-item-id="' +
                item.id +
                '" style="font-size: 15px !important;">*Quantity cannot exceed available to return quantity - [' +
                item.availableQty +
                ']</p>';
              html +=
                '<p class="text-danger mt-1 error" data-line-item-id="' +
                item.id +
                '" style="font-size: 15px !important;">*Please fill all fields</p>';
              html += `<p style="font-weight: 700;padding-left:1.5rem;" class="option-description-${item.id}"></p>`;
            }
          }
        } else {
          html +=
            '<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">The return period has passed, please contact customer service at <a style="color: #ff8080;" href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
        }

        html += '</div></div></div></div></div></div>';
      });
      html += `</div>`;
    });
    return html;
  }

  function processedReturnItems(data, key, option_type) {
    let html = '';
    $.each(data.requested.return[key], function (index, sellerwiseItem) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
      $.each(sellerwiseItem.items, function (index, item) {
        let filterClass = '';
        if (key === 'self_ship') {
          filterClass = 'self-ship-return-requested';
        } else if (key === 'store_credit') {
          filterClass = 'store-credit-issued';
        } else if (key === 'refund') {
          filterClass = 'refund-issued';
        }
        html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row ${filterClass}">`;
        html +=
          '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" data-item-price="' +
          item.price +
          '" data-item-gross-price="' +
          item.gross_price +
          '" data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" data-item-refund-percentage="' +
          item.refund_percentage +
          '" data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" data-item-refund-single-amount="' +
          item.refund_single_amount +
          '">';
        if (index === 0) {
          if (key == 'self_ship') {
            html += `<div class="card_badge info"><span>Self-Ship Return Requested</span></div>`;
          } else if (key == 'store_credit') {
            html += `<div class="card_badge info"><span>Store Credit Issued</span></div>`;
          } else if (key == 'refund') {
            html += `<div class="card_badge info"><span>Refund Issued</span></div>`;
          }
        }
        html += '<div class="col-md-1">';
        html +=
          '<div class="product-img">\
              <img class="card-img-top card-img" src="' +
          item.image +
          '"  style="object-fit: cover;" alt="' +
          item.name +
          '">\
          </div>\
            </div>\
          <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
            <div class="row">\
             <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
              <h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>\
              <span>SKU: ' +
          item.sku +
          '</span>\
              <br/><span>\
                  <b>Qty:</b> ' +
          item.quantity +
          '\
              </span>\
            <br/><span>\
                  <b>Price:</b> £' +
          item.price +
          '\
              </span>\
              <br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>\
              <p>\
                  <b>Tracking Company:</b> ' +
          item.tracking_name +
          ' <br>\
                  <b>Tracking Id:</b> ' +
          item.tracking_id +
          '\
              </p>\
            </div>';
        html += '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">';
        html += '<div class="row">';
        // Cannot return this item, now check why
        if (item.is_return == 1) {
          // Item already requested for return
          if (item.refund_status_id == 1) {
            // Pending
            if (item.lable_type == 1) {
              // It is VIP customer, direct show return label using lable_type_url
              html +=
                `<p style="padding: 0 0 10px 0;margin:0;"><a href="` +
                item.lable_type_url +
                `" target="_blank" class="btn-refund-option">Download Return Label</a></p>
                                    <p style="padding: 0 0 5px 0;margin:0;">Please download the return label using above link and include it in your return parcel. Once prepared, kindly send the parcel back to us.</p>
                                    <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                    <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                    <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
            } else if (item.lable_type == 2) {
              if (item.lable_status == 'Pending Payment') {
                // Show payment URL to customer using lable_invoice_url
                html +=
                  `<p style="padding: 0 0 10px 0;margin:0;"><a href="javascript:;" class="btn-refund-option open-payment-popup" data-invoice-url="` +
                  item.lable_invoice_url +
                  `">Pay for Return Label</a></p>
                                          <p style="padding: 0 0 5px 0;margin:0;">You need to pay for only one return label</p>
                                          <p style="padding: 0 0 5px 0;margin:0;">You will be redirected to the payment page. After completing the payment for return charges, please return to this page to download your return label.</p>
                                          <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                          <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                          <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
              } else if (item.lable_type_url != null) {
                // Show Download label button using lable_type_url
                html +=
                  `<p style="padding: 0 0 10px 0;margin:0;"><a href="` +
                  item.lable_type_url +
                  `" target="_blank" class="btn-refund-option">Download Return Label</a></p>
                                    <p style="padding: 0 0 5px 0;margin:0;">Please download the return label using above link and include it in your return parcel. Once prepared, kindly send the parcel back to us.</p>
                                    <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                    <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                    <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
              }
            } else if (item.lable_type == 3) {
              // Customer has selected Selft Ship option
              html +=
                `<p style="padding: 0 0 10px 0;margin:0;"><a href="` +
                item.lable_type_url +
                `" target="_blank" class="btn-refund-option btn-return-note">Download Return Note</a></p>
                                    <p style="padding: 0 0 5px 0;margin:0;">If you choose to self-ship your return, the return parcel is your responsibility. This includes any instances of lost, missing, or damaged parcels. We recommend using a tracked and insured shipping method to ensure your return reaches us safely. Please download the return note using the above button and include it in your return parcel.If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                    <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                    <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
            } else if (item.lable_type == 6) {
              // Customer has selected the refund option so show details
              html +=
                '<p class="text-success mt-1" style="font-weight: 700;padding-left:0px;">Thank you for choosing to keep the item. We have processed a refund of £' +
                item.refund_total_amount +
                ' to your original payment method.</p>';
            }
          } else if (item.refund_status_id == 3) {
            // Declined
            html += `<p style="padding: 0 0 5px 0;margin:0;">We're sorry to inform you that your return request has been <strong style="color: #F44336;">Declined</strong>. If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                              <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                              <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
          } else if (item.refund_status_id == 6) {
            // Declined
            html +=
              `<p style="padding: 0 0 5px 0;margin:0;">We are pleased to inform you that a refund of <strong>£` +
              item.refund_total_amount.toFixed(2) +
              `</strong> has been <strong style="color: #198754;">Successfully</strong> processed for <strong>` +
              item.return_qty +
              ` qty</strong> of this item. If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
          } else {
            // Approved
            html +=
              `<p style="padding: 0 0 5px 0;margin:0;">Return has already been completed for this item with quantity of ` +
              item.return_qty +
              `</p>
                              <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                              <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                              <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
          }
        } else if (item.is_return == 2 && item.lable_type == 5) {
          // Item already store credit
          html +=
            `<p style="padding: 0 0 5px 0;margin:0;">Thank you for choosing to keep the item. We have sent you an email with the <strong style="color: #198754;">Gift Voucher</strong> worth £` +
            item.refund_total_amount.toFixed(2) +
            `</p>
                  <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                  <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                  <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
        } else if (item.is_return == 3) {
          // Item already exchanged
          html +=
            '<div><p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">This item has already requested for exchange so you cannot place return request for this item.</p></div>';
        } else if (item.alteration_request_status != null) {
          // Customer has requested the alteration request
          html +=
            '<div><p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">This item has already requested for alteration so you cannot place return request for this item.</p></div>';
        }

        html +=
          '</div>\
          </div>\
           </div>\
          </div>\
          </div>\
      </div>';
      });
      html += `</div>`;
    });

    return html;
  }

  function renderOptions(self) {
    let lineItemId = self.data('lineItemId');
    let price = self.data('price');
    let reasonId = self.val();
    let returnReasons = allData.reasons;
    let checkReason = returnReasons.find((item) => item.id == reasonId);

    let html = '';

    let item = null;
    $.each(allData.not_requested, function (_, seller) {
        const found = seller.items.find(i => i.id == lineItemId);
        if (found) {
            item = found;
            return false;
        }
    });

    const gradeTags = ["C", "D", "E"];
    const hasGradeTag = item && item.grade && gradeTags.includes(item.grade.toUpperCase());

    
    const card = $(`#card-${lineItemId}`);

    const storeCreditAmount = parseFloat(card.data("itemStoreCreditSingleAmount")) || 0;

    const refundAmount = parseFloat(card.data("itemRefundSingleAmount")) || 0;

    const isRestrictedCountry = restrictedCountries.includes(allData.shipping_country_code);

    if (checkReason && isRestrictedCountry) {
          $(`[data-line-item-id="${lineItemId}"].restricted-countrieslist`).show();
      } else {
          $(`[data-line-item-id="${lineItemId}"].restricted-countrieslist`).hide();
      }

  const selfShipHtml = `<label class="self-ship"><input type="radio" name="return_option_${lineItemId}" value="self_ship">
              Self Ship
          </label>`;

  // Outlet items: Return Label (except self-ship-only countries) + Self Ship
  if (checkReason && self.data("is-goddiva") === true && self.data("is-outlet") === true) {
    if (!isOutletSelfShipOnly(allData.shipping_country_code)) {
      html += `<label class="return-label"><input type="radio" name="return_option_${lineItemId}" data-price="${price}" value="return_label" data-return-fee="${allData.is_vip_customer ? '0.00' : allData.return_fee}">
                  Return Label
              </label>`;
    }

    if (allData.is_self_ship_available) {
      html += selfShipHtml;
    }
    return html;
  }

  if (checkReason && self.data("is-goddiva") == true && allData.partner_id == 1) {
    if (checkReason.is_store_credit == true && hasGradeTag && storeCreditAmount > 0) {
      html += `<label class="store-credit"><input type="radio" name="return_option_${lineItemId}" value="store_credit">
                 £<span id="total-store-credit__${lineItemId}">0.00</span> Store Credit <span class="keepitem">(Keep the item)</span>
                 </label>`;
    }

    if (checkReason.is_refund == true && refundAmount > 0) {
      html += `<label class="refund"><input type="radio" name="return_option_${lineItemId}" value="refund">
                £<span id="total-refund__${lineItemId}">0.00</span> Refund <span class="keepitem">(Keep the item)</span>
            </label>`;
    }
  }

  // Non-outlet: Return Label only if country is NOT restricted
  if (!isRestrictedCountry) {
    html += `<label class="return-label"><input type="radio" name="return_option_${lineItemId}" value="return_label" data-return-fee="${allData.is_vip_customer ? '0.00' : allData.return_fee}">
                  Return Label
              </label>`;
  }

  if (allData.is_self_ship_available) {
    html += selfShipHtml;
  }

  return html;
  
  }
  function processPendingLabelItems(data) {
    let html = '';
    let flatPendingLabelList = data.requested.return.return_label.pending_label;
    $.each(flatPendingLabelList, function (index, label) {
      $.each(label.items, function (itemIndex, seller) {
        html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
        $.each(seller.items, function (sellerItemIndex, item) {
          lastPendingFeesReturnItems.push({
            brand_id: item.brand_id,
            brand_name: item.brand,
            requested_date: item.requested_date,
          });

          html += '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row return-fee-pending">';
          html +=
            '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';
          if (sellerItemIndex === 0) {
            html += '<div class="card_badge danger"><span>Return Fee Pending</span></div>';
          }
          html += '<div class="col-md-1">';
          html += '<div class="product-img">';
          html +=
            '<img class="card-img-top card-img" src="' +
            item.image +
            '" style="object-fit: cover;" alt="' +
            item.name +
            '">';
          html += '</div>'; // Close product-img
          html += '</div>'; // Close col-md-1
          html += '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">';
          html += '<div class="row">';
          html += '<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">';
          html +=
            '<h6 class="card-title" style="font-size: 15px;">' +
            item.name +
            ' - ' +
            item.color +
            '-' +
            item.size +
            '</h6>';
          html += '<span>SKU: ' + item.sku + '</span>';
          html += '<br/><span><b>Qty:</b> ' + item.quantity + '</span>';
          html += '<br/><span><b>Price:</b> £' + item.price + '</span>';
          html += '<br/><span data-brand="' + item.brand + '">Brand: ' + item.brand + '</span>';
          html +=
            '<p><b>Tracking Company:</b> ' +
            item.tracking_name +
            ' <br><b>Tracking Id:</b> ' +
            item.tracking_id +
            '</p>';
          html += '</div>'; // Close col-lg-4
          html += '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">';
          html += '<div class="row">';
          if (item.return_request_item_status_id == 4) {
            if (
              item.return_request_item_cancelled_type == 'admin' ||
              item.return_request_item_cancelled_type == 'system'
            ) {
              html += `<p style="padding: 0 0 5px 0;margin:0;color: #F44336;">Return request was declined by Admin because return fee was not paid.</p>`;
            } else {
              html += `<p style="padding: 0 0 5px 0;margin:0;color: #F44336;">Return request cancelled by you.</p>`;
            }
          } else if (item.return_request_item_status_id == 3) {
            html += `<p style="padding: 0 0 5px 0;margin:0;color: #F44336;">Return request was declined by Admin.</p>`;
          } else if (item.lable_type == 2 && item.return_request_item_status_id != 4) {
            if (item.lable_status == "Pending Payment") {
              html += `
                <div class="d-flex justify-content-between pending-payment-wrapper">
                  <p style="padding: 0 0 10px 0;margin:0;">
                    <a href="javascript:;" class="btn-refund-option open-payment-popup" data-invoice-url='${item.lable_invoice_url}'>Pay for Return Label</a>
                  </p>
                  <div class="cancel-request-wrapper">
                    <a href="javascript:;" class="btn-cancel-request" data-cancel-request-id="${item.return_request_item_id}" style="display:none!important">Cancel Request</a>`;
            
                    if (Array.isArray(item.images)) {
                      html += `<div class="faulty-image-preview-container">`;
                      item.images.forEach((imgUrl, index) => {
                        if (imgUrl) {
                          html += `
                            <a href="${imgUrl}" data-fancybox="faulty-images-${item.return_request_item_id}" data-caption="Faulty Image ${index + 1}">
                              <img src="${imgUrl}" class="faulty-preview-image" alt="Faulty Image">
                            </a>
                          `;
                        }
                      });
                      html += `</div>`;
                    }
            
                html += `
                  </div>
                </div>
                <p style="padding: 0 0 10px 0;margin:0;">You need to pay for only one return label</p>
                <p style="padding: 0 0 5px 0;margin:0;">After completing the payment for return charges, please return to this page to download your return label.</p>
              `;
            }
          }
          html += '</div>'; // Close row inside col-lg-8
          html += '</div>'; // Close col-lg-8
          html += '</div>'; // Close row inside col-lg-10
          html += '</div>'; // Close col-lg-10
          html += '</div>'; // Close cards
          html += '</div>'; // Close col-lg-12 returnitems
        });
        html += `</div>`;
      });
    });
    return html;
  }
  lastReturnItems = [];
  lastPendingFeesReturnItems = [];
  function processCompleteLabelItems(data) {
    let html = '';
    let flatCompleteLabelList = data.requested.return.return_label.complete_label;

    // for redirection GD-2225 start
    let shippingCode = data.shipping_country_code;
    // for redirection GD-2225 ends

    html += `<div class="separator paid-items-separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px;">`;
    html += '<div class="card_badge info"><span>Return Fee Paid</span></div>';
    $.each(flatCompleteLabelList, function (index, returnRequest) {
      let notEligibleCount = 0;
      let returnFeePaidCount = 0;
      let classOpen = '';
      if (index == 0) {
        classOpen = 'open';
      }

      html +=
        `<div class="accordion-container paid-returns-accordion return-request-` +
        returnRequest.return_request_id +
        `">
    	<div class="accordion-item">
    		<div class="accordion-header">
    			<span class="accordion-arrow-icon accordion-arrow-up" style="">&nbsp;</span> Items Requested for Return on ` +
        returnRequest.requested_date +
        `
    		</div>
            <div class="accordion-body ` +
        classOpen +
        `">
            <div>`;
      if (returnRequest.return_request_status_id != 4) {
        html += `<p style="padding: 0 0 5px 0; margin: 0">
                Please download the return label using the below link and include it in
                your return parcel. Once prepared, kindly send the parcel back to us.
              </p>`;
      }

      html += `<p style="padding: 0 0 5px 0; margin: 0">
                If you have any questions or need further assistance, please don't
                hesitate to reach out to our support team at
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">
                <a style="padding: 0; color: #ff8080" href="mailto:info@goddiva.co.uk"
                  >info@goddiva.co.uk</a
                >
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">We're here to help!</p>
            </div>
          
            <p>You have selected the following items for return:</p>`;

      $.each(returnRequest.items, function (index, seller) {
        let notEligibleCount = 0;
        let returnFeePaidCount = 0;
        html +=
          `<div class="brand-wrapper">
                 <div data-brand-id="2" class="brand-header">
                    <h4>` +
          seller.brand +
          `</h4>
                    <div>`;
        if (returnRequest.return_request_status_id != 4) {
          if (restrictedCountries.includes(shippingCode)) {
            ` <p class="redirect-msg">
                Now please go to this URL <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> and generate your return label. Thanks
            </p>`
          }else{
            if (seller.items && seller.items[0].return_tracking) {
              html +=
                `<a href="` +
                seller.label_url +
                `"
                                    target="_blank"
                                    class="btn-refund-option"
                                    >Download Return Label</a
                                  >`;
              
              if (seller.items[0].return_tracking.tracking_id) {
                html +=
                  `<a href="` +
                  seller.qrcode_url +
                  `"
                                    target="_blank"
                                    class="btn-refund-option"
                                    >Download QR Code</a
                                  >`;
              }
            }
          }         
        }

        html += `</div>
                  </div>`;
        $.each(seller.items, function (sellerItemIndex, item) {
          let filterClass = '';
          if (item.is_return == 3 || item.alteration_request_status != null) {
            filterClass = 'return-not-eligible';
          } else {
            filterClass = 'return-fee-paid';
          }
          html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row ${filterClass}">`;
          html +=
            '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';

          if (item.is_return == 3 || item.alteration_request_status != null) {
            notEligibleCount++;
          } else {
            returnFeePaidCount++;
            lastReturnItems.push({
              brand_id: item.brand_id,
              brand_name: item.brand,
              requested_date: item.requested_date,
            });
          }

          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<h6 class="card-title" style="font-size: 15px;">' + item.name + ' [SKU: ' + item.sku + ']</h6>';
          html += '<p><span><b>Price:</b> £' + item.price + '</span></p>';
          html += '<p><span><b>Ordered Qty:</b> ' + item.quantity + '</span></p>';
          html += '<p><span><b>Return Requested Qty:</b> ' + item.return_qty + '</span></p>';
          html += '</div>'; // Close col-lg-6
          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<div class="row">';
          if (item.return_request_item_status_id != 4 && item.refund_status_id != 2){
            html+=`<div class="cancel-request-wrapper">`;
              html+=`<a href="javascript:;" class="btn-cancel-request" data-cancel-request-id="${item.return_request_item_id}" style="display:none!important">Cancel Request</a>`;
                if (Array.isArray(item.images)) {
                html += `<div class="faulty-image-preview-container">`;
                item.images.forEach((imgUrl, index) => {
                  if (imgUrl) {
                    html += `
                      <a href="${imgUrl}" data-fancybox="faulty-images-${item.return_request_item_id}" data-caption="Faulty Image ${index + 1}">
                        <img src="${imgUrl}" class="faulty-preview-image" alt="Faulty Image">
                      </a>
                    `;
                  }
                });
                html += `</div>`;
              }
            html+=`</div>`;
            }

          if (restrictedCountries.includes(shippingCode)) {
                html += '<p style="padding: 0 0 5px 0;margin:0;">Please Visit <a style="padding: 0;color: #ff8080;"  href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> to download the return label. Please reach out to our support team at</p>';
                html += '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
                html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
          }else{
            if (item.is_return == 1) {
              if (item.refund_status_id == 1) {
                // Pending
                if (item.lable_type == 1) {
                  if (item.lable_type_url == 'error') {
                    html +=
                      '<p style="padding: 0 0 5px 0;margin:0;">We are sorry, but we encountered a technical issue and were unable to generate the return label. Please reach out to our support team at</p>';
                    html +=
                      '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
                    html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
                  }
                } else if (item.lable_type == 2) {
                  if (item.lable_type_url != null) {
                    if (item.lable_type_url == 'error') {
                      html +=
                        '<p style="padding: 0 0 5px 0;margin:0;">We are sorry, but we encountered a technical issue and were unable to generate the return label. Please reach out to our support team at</p>';
                      html +=
                        '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
                      html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
                    }
                  }
                } else if (item.lable_type == 3) {
                  html +=
                    '<p style="padding: 0 0 10px 0;margin:0;"><a href="' +
                    item.lable_type_url +
                    '" target="_blank" class="btn-refund-option btn-return-note">Download Return Note</a></p>';
                  html +=
                    '<p style="padding: 0 0 5px 0;margin:0;">Since you have chosen the self-ship option, please send the return note back to us at your own expense.</p>';
                } else if (item.lable_type == 6) {
                  html +=
                    '<p class="text-success mt-1" style="font-weight: 700;padding-left:0px;">Thank you for choosing to keep the item. We have processed a refund of £' +
                    item.refund_total_amount +
                    ' to your original payment method.</p>';
                }
              } else if (item.refund_status_id == 3) {
                // Declined
                html +=
                  '<p style="padding: 0 0 5px 0;margin:0;">We\'re sorry to inform you that your return request has been <strong style="color: #F44336;">Declined</strong>.</p>';
              } else if (item.refund_status_id == 6) {
                // Successful refund
                html +=
                  '<p style="padding: 0 0 5px 0;margin:0;">A refund of <strong>£' +
                  item.refund_total_amount.toFixed(2) +
                  '</strong> has been <strong style="color: #198754;">Successfully</strong> processed for <strong>' +
                  item.return_qty +
                  ' qty</strong> of this item.</p>';
              } else {
                // Approved
                html +=
                  '<p style="padding: 0 0 5px 0;margin:0;">Return has already been completed for this item with a quantity of ' +
                  item.return_qty +
                  '</p>';
              }
            } else if (item.is_return == 2 && item.lable_type == 5) {
              html +=
                '<p style="padding: 0 0 5px 0;margin:0;">We have sent you a <strong style="color: #198754;">Gift Voucher</strong> worth £' +
                item.refund_total_amount.toFixed(2) +
                '</p>';
            } else if (item.is_return == 3) {
              html +=
                '<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;">This item has already been requested for exchange, so you cannot place a return request for this item.</p>';
            } else if (item.alteration_request_status != null) {
              html +=
                '<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;">This item has already been requested for alteration, so you cannot place a return request for this item.</p>';
            }
          }

          html += '</div>'; // Close row inside col-lg-6
          html += '</div>'; // Close col-lg-6
          html += '</div>'; // Close cards
          html += '</div>'; // Close col-lg-12 returnitems
        });
        html += `</div>`;
      });

      html += `</div>
    	</div>
    </div>`;
    });
    html += `</div>`;
    return html;
  }
  // return html ends

  // exchange html start
  function processAlreadyExchangeItems(data) {
    let html = '';
    let flatCompleteLabelList = data.requested.exchange;

    // for redirection GD-2225 start
    let shippingCode = data.shipping_country_code;
    // for redirection GD-2225 ends

    html += `<div class="separator paid-items-separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px;">`;
    html += '<div class="card_badge info"><span>Already Requested for Exchange</span></div>';
    $.each(flatCompleteLabelList, function (index, returnRequest) {
      let notEligibleCount = 0;
      let returnFeePaidCount = 0;
      let classOpen = '';
      if (index == 0) {
        classOpen = 'open';
      }

      html +=
        `<div class="accordion-container paid-returns-accordion return-request-` +
        returnRequest.return_request_id +
        `">
    	<div class="accordion-item">
    		<div class="accordion-header">
    			<span class="accordion-arrow-icon accordion-arrow-up" style="">&nbsp;</span> Items Requested for Exchange on ` +
        returnRequest.requested_date +
        `
    		</div>
            <div class="accordion-body ` +
        classOpen +
        `">
            <div>`;
      if (returnRequest.return_request_status_id != 4) {
        html += `<p style="padding: 0 0 5px 0; margin: 0">
                Please download the return label using the below link and include it in
                your return parcel. Once prepared, kindly send the parcel back to us.
              </p>`;
      }

      html += `<p style="padding: 0 0 5px 0; margin: 0">
                If you have any questions or need further assistance, please don't
                hesitate to reach out to our support team at
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">
                <a style="padding: 0; color: #ff8080" href="mailto:info@goddiva.co.uk"
                  >info@goddiva.co.uk</a
                >
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">We're here to help!</p>
            </div>
          
            <p>You have selected the following items for exchange:</p>`;

      $.each(returnRequest.items, function (index, seller) {
        let notEligibleCount = 0;
        let returnFeePaidCount = 0;
        html +=
          `<div class="brand-wrapper">
                 <div data-brand-id="2" class="brand-header">
                    <h4>` +
          seller.brand +
          `</h4>
                    <div>`;

        if (restrictedCountries.includes(shippingCode)) {
          ` <p class="redirect-msg">
              Now please go to this URL <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> and generate your return label. Thanks
          </p>`
        }else{
            if (returnRequest.return_request_status_id != 4) {
                html +=
                  `<a href="` +
                  seller.label_url +
                  `"
                            target="_blank"
                            class="btn-refund-option"
                            >Download Return Label</a
                          >`;
                if (
                  seller.items &&
                  seller.items &&
                  seller.items[0].return_tracking &&
                  seller.items[0].return_tracking.tracking_id
                ) {
                  html +=
                    `<a href="` +
                    seller.qrcode_url +
                    `"
                            target="_blank"
                            class="btn-refund-option"
                            >Download QR Code</a
                          >`;
                }
          }
        }

        html += `</div>
                  </div>`;
        $.each(seller.items, function (sellerItemIndex, item) {
          let filterClass = '';
          if (item.is_return == 3 || item.alteration_request_status != null) {
            filterClass = 'return-not-eligible';
          } else {
            filterClass = 'return-fee-paid';
          }
          html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row already-requested-for-exchange">`;
          html +=
            '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';

          if (item.is_return == 3 || item.alteration_request_status != null) {
            notEligibleCount++;
          } else {
            returnFeePaidCount++;
            lastReturnItems.push({
              brand_id: item.brand_id,
              brand_name: item.brand,
              requested_date: item.requested_date,
            });
          }

          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<h6 class="card-title" style="font-size: 15px;">' + item.name + ' [SKU: ' + item.sku + ']</h6>';
          html += '<p><span><b>Price:</b> £' + item.price + '</span></p>';
          html += '<p><span><b>Ordered Qty:</b> ' + item.quantity + '</span></p>';
          html += '<p><span><b>Exchange Requested Qty:</b> ' + item.return_qty + '</span></p>';
          html += '</div>'; // Close col-lg-6
          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<div class="row">';

          if (restrictedCountries.includes(shippingCode)) {

            html += '<p style="padding: 0 0 5px 0;margin:0;">Please Visit <a style="padding: 0;color: #ff8080;"  href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> to download the return label. Please reach out to our support team at</p>';
            html += '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
            html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
            
          }else{
              if (item.is_return == 1) {
                if (item.refund_status_id == 1) {
                  // Pending
                  if (item.lable_type == 1) {
                    if (item.lable_type_url == 'error') {
                      html +=
                        '<p style="padding: 0 0 5px 0;margin:0;">We are sorry, but we encountered a technical issue and were unable to generate the return label. Please reach out to our support team at</p>';
                      html +=
                        '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
                      html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
                    }
                  } else if (item.lable_type == 2) {
                    if (item.lable_type_url != null) {
                      if (item.lable_type_url == 'error') {
                        html +=
                          '<p style="padding: 0 0 5px 0;margin:0;">We are sorry, but we encountered a technical issue and were unable to generate the return label. Please reach out to our support team at</p>';
                        html +=
                          '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
                        html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
                      }
                    }
                  }
                } else if (item.refund_status_id == 3) {
                  // Declined
                  html +=
                    '<p style="padding: 0 0 5px 0;margin:0;">We\'re sorry to inform you that your exchange request has been <strong style="color: #F44336;">Declined</strong>.</p>';
                } else {
                  // Approved
                  html +=
                    '<p style="font-weight: 700; color: #198754;padding-left:0px;">Exchange Already Completed From ' +
                    item.exchange_order +
                    ' with quantity ' +
                    item.return_qty +
                    '</p>';
                }
              }
          }

          html += '</div>'; // Close row inside col-lg-6
          html += '</div>'; // Close col-lg-6
          html += '</div>'; // Close cards
          html += '</div>'; // Close col-lg-12 returnitems
        });
        html += `</div>`;
      });

      html += `</div>
    	</div>
    </div>`;
    });
    html += `</div>`;
    return html;
  }

  function alreadyRequestedForExchange(data, action_type) {
    let html = '';
    html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
    var counter = 0;
    $.each(data, function (index, item) {
      let handlelizedActionType = action_type
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '');
      html +=
        `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 exchangeitems filter-row already-requested-for-` +
        handlelizedActionType +
        `">` +
        '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
        item.id +
        '" data-item-price="' +
        item.price +
        '" data-item-gross-price="' +
        item.gross_price +
        '" data-item-store-credit-percentage="' +
        item.store_credit_percentage +
        '" data-item-refund-percentage="' +
        item.refund_percentage +
        '" data-item-store-credit-single-amount="' +
        item.store_credit_single_amount +
        '" data-item-refund-single-amount="' +
        item.refund_single_amount +
        '">';
      if (counter == 0) {
        html += '<div class="card_badge info"><span>Already requested for ' + action_type + '</span></div>';
      }
      html += '<div class="col-md-1">';
      html +=
        '<div class="product-img">' +
        '<img class="card-img-top card-img" src="' +
        item.image +
        '" style="object-fit: cover;" alt="' +
        item.name +
        '">' +
        '</div>' +
        '</div>' +
        '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">' +
        '<div class="row">' +
        '<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">' +
        '<h6 class="card-title" style="font-size: 15px;">' +
        item.name +
        ' - ' +
        item.color +
        '-' +
        item.size +
        '</h6>' +
        '<span>SKU: ' +
        item.sku +
        '</span>' +
        '<br/><span><b>Qty:</b> ' +
        item.quantity +
        '</span>' +
        '<br/><span><b>Price:</b> £' +
        item.price +
        '</span>' +
        '<br/><span data-brand="' +
        item.brand +
        '">Brand: ' +
        item.brand +
        '</span>' +
        '<p>' +
        '<b>Tracking Company:</b> ' +
        item.tracking_name +
        '<br>' +
        '<b>Tracking Id:</b> ' +
        item.tracking_id +
        '</p>' +
        '</div>' +
        '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">' +
        '<div class="row">';
      if (item.is_return == 3) {
        // Item already exchanged
        if (item.refund_status_id == 1) {
          // Pending
          html +=
            '<p style="font-weight: 700; color: #F44336;padding-left:0px;">Exchange Already Requested From ' +
            item.exchange_order +
            ' with quantity ' +
            item.return_qty +
            '</p>';
          if (item.lable_type_url != 'error') {
            html += `<a href="` + item.lable_type_url + `" class="btnurls" target="_blank">Download Label</a>`;
          }
          if (item.qrcode_url != 'error') {
            html += `<a href="` + item.qrcode_url + `" class="btnurls" target="_blank">Download QR Code</a>`;
          }
        } else if (item.refund_status_id == 3) {
          // Declined
          html +=
            '<p style="font-weight: 700; color: #F44336;padding-left:0px;">Your exchange request is declined.</p>';
        } else {
          html +=
            '<p style="font-weight: 700; color: #198754;padding-left:0px;">Exchange Already Completed From ' +
            item.exchange_order +
            ' with quantity ' +
            item.return_qty +
            '</p>';
        }
      }
      html += '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      counter++;
    });
    html += `</div>`;
    return html;
  }

  function pendingExchangeItems(data) {
    let html = '';
    $.each(data.not_requested, function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;

      $.each(seller.items, function (itemIndex, item) {
        html +=
          '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 exchangeitems filter-row eligible-for-exchange">' +
          '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" ' +
          'data-item-price="' +
          item.price +
          '" ' +
          'data-item-gross-price="' +
          item.gross_price +
          '" ' +
          'data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" ' +
          'data-item-refund-percentage="' +
          item.refund_percentage +
          '" ' +
          'data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" ' +
          'data-item-refund-single-amount="' +
          item.refund_single_amount +
          '">';

        if (itemIndex === 0) {
          html +=
            '<div class="card_badge success"><span>Not Requested for Exchange - ' + seller.brand + '</span></div>';
        }

        // Left column with image + checkbox
        html += '<div class="col-md-1">';
        if (data.is_active_date == 1) {
          if (item.can_exchange == 1 && !item.product_tags.includes('outlet') && item.is_gift_bag === false) {
            html +=
              '<div class="controls flex-row-reverse">' +
              '<i class="material-icons"></i>' +
              '<i class="material-icons">' +
              '<input class="form-check-input exchange-checkbox checkbox" data-line-item-id="' +
              item.id +
              '" style="font-size: 1.5rem;display: block" type="checkbox" id="checkboxNoLabel" value="" aria-label="...">' +
              '</i>' +
              '</div>';
          }
        }
        html +=
          '<div class="product-img">' +
          '<img class="card-img-top card-img" src="' +
          item.image +
          '" style="object-fit: cover;" alt="' +
          item.name +
          '">' +
          '</div>' +
          '</div>';

        // Right column
        html += '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">' + '<div class="row">';
        // Normal item → show full details + form
        html +=
          '<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">' +
          '<h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>' +
          '<span>SKU: ' +
          item.sku +
          '</span>' +
          '<br/><span><b>Qty:</b> ' +
          item.quantity +
          '</span>' +
          '<br/><span><b>Price:</b> £' +
          item.price +
          '</span>' +
          '<br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>' +
          '<p>' +
          '<b>Tracking Company:</b> ' +
          item.tracking_name +
          '<br>' +
          '<b>Tracking Id:</b> ' +
          item.tracking_id +
          '</p>' +
          '</div>' +
          '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">' +
          '<div class="row">';
        if (item.is_gift_bag === true) {
          // Gift bag → only show message
          html +=
            '<p class="gift-bag-msg text-danger mt-1" style="font-weight: 700; font-size: 15px" data-line-item-id="' +
            item.id +
            '">The promotional bag can’t be exchanged.</p>';
        } else {
          if (data.is_active_date == 1) {
            if (item.can_exchange == 1) {
              if (seller.seller_id == 60) {
                // Not returnable message only
                html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">For hygiene reasons, we are unable to accept exchange on beauty products, ranging from pierced jewellery, make-up, skin care, fragrances, hair products and anything that can be applied to the skin or body. In addition, we will be unable to accept returns on face masks, lingerie & swimwear</p>
                <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
                <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
                <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
              `;
              } else if(item.is_mystery){
                // Not returnable message only
                html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">This is a Mystery Box product, and as per our return policy, Mystery Box items are non-exchangable.</p>
                  <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
                  <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
                  <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
                `;
              } else {
                html +=
                  '<input type="hidden" name="is_same_size" class="is_same_size" data-line-item-id="' +
                  item.id +
                  '" value="">';

                if (item.variants.length > 0) {
                  html +=
                    '<div class="col-lg-2 col-md-4 col-sm-12 col-xs-12" id="exchange-quantity">\
                          <label>Quantity</label>\
                          <div class="input-container">\
                            <button class="minus-btn"></button>\
                            <input type="number" style="font-size: 14px !important;" class="form-control quantity" placeholder="Quantity" data-size="' +
                    item.color +
                    ' / ' +
                    item.size +
                    '" min="1" max="' +
                    item.availableQty +
                    '" oninput="validity.valid||(value=\'\');" data-max-qty="' +
                    item.quantity +
                    '" data-line-item-id="' +
                    item.id +
                    '" value="1">\
                            <button class="plus-btn"></button>\
                          </div>\
                        </div>';
                }

                if (item.variants.length > 0) {
                  html +=
                    '<div class="col-md-3">\
                          <label>Available Option <span class="mandatory">*</span></label>\
                          <select name="available_option" class="form-select mb-1 available_option" data-size="' +
                    item.color +
                    ' / ' +
                    item.size +
                    '" data-line-item-id="' +
                    item.id +
                    '" data-product="' +
                    item.name +
                    '" data-brand="' +
                    item.brand +
                    '" aria-label="Reason">\
                            <option value="-1" selected disabled>Select Option</option>';

                  item.variants.forEach(function (variant) {
                    html +=
                      '<option data-variant-id="' +
                      variant.id +
                      '" value="' +
                      variant.value +
                      '">' +
                      variant.value +
                      '</option>';
                  });

                  html +=
                    '</select>\
                        </div>\
                        <div class="col-md-6">\
                          <label>Reason <span class="mandatory">*</span></label>\
                          <select id="exchange-reason-' +
                    item.id +
                    '" name="search_type" class="form-select mb-1 exchange-reason" data-size="' +
                    item.color +
                    ' / ' +
                    item.size +
                    '" data-line-item-id="' +
                    item.id +
                    '" data-product="' +
                    item.name +
                    '" data-brand="' +
                    item.brand +
                    '" aria-label="Reason">\
                            <option value="-1" selected disabled>Select Reason</option>';

                  data.exchange_reasons.forEach(function (reason) {
                    html += '<option value="' + reason.id + '">' + reason.name + '</option>';
                  });

                  html +=
                    '</select>\
                          <div class="other-message" data-line-item-id="' +
                    item.id +
                    '"></div>\
                          <div class="">\
                            <textarea class="form-control mb-1 specific-reason exchange-sp-reason" placeholder="Leave a specific reason here" maxlength="150" data-line-item-id="' +
                    item.id +
                    '" style="display: none;"></textarea>\
                          </div>\
                        </div>';
                } else {
                  html +=
                    '<label for="select-reason" style="font-size: 13px; font-weight: 600; height: 85px; padding-top: 20px;">Another product option not available <span class="text-danger"></span></label>';
                }

                html +=
                  '<p class="text-danger mt-1 type-error" data-line-item-id="' +
                  item.id +
                  '" style="font-size: 15px !important;">*Quantity cannot exceed available to return quantity - [' +
                  item.availableQty +
                  ']</p>';
                html +=
                  '<p class="text-danger mt-1 error" data-line-item-id="' +
                  item.id +
                  '" style="font-size: 15px !important;">*Please fill all fields</p>';
              }
            }
          } else {
            html +=
              '<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">The exchange period has passed, please contact customer service at <a href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
          }
        }

        html += '</div></div>'; // close row and col-8

        html += '</div></div></div></div>'; // close row, cols, card
      });

      html += `</div>`; // separator
    });

    return html;
  }
  //exchange html ends

  // alteration html start
  function processAlreadyAlterationItems(data) {
    let html = '';
    let flatCompleteLabelList = data.requested.alteration;

    // for redirection GD-2225 start
    let shippingCode = data.shipping_country_code;
    // for redirection GD-2225 ends

    html += `<div class="separator paid-items-separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px;">`;
    html += '<div class="card_badge info"><span>Already Requested for Alteration</span></div>';
    $.each(flatCompleteLabelList, function (index, returnRequest) {
      let notEligibleCount = 0;
      let returnFeePaidCount = 0;
      let classOpen = '';
      if (index == 0) {
        classOpen = 'open';
      }

      html +=
        `<div class="accordion-container paid-returns-accordion return-request-` +
        returnRequest.return_request_id +
        `">
    	<div class="accordion-item">
    		<div class="accordion-header">
    			<span class="accordion-arrow-icon accordion-arrow-up" style="">&nbsp;</span> Items Requested for Alteration on ` +
        returnRequest.requested_date +
        `
    		</div>
            <div class="accordion-body ` +
        classOpen +
        `">
            <div>`;
      if (returnRequest.return_request_status_id != 4) {
        html += `<p style="padding: 0 0 5px 0; margin: 0">
                Please download the return label using the below link and include it in
                your return parcel. Once prepared, kindly send the parcel back to us.
              </p>`;
      }

      html += `<p style="padding: 0 0 5px 0; margin: 0">
                If you have any questions or need further assistance, please don't
                hesitate to reach out to our support team at
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">
                <a style="padding: 0; color: #ff8080" href="mailto:info@goddiva.co.uk"
                  >info@goddiva.co.uk</a
                >
              </p>
              <p style="padding: 0 0 10px 0; margin: 0">We're here to help!</p>
            </div>
          
            <p>You have selected the following items for exchange:</p>`;

      $.each(returnRequest.items, function (index, seller) {
        let notEligibleCount = 0;
        let returnFeePaidCount = 0;
        html +=
          `<div class="brand-wrapper">
                 <div data-brand-id="2" class="brand-header">
                    <h4>` +
          seller.brand +
          `</h4>
                    <div>`;

        if (restrictedCountries.includes(shippingCode)) {
          ` <p class="redirect-msg">
              Now please go to this URL <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> and generate your return label. Thanks
          </p>`
        }else{
            if (returnRequest.return_request_status_id != 4) {
                html +=
                  `<a href="` +
                  seller.label_url +
                  `"
                            target="_blank"
                            class="btn-refund-option"
                            >Download Return Label</a
                          >`;
                if (
                  seller.items &&
                  seller.items &&
                  seller.items[0].return_tracking &&
                  seller.items[0].return_tracking.tracking_id
                ) {
                  html +=
                    `<a href="` +
                    seller.qrcode_url +
                    `"
                            target="_blank"
                            class="btn-refund-option"
                            >Download QR Code</a
                          >`;
                }
              }
        }

        html += `</div>
                  </div>`;
        $.each(seller.items, function (sellerItemIndex, item) {
          let filterClass = '';
          if (item.is_return == 3 || item.alteration_request_status != null) {
            filterClass = 'return-not-eligible';
          } else {
            filterClass = 'return-fee-paid';
          }
          html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 returnitems filter-row already-requested-for-alteration">`;
          html +=
            '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';

          if (item.is_return == 3 || item.alteration_request_status != null) {
            notEligibleCount++;
          } else {
            returnFeePaidCount++;
            lastReturnItems.push({
              brand_id: item.brand_id,
              brand_name: item.brand,
              requested_date: item.requested_date,
            });
          }

          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<h6 class="card-title" style="font-size: 15px;">' + item.name + ' [SKU: ' + item.sku + ']</h6>';
          html += '<p><span><b>Price:</b> £' + item.price + '</span></p>';
          html += '<p><span><b>Ordered Qty:</b> ' + item.quantity + '</span></p>';
          html += '<p><span><b>Alteration Requested Qty:</b> ' + item.return_qty + '</span></p>';
          html += '</div>'; // Close col-lg-6
          html += '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">';
          html += '<div class="row">';

          if (restrictedCountries.includes(shippingCode)) {

            html += '<p style="padding: 0 0 5px 0;margin:0;">Please Visit <a style="padding: 0;color: #ff8080;"  href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> to download the return label. Please reach out to our support team at</p>';
            html += '<p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>';
            html += '<p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>';
            
          }else{
            if (item.alteration_request_status != null) {
              html +=
                '<div class="col-lg-12">\
                          <p><b>Alteration Request Status:</b> ' +
                item.alteration_request_status +
                '</p>\
                          <p><b>Requested Quantity:</b> ' +
                (item.alteration_request_quantity || 'N/A') +
                '</p>\
                          <p><b>Requested Length (in cm):</b> ' +
                item.alteration_request_length +
                '</p>';
              if (item.alteration_request_note && item.alteration_request_note.trim() !== '') {
                html += '<p><b>Note:</b> ' + item.alteration_request_note + '</p>';
              }
              if (item.alteration_request_trackings && item.alteration_request_trackings.length > 0) {
                html += `<div class="alteration-tracking"><p>Tracking Details:</p>`;
                item.alteration_request_trackings.forEach((tracking) => {
                  const trackingLink = `<a style="color: #ff8080;" href="${tracking.tracking_url}" target="_blank">${tracking.tracking_name} (ID: ${tracking.tracking_id})</a>`;
                  //console.log(trackingLink);
                  html += trackingLink;
                });
                html += `</div>`;
              }
              html += '</div>';
            }
          }

          html += '</div>'; // Close row inside col-lg-6
          html += '</div>'; // Close col-lg-6
          html += '</div>'; // Close cards
          html += '</div>'; // Close col-lg-12 returnitems
        });
        html += `</div>`;
      });

      html += `</div>
    	</div>
    </div>`;
    });
    html += `</div>`;
    return html;
  }

  function pendingAlterationItems(data) {
    let html = '';
    let goddiva_items_count = 0;
    $.each(data.not_requested, function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
      $.each(seller.items, function (itemIndex, item) {
        if (item.is_goddiva) {
          html +=
            '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 alterationitems filter-row eligible-for-alteration">\
                          <div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';
          if (goddiva_items_count === 0) {
            html +=
              '<div class="card_badge success"><span>Not Requested for Alteration - ' + seller.brand + '</span></div>';
          }
          html += '<div class="col-md-1">';
          if (item.can_alteration_request == 1 && item.is_gift_bag === false) {
            if(item.is_mystery){
                html += '';
              } else{
                  html +=
                    '<div class="controls flex-row-reverse">\
                                  <i class="material-icons"></i>\
                                  <i class="material-icons">\
                                      <input class="form-check-input alteration-checkbox checkbox" data-line-item-id="' +
                    item.id +
                    '" style="font-size: 1.5rem;display: block" type="checkbox" id="checkboxNoLabel" value="" aria-label="...">\
                                  </i>\
                              </div>';
              }
          }

          html +=
            '<div class="product-img">\
                        <img class="card-img-top card-img" src="' +
            item.image +
            '"  style="object-fit: cover;" alt="' +
            item.name +
            '">\
                     </div>\
                   </div>';

          html +=
            '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
                          <div class="row">\
                              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
                                  <h6 class="card-title" style="font-size: 15px;">' +
            item.name +
            ' - ' +
            item.color +
            '-' +
            item.size +
            '</h6>\
                                  <span>SKU: ' +
            item.sku +
            '</span>\
                                  <br/><span>\
                                      <b>Qty:</b> ' +
            item.quantity +
            '\
                                  </span>\
                                   <br/><span>\
                                      <b>Price:</b> £' +
            item.price +
            '\
                                  </span>\
                                  <br/><span data-brand="' +
            item.brand +
            '">Brand: ' +
            item.brand +
            '</span>\
                                  <p>\
                                      <b>Tracking Company:</b> ' +
            item.tracking_name +
            ' <br>\
                                      <b>Tracking Id:</b> ' +
            item.tracking_id +
            '\
                                  </p>\
                              </div>';

          html +=
            '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">\
                        <div class="row">';
          if (item.is_gift_bag === true) {
            // Gift bag → only show message
            html +=
              '<p class="gift-bag-msg text-danger mt-1" style="font-weight: 700; font-size: 15px" data-line-item-id="' +
              item.id +
              '">The promotional bag can’t be alter.</p>';
          } else {
            if (data.is_active_date == 1) {
              if (item.can_alteration_request == 1) {
                  if(item.is_mystery){
                    // Not returnable message only
                    html += `<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px;padding: 0 0 5px 0;margin:0;">This is a Mystery Box product, it cannot be altered.</p>
                      <p style="padding: 0 0 5px 0;margin:0;">If you have any questions or concerns, feel free to reach out to our Customer Service team at</p>
                      <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a>.</p>
                      <p style="padding: 0 0 10px 0;margin:0;">We’ll be happy to assist you.</p>
                    `;
                  } else {
                      html +=
                        '<input type="hidden" name="is_same_size" class="is_same_size" data-line-item-id="' +
                        item.id +
                        '" value="">';

                      html +=
                        '<div class="col-lg-2 col-md-4 col-sm-12 col-xs-12" style="">\
                                  <label>Quantity</label>\
                                  <div class="input-container">\
                                  <button class="minus-btn"> </button>\
                                  <input type="number" style="font-size: 14px !important;" class="form-control quantity"  min="1" max="' +
                        item.availableQty +
                        '" oninput="validity.valid||(value=\'\');" data-max-qty="' +
                        item.quantity +
                        '" data-line-item-id="' +
                        item.id +
                        '" value="1">\
                                  <button class="plus-btn"> </button>\
                                  </div>\
                                </div>';

                      html +=
                        '<div class="col-lg-3 col-md-4 col-sm-12 col-xs-12" style="">\
                                  <label style="text-transform:none">Amount to be removed from the hem (in CM) <span class="mandatory">*</span></label>\
                                  <input type="number" style="font-size: 14px !important;" class="form-control length-input" placeholder="Length" min="1" max="30" data-line-item-id="' + item.id + '">\
                                  <p style="color:red;">Please enter a value between 1 and 30 cm.</p>\
                          </div>';

                      html +=
                        '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="">\
                                  <label style="text-transform:none">Note</label>\
                                  <textarea class="form-control alteration-note" maxlength="1000" data-line-item-id="' +
                        item.id +
                        '" placeholder="Enter Notes" style="height:150px !important"></textarea>\
                                  <p class="alterationremaining" data-line-item-id="' +
                        item.id +
                        '">1000 character remaining</p>\
                                </div>';
                      html +=
                        '<p class="text-danger mt-1 error" data-line-item-id="' +
                        item.id +
                        '" style="font-size: 15px !important;display:none">*Please fill all fields</p>';
                    }
              }
            } else {
              html +=
                '<p class="text-danger mt-1"  style="font-weight: 700; font-size: 15px">The alteration period has passed, please contact customer service at <a href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
            }
          }

          html +=
            '</div>\
                       </div>\
                       </div>\
                       </div>\
                       </div>\
                    </div>';
          goddiva_items_count++;
        }
      });
      html += `</div>`;
    });
    return html;
  }

  function pendingOutletAlterationItems(data) {
    let html = '';
    let goddiva_items_count = 0;
    $.each(data.outlet || [], function (index, seller) {
      html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;

      $.each(seller.items || [], function (itemIndex, item) {
        if (item.is_goddiva) {
          html +=
            '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 alterationitems filter-row eligible-for-alteration">\
                    <div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
            item.id +
            '" data-item-price="' +
            item.price +
            '" data-item-gross-price="' +
            item.gross_price +
            '" data-item-store-credit-percentage="' +
            item.store_credit_percentage +
            '" data-item-refund-percentage="' +
            item.refund_percentage +
            '" data-item-store-credit-single-amount="' +
            item.store_credit_single_amount +
            '" data-item-refund-single-amount="' +
            item.refund_single_amount +
            '">';

          // Badge only once per seller block
          if (goddiva_items_count === 0) {
            html +=
              '<div class="card_badge success"><span>Not Requested for Alteration (Outlet) - ' +
              seller.brand +
              '</span></div>';
          }

          html += '<div class="col-md-1">';

          if (item.can_alteration_request == 1 && item.is_gift_bag === false) {
            html +=
              '<div class="controls flex-row-reverse">\
                    <i class="material-icons"></i>\
                    <i class="material-icons">\
                        <input class="form-check-input alteration-checkbox checkbox" data-line-item-id="' +
              item.id +
              '" style="font-size: 1.5rem;display: block" type="checkbox" id="checkboxNoLabel" value="" aria-label="...">\
                    </i>\
                 </div>';
          }

          html +=
            '<div class="product-img">\
                  <img class="card-img-top card-img" src="' +
            item.image +
            '" style="object-fit: cover;" alt="' +
            item.name +
            '">\
               </div>\
             </div>';

          html +=
            '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
                  <div class="row">\
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
                      <h6 class="card-title" style="font-size: 15px;">' +
            item.name +
            ' - ' +
            item.color +
            '-' +
            item.size +
            '</h6>\
                      <span>SKU: ' +
            item.sku +
            '</span>\
                      <br/><span><b>Qty:</b> ' +
            item.quantity +
            '</span>\
                      <br/><span><b>Price:</b> £' +
            item.price +
            '</span>\
                      <br/><span data-brand="' +
            item.brand +
            '">Brand: ' +
            item.brand +
            '</span>\
                      <p>\
                        <b>Tracking Company:</b> ' +
            item.tracking_name +
            ' <br>\
                        <b>Tracking Id:</b> ' +
            item.tracking_id +
            '\
                      </p>\
                    </div>';

          html +=
            '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">\
                 <div class="row">';

          if (item.is_gift_bag === true) {
            // Gift bag → only show message
            html +=
              '<p class="gift-bag-msg text-danger mt-1" style="font-weight: 700; font-size: 15px" data-line-item-id="' +
              item.id +
              '">The promotional bag can’t be alter.</p>';
          } else {
            if (data.is_active_date == 1) {
              if (item.can_alteration_request == 1) {
                html +=
                  '<input type="hidden" name="is_same_size" class="is_same_size" data-line-item-id="' +
                  item.id +
                  '" value="">';

                html +=
                  '<div class="col-lg-2 col-md-4 col-sm-12 col-xs-12">\
                       <label>Quantity</label>\
                       <div class="input-container">\
                         <button class="minus-btn"> </button>\
                         <input type="number" style="font-size: 14px !important;" class="form-control quantity" min="1" max="' +
                  item.availableQty +
                  '" oninput="validity.valid||(value=\'\');" data-max-qty="' +
                  item.quantity +
                  '" data-line-item-id="' +
                  item.id +
                  '" value="1">\
                         <button class="plus-btn"> </button>\
                       </div>\
                     </div>';

                html +=
                  '<div class="col-lg-3 col-md-4 col-sm-12 col-xs-12">\
                       <label style="text-transform:none">Amount to be removed from the hem (in CM) <span class="mandatory">*</span></label>\
                       <input type="number" style="font-size: 14px !important;" class="form-control length-input" placeholder="Length" min="1" max="30" data-line-item-id="' + item.id + '">\
                       <p style="color:red;">Please enter a value between 1 and 30 cm.</p>\
                     </div>';

                html +=
                  '<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">\
                       <label style="text-transform:none">Note</label>\
                       <textarea class="form-control alteration-note" maxlength="1000" data-line-item-id="' +
                  item.id +
                  '" placeholder="Enter Notes" style="height:150px !important"></textarea>\
                       <p class="alterationremaining" data-line-item-id="' +
                  item.id +
                  '">1000 character remaining</p>\
                     </div>';

                html +=
                  '<p class="text-danger mt-1 error" data-line-item-id="' +
                  item.id +
                  '" style="font-size: 15px !important;display:none">*Please fill all fields</p>';
              }
            } else {
              html +=
                '<p class="text-danger mt-1" style="font-weight: 700; font-size: 15px">The alteration period has passed, please contact customer service at <a href="mailto:info@goddiva.co.uk"> info@goddiva.co.uk</a> for more information.</p>';
            }
          }

          html +=
            '   </div>\
                  </div>\
                </div>\
              </div>\
            </div>';

          goddiva_items_count++;
        }
      });

      html += `</div>`;
    });

    return html;
  }

  function alreadyRequestedForAlteration(data, action_type, status) {
    let html = '';
    html += `<div class="separator" style="border: 1px solid #ccc;margin:10px 0px;padding:2px">`;
    var counter = 0;
    $.each(data, function (index, item) {
      if (item.is_goddiva) {
        let handlelizedActionType = action_type
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]+/g, '');
        html += `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 alterationitems filter-row already-requested-for-${handlelizedActionType} alteration-${item.alteration_request_status}">`;
        html +=
          '<div class="cards row" style="margin-bottom: 5px; border-radius:3px !important;" id="card-' +
          item.id +
          '" data-item-price="' +
          item.price +
          '" data-item-gross-price="' +
          item.gross_price +
          '" data-item-store-credit-percentage="' +
          item.store_credit_percentage +
          '" data-item-refund-percentage="' +
          item.refund_percentage +
          '" data-item-store-credit-single-amount="' +
          item.store_credit_single_amount +
          '" data-item-refund-single-amount="' +
          item.refund_single_amount +
          '">';

        if (counter == 0) {
          if (action_type == 'Alteration') {
            html += `<div class="card_badge info"><span>${action_type} - Status: ${item.alteration_request_status}</span></div>`;
          } else {
            html += '<div class="card_badge info"><span>Already requested for ' + action_type + '</span></div>';
          }
        }

        html += '<div class="col-md-1">';
        html +=
          '<div class="product-img">\
                  <img class="card-img-top card-img" src="' +
          item.image +
          '"  style="object-fit: cover;" alt="' +
          item.name +
          '">\
               </div>\
             </div>';

        html +=
          '<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">\
                    <div class="row">\
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">\
                            <h6 class="card-title" style="font-size: 15px;">' +
          item.name +
          ' - ' +
          item.color +
          '-' +
          item.size +
          '</h6>\
                            <span>SKU: ' +
          item.sku +
          '</span>\
                            <br/><span>\
                                <b>Qty:</b> ' +
          item.quantity +
          '\
                            </span>\
                            <br/><span>\
                                <b>Price:</b> £' +
          item.price +
          '\
                            </span>\
                            <br/><span data-brand="' +
          item.brand +
          '">Brand: ' +
          item.brand +
          '</span>\
                            <p>\
                                <b>Tracking Company:</b> ' +
          item.tracking_name +
          ' <br>\
                                <b>Tracking Id:</b> ' +
          item.tracking_id +
          '\
                            </p>\
                        </div>';

        html +=
          '<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-2" style="padding-top:2px;">\
                  <div class="row">';
        if (item.alteration_request_status != null) {
          html +=
            '<div class="col-lg-12">\
                        <p><b>Alteration Request Status:</b> ' +
            item.alteration_request_status +
            '</p>\
                        <p><b>Requested Quantity:</b> ' +
            (item.alteration_request_quantity || 'N/A') +
            '</p>\
                        <p><b>Requested Length (in cm):</b> ' +
            item.alteration_request_length +
            '</p>';
          if (item.alteration_request_note && item.alteration_request_note.trim() !== '') {
            html += '<p><b>Note:</b> ' + item.alteration_request_note + '</p>';
          }
          if (item.alteration_request_trackings && item.alteration_request_trackings.length > 0) {
            html += `<div class="alteration-tracking"><p>Tracking Details:</p>`;
            item.alteration_request_trackings.forEach((tracking) => {
              const trackingLink = `<a style="color: #ff8080;" href="${tracking.tracking_url}" target="_blank">${tracking.tracking_name} (ID: ${tracking.tracking_id})</a>`;
              //console.log(trackingLink);
              html += trackingLink;
            });
            html += `</div>`;
          }
          if (item.alteration_request_status == 'Pending' && item.return_tracking && item.return_tracking.label_url) {
            html += `<a href="${item.return_tracking.label_url}" target="_blank" class="btn-alter-label">Download Retun Label</a>`;
          }
          if (item.alteration_request_status == 'Pending' && item.return_tracking && item.return_tracking.qrcode_url) {
            html += `<a href="${item.return_tracking.qrcode_url}" target="_blank" class="btn-alter-label">Download QR Code</a>`;
          }
          if (
            item.alteration_request_status == 'Pending' &&
            item.return_tracking &&
            (item.return_tracking.qrcode_url || item.return_tracking.label_url)
          ) {
            html += `<p style="padding: 10px 0 5px 0;margin:0;">Please download the return label using the above button and include it in your return parcel.If you have any questions or need further assistance, please don't hesitate to reach out to our support team at</p>
                                 <p style="padding: 0 0 10px 0;margin:0;"><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>
                                 <p style="padding: 0 0 10px 0;margin:0;">We’re here to help!</p>`;
          }
          html += '</div>';
        }
        html +=
          '</div>\
                 </div>\
                 </div>\
                 </div>\
                 </div>\
              </div>';
        counter++;
      }
    });
    html += `</div>`;
    return html;
  }

  // alteration html ends
  groupedData = null;
  function showPaymentPopup(response, returnItems, data) {
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const year = String(date.getFullYear()); // Get full year
      const hours = String(date.getHours() % 12 || 12).padStart(2, '0'); // Format hour in 12-hour format
      const minutes = String(date.getMinutes()).padStart(2, '0'); // Get minutes
      const seconds = String(date.getSeconds()).padStart(2, '0'); // Get seconds
      const ampm = date.getHours() >= 12 ? 'PM' : 'AM'; // Determine AM or PM

      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    }
    groupedData = null;
    jQuery('#PaymentPopup .close-button').removeAttr('data-reload-search');

    // Parse and generate HTML content
    var accordionContainer = $('#payment-content-wrapper');
    accordionContainer.html('');

    accordionContainer.append('<h3>Summary</h3>');

    // Return Summary
    if (
      response.return_label_response &&
      response.return_label_response.items &&
      response.return_label_response.items.length > 0
    ) {
      // Create accordion item
      let accordionItem = $('<div class="accordion-item"></div>');

      // Create accordion header
      let accordionHeader = $('<div class="accordion-header"></div>');
      accordionHeader.html('<span class="accordion-arrow-icon accordion-arrow-up">&nbsp;</span> Return Items Summary');
      let accordionBody = $('<div class="accordion-body" style="display: block;"></div>');

      // Add click event to toggle accordion body
      accordionHeader.click(function () {
        // Toggle arrow direction
        $(this).find('.accordion-arrow-icon').toggleClass('accordion-arrow-down accordion-arrow-up');
        $(this).next('.accordion-body').slideToggle();
      });

      if (response.return_label_response.error == false) {
        accordionBody.append(
          '<p>A return fee of £' + data.return_fee + ' is required before you can download the return label.</p>'
        );
        accordionBody.append(
          '<p>Once you make this one-time payment, a return label will be provided for each brand.</p>'
        );
        accordionBody.append(
          '<p>Requested Date : ' + formatDate(response.return_label_response.requested_date) + ' </p>'
        );
      } else {
        accordionBody.append(
          '<p>We are sorry to inform you that your return request could not be processed. Please reach out to our support team at </p>'
        );
        accordionBody.append(
          '<p><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>'
        );
        accordionBody.append('<p>We’re here to help!</p>');
      }

      accordionBody.append('<p>You have selected the following items for return:</p>');

      groupedData = response.return_label_response.items.reduce((acc, item) => {
        // Check if the brand_id already exists in the accumulator
        let brandGroup = acc.find((group) => group.brand_id === item.brand_id);

        if (!brandGroup) {
          // If the brand group doesn't exist, create it
          brandGroup = {
            brand_id: item.brand_id,
            brand_name: item.brand_name,
            items: [],
          };
          acc.push(brandGroup);
        }

        // Add the item to the brand's items array
        brandGroup.items.push(item);
        return acc;
      }, []);

      groupedData.forEach(function (brandGroup) {
        // Append brand name
        accordionBody.append('<h4 data-brand-id="' + brandGroup.brand_id + '">' + brandGroup.brand_name + '</h4>');

        // Create SKU list under each brand
        let skuList = $('<ul class="sku-list" data-brand-id="' + brandGroup.brand_id + '"></ul>');
        brandGroup.items.forEach(function (item) {
          let skuItem = $('<li data-lineitem-id="' + item.line_item_id + '"></li>');
          skuItem.html(item.sku + ' (Qty: ' + item.quantity + ')');
          skuList.append(skuItem);
        });
        accordionBody.append(skuList);
      });

      accordionBody.append(
        '<p>Please click the button below to complete the payment and proceed with your return.</p>'
      );
      accordionBody.append(
        '<p style="margin-top: 15px; text-align: center;"><a class="pay-now-button" rel="noopener noreferrer" data-index="0" target="_blank" href="' +
          response.return_label_response.invoice_url +
          '" data-return-request-id="' +
          response.return_label_response.returnRequestId +
          '">Pay Now</a></p>'
      );

      // Append header and body to accordion item
      accordionItem.append(accordionHeader);
      accordionItem.append(accordionBody);

      // Append each accordion item to container
      accordionContainer.append(accordionItem);
    }

    // Self Ship Summary
    if (
      response.self_ship_response &&
      response.self_ship_response.items &&
      response.self_ship_response.items.length > 0
    ) {
      // Create accordion item
      let accordionItem = $('<div class="accordion-item"></div>');
      let accordionBody = $('<div class="accordion-body"></div>');

      // Create accordion header
      let accordionHeader = $('<div class="accordion-header"></div>');
      accordionHeader.html('<span class="accordion-arrow-icon accordion-arrow-down">&nbsp;</span> Self Ship Summary');

      // Add click event to toggle accordion body
      accordionHeader.click(function () {
        // Toggle arrow direction
        $(this).find('.accordion-arrow-icon').toggleClass('accordion-arrow-down accordion-arrow-up');
        $(this).next('.accordion-body').slideToggle();
      });

      if (response.self_ship_response.error == false) {
        accordionBody.append('<p>Requested Date : ' + formatDate(response.self_ship_response.requested_date) + ' </p>');
      } else {
        accordionBody.append(
          '<p>We are sorry to inform you that the items selected for Self Ship could not be processed. Please reach out to our support team at </p>'
        );
        accordionBody.append(
          '<p><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>'
        );
        accordionBody.append('<p>We’re here to help!</p>');
      }

      accordionBody.append('<p>You have selected the following items for self ship:</p>');
      accordionBody.append('<ul class="sku-list">');

      // Create SKU list
      let skuList = $('<ul class="sku-list"></ul>');
      response.self_ship_response.items.forEach(function (item) {
        let skuItem = $('<li></li>');
        skuItem
          .html(item.sku + '(Qty: ' + item.quantity + ')')
          .append(
            ` | <a href="${item.return_note_url}" target="_blank" style="color: #ff8080;">Download Return Note</a>`
          );
        skuList.append(skuItem);
      });
      accordionBody.append(skuList);

      // Append header and body to accordion item
      accordionItem.append(accordionHeader);
      accordionItem.append(accordionBody);

      // Append each accordion item to container
      accordionContainer.append(accordionItem);
    }

    // Store Credit Summary
    if (
      response.store_credit_response &&
      response.store_credit_response.items &&
      response.store_credit_response.items.length > 0
    ) {
      // Create accordion item
      let accordionItem = $('<div class="accordion-item"></div>');
      let accordionBody = $('<div class="accordion-body"></div>');

      // Create accordion header
      let accordionHeader = $('<div class="accordion-header"></div>');
      accordionHeader.html(
        '<span class="accordion-arrow-icon accordion-arrow-down">&nbsp;</span> Store Credit Summary'
      );

      // Add click event to toggle accordion body
      accordionHeader.click(function () {
        // Toggle arrow direction
        $(this).find('.accordion-arrow-icon').toggleClass('accordion-arrow-down accordion-arrow-up');
        $(this).next('.accordion-body').slideToggle();
      });

      if (response.store_credit_response.error == false) {
        accordionBody.append(
          '<p>Thank you for choosing to keep the items. We have sent you an email with the Gift Voucher worth £' +
            response.store_credit_response.total_amount +
            '</p>'
        );
        accordionBody.append(
          '<p>Requested Date : ' + formatDate(response.store_credit_response.requested_date) + ' </p>'
        );
      } else {
        accordionBody.append(
          '<p>We are sorry to inform you that the Gift Card worth £' +
            response.store_credit_response.total_amount +
            ' could not be processed. Please reach out to our support team at </p>'
        );
        accordionBody.append(
          '<p><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>'
        );
        accordionBody.append('<p>We’re here to help!</p>');
      }

      accordionBody.append('<p>You have selected the following items for store credit:</p>');
      accordionBody.append('<ul class="sku-list">');

      // Create SKU list
      let skuList = $('<ul class="sku-list"></ul>');
      response.store_credit_response.items.forEach(function (item) {
        let skuItem = $('<li></li>');
        skuItem.html(item.sku + '(Qty: ' + item.quantity + ')');
        skuList.append(skuItem);
      });
      accordionBody.append(skuList);

      // Append header and body to accordion item
      accordionItem.append(accordionHeader);
      accordionItem.append(accordionBody);

      // Append each accordion item to container
      accordionContainer.append(accordionItem);
    }

    // Refund Summary
    if (response.refund_response && response.refund_response.items && response.refund_response.items.length > 0) {
      // Create accordion item
      let accordionItem = $('<div class="accordion-item"></div>');

      // Create accordion header
      let accordionHeader = $('<div class="accordion-header"></div>');
      accordionHeader.html('<span class="accordion-arrow-icon accordion-arrow-down">&nbsp;</span> Refund Summary');
      let accordionBody = $('<div class="accordion-body"></div>');

      // Add click event to toggle accordion body
      accordionHeader.click(function () {
        // Toggle arrow direction
        $(this).find('.accordion-arrow-icon').toggleClass('accordion-arrow-down accordion-arrow-up');
        $(this).next('.accordion-body').slideToggle();
      });

      if (response.refund_response.error == false) {
        accordionBody.append(
          '<p>We are pleased to inform you that a refund of £' +
            response.refund_response.total_amount +
            ' has been Successfully processed to your original payment method.</p>'
        );
        accordionBody.append('<p>Requested Date : ' + formatDate(response.refund_response.requested_date) + ' </p>');
      } else {
        accordionBody.append(
          '<p>We are sorry to inform you that a refund of £' +
            response.refund_response.total_amount +
            ' could not be processed. Please reach out to our support team at </p>'
        );
        accordionBody.append(
          '<p><a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></p>'
        );
        accordionBody.append('<p>We’re here to help!</p>');
      }

      accordionBody.append(
        '<p>You have selected the following item(s) for refund while keeping the item so you do not need to return the item(s):</p>'
      );
      accordionBody.append('<ul class="sku-list">');

      // Create SKU list
      let skuList = $('<ul class="sku-list"></ul>');
      response.refund_response.items.forEach(function (item) {
        let skuItem = $('<li></li>');
        skuItem.html(item.sku + '(Qty: ' + item.quantity + ')');
        skuList.append(skuItem);
      });
      accordionBody.append(skuList);

      // Append header and body to accordion item
      accordionItem.append(accordionHeader);
      accordionItem.append(accordionBody);

      // Append each accordion item to container
      accordionContainer.append(accordionItem);
    }

    jQuery('#PaymentPopup .close-button').attr('data-reload-search', 'yes');
    jQuery('#PaymentPopup').show();
  }

  function getLabelUrlByBrandAndItemId(brandId, lineItemId, result) {
    let brandData = result.items.find((brand) => brand.brand_id === brandId);
    if (!brandData) return 'Brand not found';

    let itemData = brandData.items.find((item) => item.id === lineItemId);
    if (!itemData) return 'Line item not found';

    if (
      !(itemData.return_tracking && itemData.return_tracking.label_url && itemData.return_tracking.label_url != null)
    ) {
      return 'Label URL not found';
    }
    return itemData.return_tracking.label_url;
  }

  function getQRCodeUrlByBrandAndItemId(brandId, lineItemId, result) {
    let brandData = result.items.find((brand) => brand.brand_id === brandId);
    if (!brandData) return 'Brand not found';

    let itemData = brandData.items.find((item) => item.id === lineItemId);
    if (!itemData) return 'Line item not found';

    if (
      !(itemData.return_tracking && itemData.return_tracking.qrcode_url && itemData.return_tracking.qrcode_url != null)
    ) {
      return 'QR Code URL not found';
    }
    return itemData.return_tracking.qrcode_url;
  }

  var allIntervals = [];
  function checkForPayment(self, url) {
    var returnRequestId = self.data('return-request-id');
    var $email = $('.email').val();
    var $phone = $('.phone_number').val();
    var $postalcode = $('.postalcode').val();
    var $orderId = $('.orderId').val();
    var $tabData = $('#tabData').val();
    var $selectedMarketplace = $('#marketplaces').val();

    if (returnRequestId) {
      let channelID = 'retrun-request.' + returnRequestId;
      let channel = pusher.subscribe(channelID);
      channel.bind('return-label-payment-event', function (data) {
        if (data && data.status == 'paid') {
          pusher.unsubscribe(channelID);
          var attr = self.attr('data-payment-status');

          if (typeof attr == 'undefined' || attr == false || attr == 'pending') {
            self.attr('data-payment-status', 'paid');

            $('#search_type').val(selectOption);
            let searchType = '';
            let searchValue = '';
            // determine search type based on selected option
            if (selectOption == 'phone') {
                searchType = 'phone_number';
                searchValue = $phone;
            } else if (selectOption == 'email') {
                searchType = 'email';
                searchValue = $email;
            } else {
                // postal code search
                searchType = 'postal_code';
                searchValue = $postalcode;
            }

            $.ajax({
              type: 'POST',
              url: baseEndpointUrl + '/v1/api/return/order-items',
              data: {
                marketplace_id: $selectedMarketplace,
                order_id: $orderId,
                search_type: searchType,
                search_value: searchValue,
                type: $tabData,
              },
              success: function (data) {

                // for redirection GD-2225 start
                let shippingCode = data.shipping_country_code;

                if (restrictedCountries.includes(shippingCode)) {
                  classResrtict= 'pending-restrict-hide'
                }
                // for redirection GD-2225 ends

                if (
                  data.requested &&
                  data.requested.return &&
                  data.requested.return.return_label &&
                  data.requested.return.return_label.complete_label &&
                  data.requested.return.return_label.complete_label.length > 0
                ) {
                  let completedLabelsList = data.requested.return.return_label.complete_label.find(
                    (item) => item.return_request_id == returnRequestId
                  );
                  console.log('completedLabelsList', completedLabelsList);
                  if (completedLabelsList && completedLabelsList.invoice_url == null) {
                    self.html('Payment Completed').addClass('success');
                    self.parents('.popup-content').find('.close-button').attr('data-reload-search', 'yes');
                    console.log('groupedData', groupedData);
                    if (groupedData && Array.isArray(groupedData)) {
                      groupedData.forEach((brand) => {
                        let line_item_id = brand.items[0].line_item_id;
                        const labelUrl = getLabelUrlByBrandAndItemId(brand.brand_id, line_item_id, completedLabelsList);
                        const qrCodeURL = getQRCodeUrlByBrandAndItemId(
                          brand.brand_id,
                          line_item_id,
                          completedLabelsList
                        );

                        // for redirection GD-2225 start
                        let brandHeader = $(`#payment-content-wrapper h4[data-brand-id="${brand.brand_id}"]`);

                        if (restrictedCountries.includes(shippingCode)) {
                            console.log("Restricted country detected:", shippingCode);
                            brandHeader.append(`
                                <p class="redirect-msg">
                                    Now please go to this URL <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank">https://www.omniparcelreturns.com/bookreturn/booking_return/307</a> and generate your return label. Thanks
                                </p>
                            `);

                            return; // skip adding download links
                        }
                        // for redirection GD-2225 ends


                        //console.log('labelUrl', labelUrl);
                        if (
                          labelUrl != 'Brand not found' &&
                          labelUrl != 'Line item not found' &&
                          labelUrl != 'Label URL not found' &&
                          labelUrl != 'error'
                        ) {
                          $('#payment-content-wrapper h4[data-brand-id=' + brand.brand_id + ']').append(
                            `<span>
                                        <a href="` +
                              labelUrl +
                              `" target="_blank" class="btn-refund-option">Download Return Label</a>
                                        <a href="` +
                              qrCodeURL +
                              `" target="_blank" class="btn-refund-option">Download QR Code</a>  
                                        </span>`
                          );
                        } else {
                          $('#payment-content-wrapper h4[data-brand-id=' + brand.brand_id + ']').after(
                            `<span class="error">Some error occured. Please reach out to our support team at <a style="padding: 0;color: #ff8080;" href="mailto:info@goddiva.co.uk">info@goddiva.co.uk</a></span>`
                          );
                        }
                      });
                    }
                    $('.accordion-body').append(`
                              <p class="`+classResrtict+`">Thank you for completing payment! The return label and return instructions have been sent to your inbox, remember to double check your spam/junk folders.</p>
                              <p class="`+classResrtict+`">The label will also be re-downloadable through our returns portal</p>
                            `);
                  }
                }
              },
              error: function (xhr, status, error) {
                alert('Some error occured while checking payment status.');
                console.error('Error during AJAX request:', status, error);
                self
                  .attr('href', url)
                  .attr('target', '_blank')
                  .attr('rel', 'noopener noreferrer')
                  .removeClass('disabled')
                  .removeClass('success')
                  .html('Pay Now');
              },
            });
          }
        }
      });
    }
  }

  function showReturnFeePopup() {
    var data = allData;

    // for redirection GD-2225 start
    let shippingCode = data.shipping_country_code;
    // for redirection GD-2225 ends

    if (
      data.requested &&
      data.requested.return &&
      data.requested.return.return_label &&
      data.requested.return.return_label.pending_label &&
      data.requested.return.return_label.pending_label.length > 0
    ) {
      let pendingReturnFeeHtml = '';
      var accordionContainer = $('#payment-content-wrapper');
      accordionContainer.html('');
      accordionContainer.append('<h3>Return Fee Pending</h3>');
      accordionContainer.append(
        '<p>You previously selected the Return Label option for some items but have not yet paid the associated fees. Below are the pending return label charges. Once the payment is completed, you will be able to download the return label.</p>'
      );
      let flatPendingLabelList = data.requested.return.return_label.pending_label;
      flatPendingLabelList.forEach(function (label, index) {
        let hasMatchingRecord =
          label.return_request_status_id == 5 &&
          label.return_request_item_status_id == 4 &&
          label.return_request_financial_status == null &&
          label.is_return_fee == 1;
        if (!hasMatchingRecord) {
          var invoiceNumber = index + 1;
          var accordionItem = $('<div class="accordion-item"></div>');
          var accordionHeader = $('<div class="accordion-header"></div>');
          accordionHeader.html(
            '<span class="accordion-arrow-icon accordion-arrow-down">&nbsp;</span> Return Fee #' + invoiceNumber
          );
          var payNowButton = $(
            '<a class="pay-now-button" rel="noopener noreferrer" data-return-request-id="' +
              label.return_request_id +
              '" target="_blank" data-index="' +
              index +
              '">Pay Now</a>'
          );
          payNowButton.attr('href', label.invoice_url);
          accordionHeader.append(payNowButton);
          accordionHeader.click(function () {
            $(this).find('.accordion-arrow-icon').toggleClass('accordion-arrow-down accordion-arrow-up');
            $(this).next('.accordion-body').slideToggle();
          });

          if (restrictedCountries.includes(shippingCode)) {
            classResrtict= 'pending-restrict-hide'
          }

          var accordionBody = $(
            '<div class="accordion-body"><p class="'+classResrtict+'">You have selected the following items for return. A return fee of £' +
              data.return_fee +
              ' is required before you can download the return label.</p></div>'
          );

          // for redirection GD-2225 start
         if (restrictedCountries.includes(shippingCode)) {
                accordionBody.append(`
                    <p class="redirect-msg pending-restrict" style="display:none;">
                        Now please go to this URL 
                        <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" 
                          target="_blank" rel="noopener noreferrer">
                          https://www.omniparcelreturns.com/bookreturn/booking_return/307
                        </a> 
                        and generate your return label. Thanks.
                    </p>
                `);
          }else{
              if (label.error_code !== 0) {
                var errorMessage = $(
                  '<div class="error-message">Some error occurred. Error Code: ' + label.error_code + '</div>'
                );
                accordionBody.append(errorMessage);
              }
          }

          accordionBody.append(
            '<p class="'+classResrtict+'">Once this return fee is paid, you can download the return label for the following items:</p>'
          );
          label.items.forEach(function (sellerwiseItem) {
            var sellerBrand = $('<h4></h4>').text(sellerwiseItem.brand);
            var skuList = $('<ul class="sku-list"></ul>');

            sellerwiseItem.items.forEach(function (item) {
              var skuItem = $('<li></li>').text(item.sku);
              skuList.append(skuItem);
            });
            accordionBody.append(sellerBrand).append(skuList);
          });
          accordionItem.append(accordionHeader);
          accordionItem.append(accordionBody);
          accordionContainer.append(accordionItem);
        }
      });
      jQuery('#PaymentPopup').show();
    }
  }
  /* ----------------------------------------------------------------------
   * URL prefill + auto-search
   * Lets another page (e.g. the EU Right of Withdrawal page for an already
   * dispatched order) deep-link into the returns portal with the search
   * pre-filled and run automatically — exactly as if the user clicked Search.
   *
   * Supported query params:
   *   marketplace   marketplace id for the "Where did you place the order?" select (optional)
   *   search_type   phone | email | postalcode  (optional; inferred from the value param below)
   *   phone         last 4 digits of mobile        }
   *   email         email address                  }  provide the one matching search_type
   *   postalcode    postal code                    }
   *   order_id      Order ID / Marketplace Order ID
   *   type          return | exchange | alteration (optional, defaults to the page default)
   *
   * Runs only when an order_id + a search value are present AND there is no
   * customer_id (that param drives the existing logged-in account flow).
   * -------------------------------------------------------------------- */
  (function prefillAndSearchFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_id')) return; // leave the existing account flow untouched

    var orderId = params.get('order_id');
    var type = params.get('type'); // return | exchange | alteration

    var phone = params.get('phone') || params.get('phone_number');
    var email = params.get('email');
    var postalcode = params.get('postalcode') || params.get('postal_code');

    // Resolve search-by type: explicit param, else infer from which value is supplied.
    var st = params.get('search_type');
    var value = params.get('search_value');
    if (!st) {
      if (email) st = 'email';
      else if (postalcode) st = 'postalcode';
      else if (phone) st = 'phone';
    }
    if (!value) {
      if (st === 'email') value = email;
      else if (st === 'postalcode') value = postalcode;
      else if (st === 'phone') value = phone;
    }

    if (!st || !value || !orderId) return; // not enough to auto-search

    var marketplace = params.get('marketplace');

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var $mp = jQuery('#marketplaces');
      // Wait until the marketplace options have loaded (they fetch async).
      if ($mp.find('option').length > 0 || attempts > 50) {
        clearInterval(timer);

        if (marketplace) { $mp.val(marketplace).trigger('change'); }

        jQuery('#search_type').val(st).trigger('change');

        if (st === 'phone') jQuery('.phone_number').val(value);
        else if (st === 'email') jQuery('.email').val(value);
        else if (st === 'postalcode') jQuery('.postalcode').val(value);

        jQuery('.orderId').val(orderId);

        if (type) { jQuery('#tabData').val(type); }

        // Fire the same search the Search button triggers.
        setTimeout(function () { jQuery('#search-btn').click(); }, 350);
      }
    }, 100);
  })();
